
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("akCIa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7859cce744f55b34$var$_react = $7859cce744f55b34$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7859cce744f55b34$var$_statusError = $7859cce744f55b34$var$_interopRequireDefault((parcelRequire("ep4XT")));

var $7859cce744f55b34$var$_error = $7859cce744f55b34$var$_interopRequireDefault((parcelRequire("e0UAf")));
function $7859cce744f55b34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7859cce744f55b34$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $7859cce744f55b34$var$_react.default.createElement($7859cce744f55b34$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $7859cce744f55b34$var$_error.default
    }, props));
$7859cce744f55b34$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $7859cce744f55b34$var$_default = module.exports.default = $7859cce744f55b34$var$StatusErrorIcon;

});
parcelRegister("ep4XT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7c740718f16c580$var$_react = $a7c740718f16c580$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a7c740718f16c580$var$_baseNew = $a7c740718f16c580$var$_interopRequireDefault((parcelRequire("a2kLY")));
function $a7c740718f16c580$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7c740718f16c580$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $a7c740718f16c580$var$_react.default.createElement($a7c740718f16c580$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$a7c740718f16c580$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $a7c740718f16c580$var$_default = module.exports.default = $a7c740718f16c580$var$StatusErrorIcon;

});
parcelRegister("a2kLY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("kGE6o")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("kGE6o")).Icon);

var $kGE6o = parcelRequire("kGE6o");

});
parcelRegister("kGE6o", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $432fef2a19c06916$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $432fef2a19c06916$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $91hOG = parcelRequire("91hOG");
const $432fef2a19c06916$var$svgStyles = null;
const $432fef2a19c06916$var$iconStyles = null;
const $432fef2a19c06916$var$smallIconStyles = null;
const $432fef2a19c06916$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $432fef2a19c06916$var$baseHcmStyles = null;
const $432fef2a19c06916$var$scaleSize = null;
const $432fef2a19c06916$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $432fef2a19c06916$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $432fef2a19c06916$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $432fef2a19c06916$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, LEGACY_primaryColor: LEGACY_primaryColor, LEGACY_secondaryColor: LEGACY_secondaryColor, LEGACY_size: LEGACY_size, LEGACY_fallbackIcon: FallbackIcon, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, LEGACY_margin: LEGACY_margin, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $91hOG.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ (0, $gt9Am.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor ?? color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        // @ts-ignore -next-line
        UNSAFE_margin: LEGACY_margin
    });
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $432fef2a19c06916$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $hcewu.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va18uv _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $hcewu.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $432fef2a19c06916$var$coreSizeSmall[spacing] : $432fef2a19c06916$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var $432fef2a19c06916$export$2e2bcd8739ae039 = $432fef2a19c06916$export$f04a61298a47a40f;

});



parcelRegister("e0UAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a33cf5170526668c$var$_react = $a33cf5170526668c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $jJt6S = parcelRequire("jJt6S");
function $a33cf5170526668c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a33cf5170526668c$var$ErrorIcon = (props)=>/*#__PURE__*/ $a33cf5170526668c$var$_react.default.createElement($jJt6S.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$a33cf5170526668c$var$ErrorIcon.displayName = 'ErrorIcon';
var $a33cf5170526668c$var$_default = module.exports.default = $a33cf5170526668c$var$ErrorIcon;

});
parcelRegister("jJt6S", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $f4ea77db80b935b6$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $f4ea77db80b935b6$export$2e2bcd8739ae039);
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f4ea77db80b935b6$var$iconStyles = null;
const $f4ea77db80b935b6$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ const $f4ea77db80b935b6$var$baseHcmStyles = null;
const $f4ea77db80b935b6$var$primaryEqualsSecondaryHcmStyles = null;
const $f4ea77db80b935b6$var$secondaryTransparentHcmStyles = null;
const $f4ea77db80b935b6$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $gt9Am.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi3acm",
            size && $f4ea77db80b935b6$var$sizeStyles[size]
        ])
    });
});
var $f4ea77db80b935b6$export$2e2bcd8739ae039 = $f4ea77db80b935b6$export$f04a61298a47a40f;

});



parcelRegister("4ww3C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34b3047d79dbb02b$var$_react = $34b3047d79dbb02b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $jJt6S = parcelRequire("jJt6S");
function $34b3047d79dbb02b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $34b3047d79dbb02b$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $34b3047d79dbb02b$var$_react.default.createElement($jJt6S.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$34b3047d79dbb02b$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $34b3047d79dbb02b$var$_default = module.exports.default = $34b3047d79dbb02b$var$CheckCircleIcon;

});

parcelRegister("k0vvr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e90c3f2c24f9daa0$var$_react = $e90c3f2c24f9daa0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $jJt6S = parcelRequire("jJt6S");
function $e90c3f2c24f9daa0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e90c3f2c24f9daa0$var$CrossIcon = (props)=>/*#__PURE__*/ $e90c3f2c24f9daa0$var$_react.default.createElement($jJt6S.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$e90c3f2c24f9daa0$var$CrossIcon.displayName = 'CrossIcon';
var $e90c3f2c24f9daa0$var$_default = module.exports.default = $e90c3f2c24f9daa0$var$CrossIcon;

});

parcelRegister("hRkxL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0075271576b0938$var$_react = $d0075271576b0938$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $jJt6S = parcelRequire("jJt6S");
function $d0075271576b0938$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d0075271576b0938$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $d0075271576b0938$var$_react.default.createElement($jJt6S.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props));
$d0075271576b0938$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $d0075271576b0938$var$_default = module.exports.default = $d0075271576b0938$var$HipchatChevronDownIcon;

});

parcelRegister("7wetD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5796c067611fad87$var$_react = $5796c067611fad87$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $jJt6S = parcelRequire("jJt6S");
function $5796c067611fad87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5796c067611fad87$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $5796c067611fad87$var$_react.default.createElement($jJt6S.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props));
$5796c067611fad87$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $5796c067611fad87$var$_default = module.exports.default = $5796c067611fad87$var$HipchatChevronUpIcon;

});

parcelRegister("8p6eU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61e57f89a8aecb9d$var$_react = $61e57f89a8aecb9d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $jJt6S = parcelRequire("jJt6S");
function $61e57f89a8aecb9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $61e57f89a8aecb9d$var$InfoIcon = (props)=>/*#__PURE__*/ $61e57f89a8aecb9d$var$_react.default.createElement($jJt6S.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$61e57f89a8aecb9d$var$InfoIcon.displayName = 'InfoIcon';
var $61e57f89a8aecb9d$var$_default = module.exports.default = $61e57f89a8aecb9d$var$InfoIcon;

});

parcelRegister("adB4R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7707e118c513a138$var$_react = $7707e118c513a138$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $jJt6S = parcelRequire("jJt6S");
function $7707e118c513a138$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7707e118c513a138$var$WarningIcon = (props)=>/*#__PURE__*/ $7707e118c513a138$var$_react.default.createElement($jJt6S.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$7707e118c513a138$var$WarningIcon.displayName = 'WarningIcon';
var $7707e118c513a138$var$_default = module.exports.default = $7707e118c513a138$var$WarningIcon;

});

parcelRegister("eIpuh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab68f20795a1241b$var$_react = $ab68f20795a1241b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ab68f20795a1241b$var$_statusSuccess = $ab68f20795a1241b$var$_interopRequireDefault((parcelRequire("e5hTG")));

var $ab68f20795a1241b$var$_checkCircle = $ab68f20795a1241b$var$_interopRequireDefault((parcelRequire("4ww3C")));
function $ab68f20795a1241b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab68f20795a1241b$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $ab68f20795a1241b$var$_react.default.createElement($ab68f20795a1241b$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $ab68f20795a1241b$var$_checkCircle.default
    }, props));
$ab68f20795a1241b$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $ab68f20795a1241b$var$_default = module.exports.default = $ab68f20795a1241b$var$StatusSuccessIcon;

});
parcelRegister("e5hTG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a40f6a4d18039f5c$var$_react = $a40f6a4d18039f5c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a40f6a4d18039f5c$var$_baseNew = $a40f6a4d18039f5c$var$_interopRequireDefault((parcelRequire("a2kLY")));
function $a40f6a4d18039f5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a40f6a4d18039f5c$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $a40f6a4d18039f5c$var$_react.default.createElement($a40f6a4d18039f5c$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$a40f6a4d18039f5c$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $a40f6a4d18039f5c$var$_default = module.exports.default = $a40f6a4d18039f5c$var$StatusSuccessIcon;

});


parcelRegister("fOPPX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::119fcb233ad7d2568bcc63888dfec4d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b843bc48c8f31f1f$var$_react = $b843bc48c8f31f1f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b843bc48c8f31f1f$var$_chevronDown = $b843bc48c8f31f1f$var$_interopRequireDefault((parcelRequire("6sLOg")));

var $b843bc48c8f31f1f$var$_chevronDown2 = $b843bc48c8f31f1f$var$_interopRequireDefault((parcelRequire("hRkxL")));
function $b843bc48c8f31f1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b843bc48c8f31f1f$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $b843bc48c8f31f1f$var$_react.default.createElement($b843bc48c8f31f1f$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $b843bc48c8f31f1f$var$_chevronDown2.default
    }, props));
$b843bc48c8f31f1f$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $b843bc48c8f31f1f$var$_default = module.exports.default = $b843bc48c8f31f1f$var$ChevronDownIcon;

});
parcelRegister("6sLOg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b4a71a3dd0f1910$var$_react = $4b4a71a3dd0f1910$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4b4a71a3dd0f1910$var$_baseNew = $4b4a71a3dd0f1910$var$_interopRequireDefault((parcelRequire("a2kLY")));
function $4b4a71a3dd0f1910$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b4a71a3dd0f1910$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $4b4a71a3dd0f1910$var$_react.default.createElement($4b4a71a3dd0f1910$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$4b4a71a3dd0f1910$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $4b4a71a3dd0f1910$var$_default = module.exports.default = $4b4a71a3dd0f1910$var$ChevronDownIcon;

});


parcelRegister("1rran", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9122dabf5a4e80a209ec2f5b7da6e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10cd62c05550096c$var$_react = $10cd62c05550096c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $10cd62c05550096c$var$_chevronUp = $10cd62c05550096c$var$_interopRequireDefault((parcelRequire("76DLo")));

var $10cd62c05550096c$var$_chevronUp2 = $10cd62c05550096c$var$_interopRequireDefault((parcelRequire("7wetD")));
function $10cd62c05550096c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10cd62c05550096c$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $10cd62c05550096c$var$_react.default.createElement($10cd62c05550096c$var$_chevronUp.default, Object.assign({
        name: "ChevronUpIcon",
        LEGACY_fallbackIcon: $10cd62c05550096c$var$_chevronUp2.default
    }, props));
$10cd62c05550096c$var$ChevronUpIcon.displayName = 'ChevronUpIconMigration';
var $10cd62c05550096c$var$_default = module.exports.default = $10cd62c05550096c$var$ChevronUpIcon;

});
parcelRegister("76DLo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52c7f025047a2786$var$_react = $52c7f025047a2786$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $52c7f025047a2786$var$_baseNew = $52c7f025047a2786$var$_interopRequireDefault((parcelRequire("a2kLY")));
function $52c7f025047a2786$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52c7f025047a2786$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $52c7f025047a2786$var$_react.default.createElement($52c7f025047a2786$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$52c7f025047a2786$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $52c7f025047a2786$var$_default = module.exports.default = $52c7f025047a2786$var$ChevronUpIcon;

});


parcelRegister("dZGdK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a301b90411b86881$var$_react = $a301b90411b86881$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a301b90411b86881$var$_statusInformation = $a301b90411b86881$var$_interopRequireDefault((parcelRequire("coyCL")));

var $a301b90411b86881$var$_info = $a301b90411b86881$var$_interopRequireDefault((parcelRequire("8p6eU")));
function $a301b90411b86881$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a301b90411b86881$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $a301b90411b86881$var$_react.default.createElement($a301b90411b86881$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $a301b90411b86881$var$_info.default
    }, props));
$a301b90411b86881$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $a301b90411b86881$var$_default = module.exports.default = $a301b90411b86881$var$StatusInformationIcon;

});
parcelRegister("coyCL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9062958e73d70182$var$_react = $9062958e73d70182$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9062958e73d70182$var$_baseNew = $9062958e73d70182$var$_interopRequireDefault((parcelRequire("a2kLY")));
function $9062958e73d70182$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9062958e73d70182$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $9062958e73d70182$var$_react.default.createElement($9062958e73d70182$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$9062958e73d70182$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $9062958e73d70182$var$_default = module.exports.default = $9062958e73d70182$var$StatusInformationIcon;

});


parcelRegister("fumm9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b46affdd1df5efb5$var$_react = $b46affdd1df5efb5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b46affdd1df5efb5$var$_statusWarning = $b46affdd1df5efb5$var$_interopRequireDefault((parcelRequire("aP45u")));

var $b46affdd1df5efb5$var$_warning = $b46affdd1df5efb5$var$_interopRequireDefault((parcelRequire("adB4R")));
function $b46affdd1df5efb5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b46affdd1df5efb5$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $b46affdd1df5efb5$var$_react.default.createElement($b46affdd1df5efb5$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $b46affdd1df5efb5$var$_warning.default
    }, props));
$b46affdd1df5efb5$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $b46affdd1df5efb5$var$_default = module.exports.default = $b46affdd1df5efb5$var$StatusWarningIcon;

});
parcelRegister("aP45u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e11d68342ca901d$var$_react = $7e11d68342ca901d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7e11d68342ca901d$var$_baseNew = $7e11d68342ca901d$var$_interopRequireDefault((parcelRequire("a2kLY")));
function $7e11d68342ca901d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e11d68342ca901d$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $7e11d68342ca901d$var$_react.default.createElement($7e11d68342ca901d$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$7e11d68342ca901d$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $7e11d68342ca901d$var$_default = module.exports.default = $7e11d68342ca901d$var$StatusWarningIcon;

});


parcelRegister("9lUef", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cf1b11158b7acdf$var$_react = $6cf1b11158b7acdf$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6cf1b11158b7acdf$var$_cross = $6cf1b11158b7acdf$var$_interopRequireDefault((parcelRequire("j9xob")));

var $6cf1b11158b7acdf$var$_cross2 = $6cf1b11158b7acdf$var$_interopRequireDefault((parcelRequire("k0vvr")));
function $6cf1b11158b7acdf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6cf1b11158b7acdf$var$CrossIcon = (props)=>/*#__PURE__*/ $6cf1b11158b7acdf$var$_react.default.createElement($6cf1b11158b7acdf$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $6cf1b11158b7acdf$var$_cross2.default
    }, props));
$6cf1b11158b7acdf$var$CrossIcon.displayName = 'CrossIconMigration';
var $6cf1b11158b7acdf$var$_default = module.exports.default = $6cf1b11158b7acdf$var$CrossIcon;

});
parcelRegister("j9xob", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df18c1f6fba956cf$var$_react = $df18c1f6fba956cf$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $df18c1f6fba956cf$var$_baseNew = $df18c1f6fba956cf$var$_interopRequireDefault((parcelRequire("a2kLY")));
function $df18c1f6fba956cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df18c1f6fba956cf$var$CrossIcon = (props)=>/*#__PURE__*/ $df18c1f6fba956cf$var$_react.default.createElement($df18c1f6fba956cf$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$df18c1f6fba956cf$var$CrossIcon.displayName = 'CrossIcon';
var $df18c1f6fba956cf$var$_default = module.exports.default = $df18c1f6fba956cf$var$CrossIcon;

});


parcelRegister("d1flD", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("fczy9")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("fczy9")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("d6Xk2")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("d6Xk2")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("4kM7C")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("4kM7C")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $c1d236d1310af702$export$70df29c238ba7306);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("5VLrq")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("5VLrq")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("hgSVe")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("hgSVe")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("4tqbJ")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => (parcelRequire("4tqbJ")).RecentWorkAnalyticsContext);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("5zOZ3")).ATLAS_CONTEXT);
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => (parcelRequire("9ZkrU")).TOWNSQUARE_HOME_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("1PrKb")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("4LSEp")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("4LSEp")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("2dC8y")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => (parcelRequire("2dC8y")).AIMateAnalyticsContext);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("iFaQf")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("dVOhw")).GROWTH_CONTEXT);
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => (parcelRequire("cqETU")).OMNI_CHANNEL_CONTEXT);
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => (parcelRequire("1AIN6")).ROVO_EXTENSION_CONTEXT);

var $fczy9 = parcelRequire("fczy9");

var $d6Xk2 = parcelRequire("d6Xk2");

var $4kM7C = parcelRequire("4kM7C");


var $5VLrq = parcelRequire("5VLrq");

var $hgSVe = parcelRequire("hgSVe");

var $4tqbJ = parcelRequire("4tqbJ");

var $5zOZ3 = parcelRequire("5zOZ3");

var $9ZkrU = parcelRequire("9ZkrU");

var $1PrKb = parcelRequire("1PrKb");

var $4LSEp = parcelRequire("4LSEp");

var $2dC8y = parcelRequire("2dC8y");

var $iFaQf = parcelRequire("iFaQf");

var $dVOhw = parcelRequire("dVOhw");

var $cqETU = parcelRequire("cqETU");

var $1AIN6 = parcelRequire("1AIN6");

});
parcelRegister("fczy9", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $352078d712052a67$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $352078d712052a67$export$3fe25500478a635c);

var $dhRkx = parcelRequire("dhRkx");
const $352078d712052a67$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $352078d712052a67$export$3fe25500478a635c = (0, $dhRkx.default)($352078d712052a67$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("dhRkx", function(module, exports) {
$parcel$export(module.exports, "default", () => $94a0371aecdaeb1b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3eWHA = parcelRequire("3eWHA");
const $94a0371aecdaeb1b$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3eWHA.default), {
            data: newData,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
var $94a0371aecdaeb1b$export$2e2bcd8739ae039 = $94a0371aecdaeb1b$var$createNamespaceContext;

});
parcelRegister("3eWHA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3951451ffa656a73$export$2e2bcd8739ae039);

var $VunYa = parcelRequire("VunYa");
var $3951451ffa656a73$export$2e2bcd8739ae039 = (0, $VunYa.default);

});
parcelRegister("VunYa", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c2cc93e3df99c49$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2UVxZ = parcelRequire("2UVxZ");

var $8se5X = parcelRequire("8se5X");

var $5YL9v = parcelRequire("5YL9v");
const $9c2cc93e3df99c49$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $5YL9v.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $8se5X.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $eJOHy.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2UVxZ.default).Provider, {
        value: value,
        children: children
    });
};
var $9c2cc93e3df99c49$export$2e2bcd8739ae039 = $9c2cc93e3df99c49$var$AnalyticsContext;

});
parcelRegister("2UVxZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $21fd7369ccaf3539$export$2e2bcd8739ae039);

var $gWekL = parcelRequire("gWekL");
var $21fd7369ccaf3539$export$2e2bcd8739ae039 = (0, $gWekL.default);

});
parcelRegister("gWekL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c54d2e8815121eda$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
var $c54d2e8815121eda$var$AnalyticsNextContext = (0, $eJOHy.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $c54d2e8815121eda$export$2e2bcd8739ae039 = $c54d2e8815121eda$var$AnalyticsNextContext;

});


parcelRegister("8se5X", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $a4e416adde750b31$export$d1f587f82ad51c4);

var $eJOHy = parcelRequire("eJOHy");

var $2UVxZ = parcelRequire("2UVxZ");
const $a4e416adde750b31$export$d1f587f82ad51c4 = ()=>{
    return (0, $eJOHy.useContext)((0, $2UVxZ.default));
};

});

parcelRegister("5YL9v", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $3bc2b83ab182b252$export$1d27a74659855e44);

var $eJOHy = parcelRequire("eJOHy");
const $3bc2b83ab182b252$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
};

});





parcelRegister("d6Xk2", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $7591d3bea14c85c2$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $7591d3bea14c85c2$export$d0a82da1a0b94929);

var $dhRkx = parcelRequire("dhRkx");
const $7591d3bea14c85c2$export$1fd3aad76a7c6788 = 'navigationCtx';
const $7591d3bea14c85c2$export$d0a82da1a0b94929 = (0, $dhRkx.default)($7591d3bea14c85c2$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("4kM7C", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $184c7f5914335f63$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $184c7f5914335f63$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $184c7f5914335f63$export$629cada6c5e621e1);

var $dhRkx = parcelRequire("dhRkx");
const $184c7f5914335f63$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $184c7f5914335f63$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $184c7f5914335f63$export$629cada6c5e621e1 = (0, $dhRkx.default)($184c7f5914335f63$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c1d236d1310af702$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

parcelRegister("5VLrq", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $b7240e58f3324fe3$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $b7240e58f3324fe3$export$4119ddb38ccbfb87);

var $dhRkx = parcelRequire("dhRkx");
const $b7240e58f3324fe3$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $b7240e58f3324fe3$export$4119ddb38ccbfb87 = (0, $dhRkx.default)($b7240e58f3324fe3$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("hgSVe", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $d5e2a58a5ad9ee79$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $d5e2a58a5ad9ee79$export$6f8e7ff1e3feafd7);

var $dhRkx = parcelRequire("dhRkx");
const $d5e2a58a5ad9ee79$export$da1befb791e93c7e = 'NotificationsCtx';
const $d5e2a58a5ad9ee79$export$6f8e7ff1e3feafd7 = (0, $dhRkx.default)($d5e2a58a5ad9ee79$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("4tqbJ", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $24cb28004a95685b$export$fc7a65795610cb71);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => $24cb28004a95685b$export$745926731087ebe2);

var $dhRkx = parcelRequire("dhRkx");
const $24cb28004a95685b$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $24cb28004a95685b$export$745926731087ebe2 = (0, $dhRkx.default)($24cb28004a95685b$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("5zOZ3", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $e8cde6cd12bbef4f$export$4906017439f33fc0);

var $dhRkx = parcelRequire("dhRkx");
const $e8cde6cd12bbef4f$export$4906017439f33fc0 = 'atlasCtx';
const $e8cde6cd12bbef4f$export$43ebbe41370d4543 = (0, $dhRkx.default)($e8cde6cd12bbef4f$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("9ZkrU", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $2a63285e9438ca42$export$aa18ab4fff926c9e);

var $dhRkx = parcelRequire("dhRkx");
const $2a63285e9438ca42$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $2a63285e9438ca42$export$d283110f5d85c8f2 = (0, $dhRkx.default)($2a63285e9438ca42$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});

parcelRegister("1PrKb", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $e63599c96a9af329$export$3240443bf2b83834);

var $dhRkx = parcelRequire("dhRkx");
const $e63599c96a9af329$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $e63599c96a9af329$export$6d568da622ce0a08 = (0, $dhRkx.default)($e63599c96a9af329$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("4LSEp", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $a55124a6cf50beea$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $a55124a6cf50beea$export$dcd232f3be312f94);

var $dhRkx = parcelRequire("dhRkx");
const $a55124a6cf50beea$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $a55124a6cf50beea$export$dcd232f3be312f94 = (0, $dhRkx.default)($a55124a6cf50beea$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("2dC8y", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $d97f895588a8e769$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $d97f895588a8e769$export$de3826c30468da26);

var $dhRkx = parcelRequire("dhRkx");
const $d97f895588a8e769$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $d97f895588a8e769$export$de3826c30468da26 = (0, $dhRkx.default)($d97f895588a8e769$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("iFaQf", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $3c4740fd8672df02$export$c2a811a4e42f4af5);

var $dhRkx = parcelRequire("dhRkx");
const $3c4740fd8672df02$export$c2a811a4e42f4af5 = 'avpCtx';
const $3c4740fd8672df02$export$da383e8879a25b03 = (0, $dhRkx.default)($3c4740fd8672df02$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("dVOhw", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $17fb38b87d132d81$export$82023f2f4bfb06c1);

var $dhRkx = parcelRequire("dhRkx");
const $17fb38b87d132d81$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $17fb38b87d132d81$export$84980182680018f = (0, $dhRkx.default)($17fb38b87d132d81$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});

parcelRegister("cqETU", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $2f0afa2efabe4e31$export$6d3c48fd1b3e4f3b);

var $dhRkx = parcelRequire("dhRkx");
const $2f0afa2efabe4e31$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $2f0afa2efabe4e31$export$e4e6df99270bbbb1 = (0, $dhRkx.default)($2f0afa2efabe4e31$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});

parcelRegister("1AIN6", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $68a807e66ec28a21$export$fae437eb1dd9520c);

var $dhRkx = parcelRequire("dhRkx");
const $68a807e66ec28a21$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $68a807e66ec28a21$export$7fcecc25ee38fbef = (0, $dhRkx.default)($68a807e66ec28a21$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});


parcelRegister("gQP3k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("7HqbB")).default);
$parcel$export(module.exports, "LOG_LEVEL", () => (parcelRequire("5lYHp")).LOG_LEVEL);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("gAyKX")).FabricChannel);

var $7HqbB = parcelRequire("7HqbB");

var $5lYHp = parcelRequire("5lYHp");

var $gAyKX = parcelRequire("gAyKX");

});
parcelRegister("7HqbB", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d7221753427211e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $47UNW = parcelRequire("47UNW");

var $jYBz5 = parcelRequire("jYBz5");

var $5lYHp = parcelRequire("5lYHp");

var $8GDHc = parcelRequire("8GDHc");

var $6y9b0 = parcelRequire("6y9b0");

var $7cL49 = parcelRequire("7cL49");

var $eK5Tt = parcelRequire("eK5Tt");

var $dnvMA = parcelRequire("dnvMA");

var $bnzdl = parcelRequire("bnzdl");

var $k9evp = parcelRequire("k9evp");

var $h4HRZ = parcelRequire("h4HRZ");

var $e6pxd = parcelRequire("e6pxd");

var $brhln = parcelRequire("brhln");

var $9e0W4 = parcelRequire("9e0W4");

var $96m9I = parcelRequire("96m9I");

var $l78eq = parcelRequire("l78eq");

var $bMlHd = parcelRequire("bMlHd");

var $hxMOg = parcelRequire("hxMOg");

var $amJVK = parcelRequire("amJVK");
const $9d7221753427211e$var$listenerMap = {
    [(0, $gAyKX.FabricChannel).elements]: (0, $47UNW.default),
    [(0, $gAyKX.FabricChannel).editor]: (0, $6y9b0.default),
    [(0, $gAyKX.FabricChannel).atlaskit]: (0, $jYBz5.default),
    [(0, $gAyKX.FabricChannel).navigation]: (0, $8GDHc.default),
    [(0, $gAyKX.FabricChannel).media]: (0, $7cL49.default),
    [(0, $gAyKX.FabricChannel).peopleTeams]: (0, $eK5Tt.default),
    [(0, $gAyKX.FabricChannel).notifications]: (0, $dnvMA.default),
    [(0, $gAyKX.FabricChannel).recentWork]: (0, $bnzdl.default),
    [(0, $gAyKX.FabricChannel).atlas]: (0, $k9evp.default),
    [(0, $gAyKX.FabricChannel).crossFlow]: (0, $h4HRZ.default),
    [(0, $gAyKX.FabricChannel).linkingPlatform]: (0, $e6pxd.default),
    [(0, $gAyKX.FabricChannel).postOffice]: (0, $brhln.default),
    [(0, $gAyKX.FabricChannel).aiMate]: (0, $9e0W4.default),
    [(0, $gAyKX.FabricChannel).avp]: (0, $96m9I.default),
    [(0, $gAyKX.FabricChannel).growth]: (0, $l78eq.default),
    [(0, $gAyKX.FabricChannel).omniChannel]: (0, $bMlHd.default),
    [(0, $gAyKX.FabricChannel).townsquareHome]: (0, $hxMOg.default),
    [(0, $gAyKX.FabricChannel).rovoExtension]: (0, $amJVK.default)
};
class $9d7221753427211e$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $5lYHp.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($9d7221753427211e$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$9d7221753427211e$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Listener, {
                client: client,
                logger: this.logger,
                children: prev
            }), children);
        return listeners;
    }
}
var $9d7221753427211e$export$2e2bcd8739ae039 = $9d7221753427211e$var$FabricAnalyticsListeners;

});
parcelRegister("gAyKX", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $6ee690684cb877fb$export$8faa0b115ef0268b);
var $6ee690684cb877fb$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    return FabricChannel;
}({});

});

parcelRegister("47UNW", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_TAG", () => $86098bcb30d832ab$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $86098bcb30d832ab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lbs30 = parcelRequire("lbs30");

var $gAyKX = parcelRequire("gAyKX");

var $cMb5p = parcelRequire("cMb5p");
const $86098bcb30d832ab$export$ed71ae78997933a = 'fabricElements';
class $86098bcb30d832ab$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lbs30.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $gAyKX.FabricChannel).elements,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $cMb5p.handleEvent)(event, $86098bcb30d832ab$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("lbs30", function(module, exports) {
$parcel$export(module.exports, "default", () => $d534bd69bd6710ef$export$2e2bcd8739ae039);

var $cfizD = parcelRequire("cfizD");
var $d534bd69bd6710ef$export$2e2bcd8739ae039 = (0, $cfizD.default);

});
parcelRegister("cfizD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f0c9b165535e477$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2UVxZ = parcelRequire("2UVxZ");

var $8se5X = parcelRequire("8se5X");

var $5YL9v = parcelRequire("5YL9v");
const $7f0c9b165535e477$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $8se5X.useAnalyticsContext)();
    const onEventRef = (0, $5YL9v.useTrackedRef)(onEvent);
    const channelRef = (0, $5YL9v.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $eJOHy.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2UVxZ.default).Provider, {
        value: value,
        children: children
    });
};
var $7f0c9b165535e477$export$2e2bcd8739ae039 = $7f0c9b165535e477$var$AnalyticsListener;

});


parcelRegister("cMb5p", function(module, exports) {
$parcel$export(module.exports, "handleEvent", () => $d58884540c6b6f77$export$d6e5ca10785815df);

var $f7qoV = parcelRequire("f7qoV");

var $6KqIu = parcelRequire("6KqIu");
const $d58884540c6b6f77$export$d6e5ca10785815df = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $6KqIu.processEventPayload)(event, tags);
    (0, $f7qoV.sendEvent)(logger, client)(payload);
};

});
parcelRegister("f7qoV", function(module, exports) {
$parcel$export(module.exports, "sendEvent", () => $06d0aba120c35cee$export$7329bcdc3edcd90e);
const $06d0aba120c35cee$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $06d0aba120c35cee$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($06d0aba120c35cee$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("6KqIu", function(module, exports) {
$parcel$export(module.exports, "processEventPayload", () => $5f98a46f3cb1c6be$export$c37d638b7f2ca192);

parcelRequire("d1flD");
var $4kM7C = parcelRequire("4kM7C");
var $fczy9 = parcelRequire("fczy9");

var $1O6Yz = parcelRequire("1O6Yz");

var $47UNW = parcelRequire("47UNW");

var $6y9b0 = parcelRequire("6y9b0");
const $5f98a46f3cb1c6be$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, item), {});
const $5f98a46f3cb1c6be$var$fieldExtractor = (contextKey)=>$5f98a46f3cb1c6be$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $5f98a46f3cb1c6be$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $47UNW.ELEMENTS_TAG:
            return 0, $fczy9.ELEMENTS_CONTEXT;
        case 0, $6y9b0.EDITOR_TAG:
            return 0, $4kM7C.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $5f98a46f3cb1c6be$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $c336a4a8eee57272$export$b055de0e665cb20c),
        ...event.payload
    };
    const contextKey = $5f98a46f3cb1c6be$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $5f98a46f3cb1c6be$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $c336a4a8eee57272$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $5f98a46f3cb1c6be$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $5f98a46f3cb1c6be$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $5f98a46f3cb1c6be$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $5f98a46f3cb1c6be$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$5f98a46f3cb1c6be$var$updatePayloadWithContext(primaryTag, event),
        tags: $5f98a46f3cb1c6be$var$addTags(tagsArray, event.payload.tags)
    };
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $c336a4a8eee57272$export$a1562d08625f5d7e = 'ui';
const $c336a4a8eee57272$export$947dac6c72b26f81 = 'track';
const $c336a4a8eee57272$export$f1d537d508d2945a = 'screen';
const $c336a4a8eee57272$export$12346a674644c156 = 'operational';
const $c336a4a8eee57272$export$b055de0e665cb20c = 'unknown';

parcelRegister("6y9b0", function(module, exports) {
$parcel$export(module.exports, "EDITOR_TAG", () => $64ec40e4bba72b84$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $64ec40e4bba72b84$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lbs30 = parcelRequire("lbs30");

var $gAyKX = parcelRequire("gAyKX");

var $cMb5p = parcelRequire("cMb5p");
const $64ec40e4bba72b84$export$a1d9dc589a29b3aa = 'editor';
const $64ec40e4bba72b84$export$8aa0d788f94a809 = 'fabricEditor';
class $64ec40e4bba72b84$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lbs30.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $gAyKX.FabricChannel).editor,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $cMb5p.handleEvent)(event, [
                $64ec40e4bba72b84$export$a1d9dc589a29b3aa,
                $64ec40e4bba72b84$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("jYBz5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cf9bad500d73a93$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $8XNOJ = parcelRequire("8XNOJ");

var $1RJF0 = parcelRequire("1RJF0");
function $5cf9bad500d73a93$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).atlaskit,
        processEvent: (0, $8XNOJ.default)
    });
}

});
parcelRegister("8XNOJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4963bcb29d39bb4c$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $4ubkc = parcelRequire("4ubkc");
const $4963bcb29d39bb4c$var$ATLASKIT_TAG = 'atlaskit';
const $4963bcb29d39bb4c$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $4963bcb29d39bb4c$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $4ubkc.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $4ubkc.getExtraAttributes)(event);
    const components = (0, $4ubkc.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $4ubkc.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $4963bcb29d39bb4c$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $4ubkc.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($4963bcb29d39bb4c$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $c336a4a8eee57272$export$a1562d08625f5d7e)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $4ubkc.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $c336a4a8eee57272$export$947dac6c72b26f81) || eventType === (0, $c336a4a8eee57272$export$12346a674644c156) || eventType === (0, $c336a4a8eee57272$export$f1d537d508d2945a)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("4ubkc", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $7f651d0ab8c1494e$export$9b947b4502cd2705);
$parcel$export(module.exports, "getActionSubject", () => $7f651d0ab8c1494e$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getSources", () => $7f651d0ab8c1494e$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $7f651d0ab8c1494e$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $7f651d0ab8c1494e$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $7f651d0ab8c1494e$export$cd17d76da7967240);
$parcel$export(module.exports, "getPackageHierarchy", () => $7f651d0ab8c1494e$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $1O6Yz = parcelRequire("1O6Yz");
const $7f651d0ab8c1494e$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const $7f651d0ab8c1494e$export$6f40cdf6d42c018d = (event)=>{
    const overrides = $7f651d0ab8c1494e$export$9b947b4502cd2705('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const $7f651d0ab8c1494e$export$5f9bc633b116660f = (event)=>$7f651d0ab8c1494e$export$9b947b4502cd2705('source', event);
const $7f651d0ab8c1494e$export$4e811121b221213b = (event)=>$7f651d0ab8c1494e$export$9b947b4502cd2705('component', event);
const $7f651d0ab8c1494e$export$67c3590839ebecdd = (event)=>$7f651d0ab8c1494e$export$9b947b4502cd2705('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraAttributes), {});
const $7f651d0ab8c1494e$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $7f651d0ab8c1494e$export$18cd124b5098d330 = (event)=>$7f651d0ab8c1494e$export$9b947b4502cd2705('packageVersion', event);
function $7f651d0ab8c1494e$export$4e0b83da1896ebc7(event) {
    const packages = $7f651d0ab8c1494e$export$cd17d76da7967240(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});


parcelRegister("1RJF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $46ec9026c4bb116c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lbs30 = parcelRequire("lbs30");

var $f7qoV = parcelRequire("f7qoV");
class $46ec9026c4bb116c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lbs30.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $f7qoV.sendEvent)(logger, client)(payload);
        };
    }
}

});


parcelRegister("5lYHp", function(module, exports) {
$parcel$export(module.exports, "LOG_LEVEL", () => $3d018dddcd21d176$export$ffe0c436e29512cf);
$parcel$export(module.exports, "default", () => $3d018dddcd21d176$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $3d018dddcd21d176$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $3d018dddcd21d176$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $3d018dddcd21d176$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $3d018dddcd21d176$export$ffe0c436e29512cf.DEBUG && logLevel <= $3d018dddcd21d176$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $3d018dddcd21d176$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($3d018dddcd21d176$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($3d018dddcd21d176$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($3d018dddcd21d176$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($3d018dddcd21d176$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("8GDHc", function(module, exports) {
$parcel$export(module.exports, "default", () => $87ee9ae34e14f0a5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $l1PaV = parcelRequire("l1PaV");

var $1RJF0 = parcelRequire("1RJF0");
function $87ee9ae34e14f0a5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).navigation,
        processEvent: (0, $l1PaV.default)
    });
}

});
parcelRegister("l1PaV", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c5277c0903536a7$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("d1flD");
var $d6Xk2 = parcelRequire("d6Xk2");

var $fZH68 = parcelRequire("fZH68");
const $3c5277c0903536a7$var$NAVIGATION_TAG = 'navigation';
const $3c5277c0903536a7$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $3c5277c0903536a7$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $d6Xk2.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $d6Xk2.NAVIGATION_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $d6Xk2.NAVIGATION_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $d6Xk2.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $d6Xk2.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $3c5277c0903536a7$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($3c5277c0903536a7$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("fZH68", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $687c3ee33889ceb0$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $687c3ee33889ceb0$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $687c3ee33889ceb0$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $687c3ee33889ceb0$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ 
var $1O6Yz = parcelRequire("1O6Yz");
const $687c3ee33889ceb0$var$extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const $687c3ee33889ceb0$export$5f9bc633b116660f = (event, contextName)=>$687c3ee33889ceb0$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
const $687c3ee33889ceb0$export$4e811121b221213b = (event, contextName)=>$687c3ee33889ceb0$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const $687c3ee33889ceb0$export$67c3590839ebecdd = (event, contextName)=>$687c3ee33889ceb0$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraAttributes), {});
const $687c3ee33889ceb0$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const $687c3ee33889ceb0$export$18cd124b5098d330 = (event, contextName)=>$687c3ee33889ceb0$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);

});



parcelRegister("7cL49", function(module, exports) {
$parcel$export(module.exports, "default", () => $7135bb76674fb869$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $bLwga = parcelRequire("bLwga");

var $1RJF0 = parcelRequire("1RJF0");
function $7135bb76674fb869$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).media,
        processEvent: (0, $bLwga.processEvent)
    });
}

});
parcelRegister("bLwga", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $04a969d82f7195e3$export$22af68e3614bf024);

parcelRequire("d1flD");

var $1O6Yz = parcelRequire("1O6Yz");

var $1ilzu = parcelRequire("1ilzu");

var $4ubkc = parcelRequire("4ubkc");
const $04a969d82f7195e3$var$listenerVersion = "0.0.0-use.local";
function $04a969d82f7195e3$var$getMediaContexts(event) {
    return (0, $4ubkc.extractFromEventContext)((0, $c1d236d1310af702$export$70df29c238ba7306), event);
}
function $04a969d82f7195e3$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $04a969d82f7195e3$export$22af68e3614bf024(event) {
    const sources = (0, $4ubkc.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $4ubkc.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $4ubkc.getExtraAttributes)(event);
    const mediaContexts = $04a969d82f7195e3$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $4ubkc.getComponents)(event);
    const mediaRegion = $04a969d82f7195e3$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $4ubkc.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $04a969d82f7195e3$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("eK5Tt", function(module, exports) {
$parcel$export(module.exports, "default", () => $450bcf7f3012e73c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $2v5jv = parcelRequire("2v5jv");

var $1RJF0 = parcelRequire("1RJF0");
function $450bcf7f3012e73c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).peopleTeams,
        processEvent: (0, $2v5jv.default)
    });
}

});
parcelRegister("2v5jv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3b6f40dbd2c13bc$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("d1flD");
var $5VLrq = parcelRequire("5VLrq");

var $fZH68 = parcelRequire("fZH68");
const $d3b6f40dbd2c13bc$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $d3b6f40dbd2c13bc$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $d3b6f40dbd2c13bc$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $5VLrq.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $5VLrq.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $5VLrq.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $5VLrq.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $5VLrq.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $d3b6f40dbd2c13bc$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($d3b6f40dbd2c13bc$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("dnvMA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2f1bcc7b7be3b55$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $575b2 = parcelRequire("575b2");

var $1RJF0 = parcelRequire("1RJF0");
function $e2f1bcc7b7be3b55$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).notifications,
        processEvent: (0, $575b2.default)
    });
}

});
parcelRegister("575b2", function(module, exports) {
$parcel$export(module.exports, "default", () => $343bcbeea0265242$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $fZH68 = parcelRequire("fZH68");
parcelRequire("d1flD");
var $hgSVe = parcelRequire("hgSVe");

var $gAyKX = parcelRequire("gAyKX");
const $343bcbeea0265242$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $343bcbeea0265242$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $hgSVe.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $hgSVe.NOTIFICATIONS_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $hgSVe.NOTIFICATIONS_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $hgSVe.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $hgSVe.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $343bcbeea0265242$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $gAyKX.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("bnzdl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce639ec02be998f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $6t7Lj = parcelRequire("6t7Lj");

var $1RJF0 = parcelRequire("1RJF0");
function $fce639ec02be998f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).recentWork,
        processEvent: (0, $6t7Lj.default)
    });
}

});
parcelRegister("6t7Lj", function(module, exports) {
$parcel$export(module.exports, "default", () => $933f6a4394732776$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $fZH68 = parcelRequire("fZH68");
parcelRequire("d1flD");
var $4tqbJ = parcelRequire("4tqbJ");

var $gAyKX = parcelRequire("gAyKX");
const $933f6a4394732776$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $933f6a4394732776$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $4tqbJ.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $4tqbJ.RECENT_WORK_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $4tqbJ.RECENT_WORK_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $4tqbJ.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $4tqbJ.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $933f6a4394732776$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $gAyKX.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("k9evp", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc1a413f4b8b0380$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $lyvAh = parcelRequire("lyvAh");

var $1RJF0 = parcelRequire("1RJF0");
function $fc1a413f4b8b0380$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).atlas,
        processEvent: (0, $lyvAh.default)
    });
}

});
parcelRegister("lyvAh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b6251b84d03851b$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $fZH68 = parcelRequire("fZH68");
parcelRequire("d1flD");
var $5zOZ3 = parcelRequire("5zOZ3");
const $1b6251b84d03851b$var$ATLAS_TAG = 'atlas';
const $1b6251b84d03851b$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $1b6251b84d03851b$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $5zOZ3.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $5zOZ3.ATLAS_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $5zOZ3.ATLAS_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $5zOZ3.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $5zOZ3.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $1b6251b84d03851b$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($1b6251b84d03851b$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("h4HRZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7e932e2ecd49c10$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $jtwwz = parcelRequire("jtwwz");

var $1RJF0 = parcelRequire("1RJF0");
function $f7e932e2ecd49c10$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).crossFlow,
        processEvent: (0, $jtwwz.default)
    });
}

});
parcelRegister("jtwwz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c6cb25b2cf1ae4b$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 

var $1ilzu = parcelRequire("1ilzu");
parcelRequire("d1flD");
var $d6Xk2 = parcelRequire("d6Xk2");

var $4ubkc = parcelRequire("4ubkc");

var $fZH68 = parcelRequire("fZH68");
const $7c6cb25b2cf1ae4b$var$CROSS_FLOW_TAG = 'crossFlow';
var $7c6cb25b2cf1ae4b$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $4ubkc.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $4ubkc.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $fZH68.getExtraAttributes)(event, (0, $d6Xk2.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($7c6cb25b2cf1ae4b$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("e6pxd", function(module, exports) {
$parcel$export(module.exports, "default", () => $abcfda03df6bb29f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aMDt2 = parcelRequire("aMDt2");

var $gAyKX = parcelRequire("gAyKX");

var $1RJF0 = parcelRequire("1RJF0");
function $abcfda03df6bb29f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).linkingPlatform,
        processEvent: (0, $aMDt2.default)
    });
}

});
parcelRegister("aMDt2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3350186f7fcd893$export$2e2bcd8739ae039);

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("d1flD");
var $1PrKb = parcelRequire("1PrKb");

var $fZH68 = parcelRequire("fZH68");

var $gAyKX = parcelRequire("gAyKX");
const $d3350186f7fcd893$var$listenerVersion = "0.0.0-use.local";
var $d3350186f7fcd893$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $1PrKb.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $1PrKb.LINKING_PLATFORM_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $1PrKb.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $1PrKb.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $gAyKX.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $d3350186f7fcd893$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("brhln", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ef1f125d40edf65$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $ft55H = parcelRequire("ft55H");

var $1RJF0 = parcelRequire("1RJF0");
function $8ef1f125d40edf65$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).postOffice,
        processEvent: (0, $ft55H.default)
    });
}

});
parcelRegister("ft55H", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2ca9c2efac77274$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("d1flD");
var $4LSEp = parcelRequire("4LSEp");

var $fZH68 = parcelRequire("fZH68");

var $gAyKX = parcelRequire("gAyKX");
const $c2ca9c2efac77274$var$POST_OFFICE_TAG = (0, $gAyKX.FabricChannel).postOffice;
const $c2ca9c2efac77274$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c2ca9c2efac77274$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $4LSEp.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $4LSEp.POST_OFFICE_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $4LSEp.POST_OFFICE_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $4LSEp.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $4LSEp.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $c2ca9c2efac77274$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($c2ca9c2efac77274$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("9e0W4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2833688d903d8f29$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $8H2Pg = parcelRequire("8H2Pg");

var $1RJF0 = parcelRequire("1RJF0");
function $2833688d903d8f29$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).aiMate,
        processEvent: (0, $8H2Pg.default)
    });
}

});
parcelRegister("8H2Pg", function(module, exports) {
$parcel$export(module.exports, "default", () => $2aaed9ad4c49c802$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("d1flD");
var $2dC8y = parcelRequire("2dC8y");

var $fZH68 = parcelRequire("fZH68");
const $2aaed9ad4c49c802$var$AI_MATE_TAG = 'aiMate';
const $2aaed9ad4c49c802$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $2aaed9ad4c49c802$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $2dC8y.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $2dC8y.AI_MATE_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $2dC8y.AI_MATE_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $2dC8y.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $2dC8y.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $2aaed9ad4c49c802$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($2aaed9ad4c49c802$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("96m9I", function(module, exports) {
$parcel$export(module.exports, "default", () => $66f5024d65f5ecb9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $8CwDY = parcelRequire("8CwDY");

var $1RJF0 = parcelRequire("1RJF0");
function $66f5024d65f5ecb9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).avp,
        processEvent: (0, $8CwDY.default)
    });
}

});
parcelRegister("8CwDY", function(module, exports) {
$parcel$export(module.exports, "default", () => $62a2d28ff2979a01$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("d1flD");
var $iFaQf = parcelRequire("iFaQf");

var $fZH68 = parcelRequire("fZH68");
const $62a2d28ff2979a01$var$AVP_TAG = 'avp';
const $62a2d28ff2979a01$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $62a2d28ff2979a01$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $iFaQf.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $iFaQf.AVP_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $iFaQf.AVP_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $iFaQf.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $iFaQf.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $62a2d28ff2979a01$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, ...event.context)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($62a2d28ff2979a01$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("l78eq", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f6fcd0d00687e02$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $1BA3X = parcelRequire("1BA3X");

var $1RJF0 = parcelRequire("1RJF0");
function $8f6fcd0d00687e02$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).growth,
        processEvent: (0, $1BA3X.default)
    });
}

});
parcelRegister("1BA3X", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cad1ad783232a7f$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

parcelRequire("d1flD");
var $dVOhw = parcelRequire("dVOhw");

var $fZH68 = parcelRequire("fZH68");
const $4cad1ad783232a7f$var$GROWTH_TAG = 'growth';
const $4cad1ad783232a7f$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $4cad1ad783232a7f$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $dVOhw.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $dVOhw.GROWTH_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $dVOhw.GROWTH_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $dVOhw.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $dVOhw.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $4cad1ad783232a7f$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($4cad1ad783232a7f$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("bMlHd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d77be73afa54bdbe$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $dLxRJ = parcelRequire("dLxRJ");

var $1RJF0 = parcelRequire("1RJF0");
const $d77be73afa54bdbe$var$OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).omniChannel,
        processEvent: (0, $dLxRJ.default)
    });
};
var $d77be73afa54bdbe$export$2e2bcd8739ae039 = $d77be73afa54bdbe$var$OmniChannelAnalyticsListener;

});
parcelRegister("dLxRJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $80229a798cbd1cd8$export$2e2bcd8739ae039);

parcelRequire("d1flD");
var $cqETU = parcelRequire("cqETU");

var $fZH68 = parcelRequire("fZH68");

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

var $gAyKX = parcelRequire("gAyKX");
const $80229a798cbd1cd8$var$listenerVersion = "0.0.0-use.local";
var $80229a798cbd1cd8$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $cqETU.OMNI_CHANNEL_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $cqETU.OMNI_CHANNEL_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $cqETU.OMNI_CHANNEL_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $cqETU.OMNI_CHANNEL_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $cqETU.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $80229a798cbd1cd8$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $gAyKX.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("hxMOg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d342e0748ce2acb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $bQBJM = parcelRequire("bQBJM");

var $1RJF0 = parcelRequire("1RJF0");
function $4d342e0748ce2acb$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).townsquareHome,
        processEvent: (0, $bQBJM.default)
    });
}

});
parcelRegister("bQBJM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6334f205cf4cda92$export$2e2bcd8739ae039);

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $fZH68 = parcelRequire("fZH68");
parcelRequire("d1flD");
var $9ZkrU = parcelRequire("9ZkrU");
const $6334f205cf4cda92$var$TOWNSQUARE_TAG = 'townsquare';
const $6334f205cf4cda92$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
const $6334f205cf4cda92$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $6334f205cf4cda92$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $9ZkrU.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $9ZkrU.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $9ZkrU.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $9ZkrU.TOWNSQUARE_HOME_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $9ZkrU.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $6334f205cf4cda92$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($6334f205cf4cda92$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($6334f205cf4cda92$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("amJVK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d34db568e4c2884d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gAyKX = parcelRequire("gAyKX");

var $24WaJ = parcelRequire("24WaJ");

var $1RJF0 = parcelRequire("1RJF0");
function $d34db568e4c2884d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RJF0.default), {
        ...props,
        channel: (0, $gAyKX.FabricChannel).rovoExtension,
        processEvent: (0, $24WaJ.default)
    });
}

});
parcelRegister("24WaJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $306262fc07faa004$export$2e2bcd8739ae039);

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");


var $fZH68 = parcelRequire("fZH68");
parcelRequire("d1flD");
var $1AIN6 = parcelRequire("1AIN6");
const $306262fc07faa004$var$ROVO_EXTENSION_TAG = 'rovoExtension';
const $306262fc07faa004$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $306262fc07faa004$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $fZH68.getSources)(event, (0, $1AIN6.ROVO_EXTENSION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources) || (0, $c336a4a8eee57272$export$b055de0e665cb20c);
    const extraAttributes = (0, $fZH68.getExtraAttributes)(event, (0, $1AIN6.ROVO_EXTENSION_CONTEXT));
    const components = (0, $fZH68.getComponents)(event, (0, $1AIN6.ROVO_EXTENSION_CONTEXT));
    const packages = (0, $fZH68.getPackageInfo)(event, (0, $1AIN6.ROVO_EXTENSION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $fZH68.getPackageInfo)(event, (0, $1AIN6.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $c336a4a8eee57272$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $306262fc07faa004$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add($306262fc07faa004$var$ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, $c336a4a8eee57272$export$a1562d08625f5d7e:
        case 0, $c336a4a8eee57272$export$12346a674644c156:
        case 0, $c336a4a8eee57272$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $c336a4a8eee57272$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});




parcelRegister("62buE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("beH2Y")).default);
$parcel$export(module.exports, "AutoDismissFlag", () => (parcelRequire("huCkT")).default);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("1kIJP")).default);
$parcel$export(module.exports, "useFlags", () => (parcelRequire("aHcvI")).useFlags);
$parcel$export(module.exports, "withFlagsProvider", () => (parcelRequire("aHcvI")).withFlagsProvider);
$parcel$export(module.exports, "FlagsProvider", () => (parcelRequire("aHcvI")).FlagsProvider);

var $beH2Y = parcelRequire("beH2Y");

var $huCkT = parcelRequire("huCkT");

var $1kIJP = parcelRequire("1kIJP");

var $aHcvI = parcelRequire("aHcvI");

});
parcelRegister("beH2Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c50e4cc25a8a197$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $99f0y = parcelRequire("99f0y");

var $2w7cu = parcelRequire("2w7cu");

var $9ioug = parcelRequire("9ioug");

var $jVDYl = parcelRequire("jVDYl");
var $cIjay = parcelRequire("cIjay");
var $7SOTF = parcelRequire("7SOTF");

var $hk2S7 = parcelRequire("hk2S7");


var $90eEZ = parcelRequire("90eEZ");

var $1kIJP = parcelRequire("1kIJP");

var $emXjk = parcelRequire("emXjk");
var $a2bs3 = parcelRequire("a2bs3");

var $ahonG = parcelRequire("ahonG");
const $7c50e4cc25a8a197$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
const $7c50e4cc25a8a197$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $7c50e4cc25a8a197$var$descriptionStyles = null;
const $7c50e4cc25a8a197$var$iconWrapperStyles = null;
const $7c50e4cc25a8a197$var$flagWrapperStyles = null;
const $7c50e4cc25a8a197$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $7c50e4cc25a8a197$var$transitionStyles = null; /**
                                * __Flag__
                                *
                                * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
                                * often displayed using a flag group.
                                *
                                * - [Examples](https://atlassian.design/components/flag/examples)
                                * - [Code](https://atlassian.design/components/flag/code)
                                * - [Usage](https://atlassian.design/components/flag/usage)
                                */ 
const $7c50e4cc25a8a197$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $3c00358b8d5a4fa2$export$d6830277b06edd6), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $2w7cu.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $2w7cu.default), onDismissed: onDismissedProp = (0, $2w7cu.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $eJOHy.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $1kIJP.useFlagGroup)();
    const onDismissed = (0, $eJOHy.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $eJOHy.useState)(false);
    const onDismissedAnalytics = (0, $99f0y.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$7c50e4cc25a8a197$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $3c00358b8d5a4fa2$export$d6830277b06edd6);
    const toggleExpand = (0, $eJOHy.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $eJOHy.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $99f0y.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$7c50e4cc25a8a197$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $99f0y.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$7c50e4cc25a8a197$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $ahonG.flagTextColor)[appearance];
    const iconColor = (0, $ahonG.flagIconColor)[appearance];
    const iconGlyph = (0, $ahonG.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded; // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hk2S7.default), {
        children: [
            title,
            description
        ]
    }) : undefined;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $hcewu.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jVDYl.default), {
            padding: "space.200",
            backgroundColor: (0, $ahonG.flagBackgroundColor)[appearance],
            xcss: $7c50e4cc25a8a197$var$styles.flag,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cIjay.default), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    , {
                        style: {
                            [$7c50e4cc25a8a197$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $hcewu.default)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        className: (0, $hcewu.default)([
                            "_v5641hdc _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7SOTF.default), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cIjay.default), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jVDYl.default), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $7c50e4cc25a8a197$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ioug.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $emXjk.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $a2bs3.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        , {
                                            style: {
                                                color: (0, $ahonG.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            "aria-hidden": isDelayToAnnounce,
                                            className: (0, $hcewu.default)([
                                                "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $90eEZ.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $7c50e4cc25a8a197$export$2e2bcd8739ae039 = $7c50e4cc25a8a197$var$Flag;

});
parcelRegister("99f0y", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $e7f15e061540a367$export$a4687b0234b40e28);

var $eJOHy = parcelRequire("eJOHy");

var $iFaP4 = parcelRequire("iFaP4");

var $5YL9v = parcelRequire("5YL9v");
function $e7f15e061540a367$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $5YL9v.useTrackedRef)(analyticsData);
    const fnRef = (0, $5YL9v.useTrackedRef)(fn);
    const handler = (0, $eJOHy.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("iFaP4", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $1455f8a1ab3e0a64$export$5bf35293e545f20c);

var $7pA0u = parcelRequire("7pA0u");

var $bwmP1 = parcelRequire("bwmP1");

var $8se5X = parcelRequire("8se5X");
function $1455f8a1ab3e0a64$export$5bf35293e545f20c() {
    const analyticsContext = (0, $8se5X.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $7pA0u.useCallbackOne)((payload)=>{
        return new (0, $bwmP1.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("bwmP1", function(module, exports) {
$parcel$export(module.exports, "isUIAnalyticsEvent", () => $1a223fbed7ec78f7$export$35f8383928ba8d7);
$parcel$export(module.exports, "default", () => $1a223fbed7ec78f7$export$2e2bcd8739ae039);
/// <reference types="node" />

var $1HngN = parcelRequire("1HngN");
const $1a223fbed7ec78f7$export$35f8383928ba8d7 = (obj)=>obj instanceof $1a223fbed7ec78f7$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $1a223fbed7ec78f7$export$2e2bcd8739ae039 extends (0, $1HngN.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
		 * A hacky "deep clone" of the object. This is limited in that it wont
		 * support functions, regexs, Maps, Sets, etc, but none of those need to
		 * be represented in our payload.
		 */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $1a223fbed7ec78f7$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("1HngN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9dd720ceef4515a$export$2e2bcd8739ae039);
const $c9dd720ceef4515a$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $c9dd720ceef4515a$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $c9dd720ceef4515a$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $c9dd720ceef4515a$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});




parcelRegister("2w7cu", function(module, exports) {
$parcel$export(module.exports, "default", () => $934bc4483ae5e8b5$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $934bc4483ae5e8b5$export$2e2bcd8739ae039() {}

});

parcelRegister("9ioug", function(module, exports) {
$parcel$export(module.exports, "default", () => $57df9ed4e4d69be9$export$2e2bcd8739ae039);
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2FcHJ = parcelRequire("2FcHJ");

var $egx8e = parcelRequire("egx8e");

var $dgf4X = parcelRequire("dgf4X");

var $igDjg = parcelRequire("igDjg");
const $57df9ed4e4d69be9$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
const $57df9ed4e4d69be9$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
const $57df9ed4e4d69be9$var$headingColorStylesMap = {
    'color.text': "_syazi7uo",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syaz1yd3"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::406afb01e5634a0b459f50de660d8c2e>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ const $57df9ed4e4d69be9$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ const $57df9ed4e4d69be9$var$useColor = (colorProp)=>{
    const surface = (0, $egx8e.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $2FcHJ.inverseColorMap).hasOwnProperty(surface)) return (0, $2FcHJ.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $57df9ed4e4d69be9$var$Heading = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $igDjg;
    const [hLevel, inferredElement] = (0, $dgf4X.useHeading)($57df9ed4e4d69be9$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $57df9ed4e4d69be9$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $hcewu.default)([
            $57df9ed4e4d69be9$var$styles.reset,
            size && $57df9ed4e4d69be9$var$headingSizeStylesMap[size],
            $57df9ed4e4d69be9$var$headingColorStylesMap[color]
        ]),
        children: children
    });
});
var $57df9ed4e4d69be9$export$2e2bcd8739ae039 = $57df9ed4e4d69be9$var$Heading;

});
parcelRegister("2FcHJ", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $eb9823569d0ec2ca$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $eb9823569d0ec2ca$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $eb9823569d0ec2ca$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $eb9823569d0ec2ca$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $eb9823569d0ec2ca$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $eb9823569d0ec2ca$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $eb9823569d0ec2ca$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $eb9823569d0ec2ca$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $eb9823569d0ec2ca$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $eb9823569d0ec2ca$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $eb9823569d0ec2ca$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $eb9823569d0ec2ca$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $eb9823569d0ec2ca$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $eb9823569d0ec2ca$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $eb9823569d0ec2ca$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $eb9823569d0ec2ca$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $eb9823569d0ec2ca$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $eb9823569d0ec2ca$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $eb9823569d0ec2ca$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $eb9823569d0ec2ca$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $eb9823569d0ec2ca$export$38845ca010b93505);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $eb9823569d0ec2ca$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $eb9823569d0ec2ca$export$5e65a44e5b6ecadb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $aDO2o = parcelRequire("aDO2o");
const $eb9823569d0ec2ca$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $eb9823569d0ec2ca$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $eb9823569d0ec2ca$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $eb9823569d0ec2ca$export$632685d741f3dbbf = {
    ...$eb9823569d0ec2ca$export$958d0ae7f2977ae4,
    ...$eb9823569d0ec2ca$export$d2dc61f58390201c
};
const $eb9823569d0ec2ca$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $eb9823569d0ec2ca$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $eb9823569d0ec2ca$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $eb9823569d0ec2ca$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $eb9823569d0ec2ca$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $eb9823569d0ec2ca$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $eb9823569d0ec2ca$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $eb9823569d0ec2ca$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $eb9823569d0ec2ca$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $eb9823569d0ec2ca$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
const $eb9823569d0ec2ca$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
const $eb9823569d0ec2ca$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $eb9823569d0ec2ca$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $eb9823569d0ec2ca$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $eb9823569d0ec2ca$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $eb9823569d0ec2ca$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $eb9823569d0ec2ca$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const $eb9823569d0ec2ca$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $eb9823569d0ec2ca$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = /*#__PURE__*/ (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $eb9823569d0ec2ca$export$e615f061ca585a6c = $eb9823569d0ec2ca$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7(spacingProperty, $eb9823569d0ec2ca$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $eb9823569d0ec2ca$export$bf46c3f9eeafc71f = $eb9823569d0ec2ca$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7(spacingProperty, $eb9823569d0ec2ca$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $eb9823569d0ec2ca$export$e7af83bafe7f9e63 = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7('backgroundColor', $eb9823569d0ec2ca$export$d1d79bf68ac056bd);
const $eb9823569d0ec2ca$export$3a1bcba60b23d7f0 = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7('color', $eb9823569d0ec2ca$export$8473307aa00d6ea1);
const $eb9823569d0ec2ca$export$45f3f4fe16f9f7d5 = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7('fontWeight', $eb9823569d0ec2ca$export$303e322c6b1ed114);
const $eb9823569d0ec2ca$export$68cc305da27dbaa4 = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7('fontFamily', $eb9823569d0ec2ca$export$3c7e9587132614b4);
const $eb9823569d0ec2ca$export$128f10c238242f83 = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7('font', $eb9823569d0ec2ca$export$6ffa317d5e70375);
const $eb9823569d0ec2ca$export$219d364c0da35ae4 = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7('font', $eb9823569d0ec2ca$export$236bfe3a33ef1292);
const $eb9823569d0ec2ca$export$38845ca010b93505 = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7('fontWeight', $eb9823569d0ec2ca$export$855cfd311192d666);
const $eb9823569d0ec2ca$export$ff257d957d48c421 = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7((0, $aDO2o.CURRENT_SURFACE_CSS_VAR), $eb9823569d0ec2ca$export$41a358c9c2356760);
const $eb9823569d0ec2ca$export$5e65a44e5b6ecadb = (color)=>$eb9823569d0ec2ca$export$41a358c9c2356760[color] !== undefined;
const $eb9823569d0ec2ca$export$7001ce64d9ff7c7f = $eb9823569d0ec2ca$export$ca0f9c2de39ffed7('font', $eb9823569d0ec2ca$export$b805719bc8cb376);

});
parcelRegister("aDO2o", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $a3b2b6b4fe42348b$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $a3b2b6b4fe42348b$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $a3b2b6b4fe42348b$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $a3b2b6b4fe42348b$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $a3b2b6b4fe42348b$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $a3b2b6b4fe42348b$export$9d7b58831ae93caa);
const $a3b2b6b4fe42348b$export$4ef52930e33717cd = 'data-theme';
const $a3b2b6b4fe42348b$export$a00eac3f8684bcd0 = 'data-color-mode';
const $a3b2b6b4fe42348b$export$2112803007239c61 = 'data-contrast-mode';
const $a3b2b6b4fe42348b$export$352e418ed5b6193a = 'data-custom-theme';
const $a3b2b6b4fe42348b$export$6f0c6fb8c80fcc92 = 'ds';
const $a3b2b6b4fe42348b$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $a3b2b6b4fe42348b$export$dddac1532e822863 = `--${$a3b2b6b4fe42348b$export$6f0c6fb8c80fcc92}-token-not-found`;
const $a3b2b6b4fe42348b$export$9d7b58831ae93caa = `--${$a3b2b6b4fe42348b$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});


parcelRegister("egx8e", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $4c0d0311609b7bec$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $4c0d0311609b7bec$export$1aeb4f6b93c4540d);

var $eJOHy = parcelRequire("eJOHy");
const $4c0d0311609b7bec$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eJOHy.createContext)('elevation.surface');
const $4c0d0311609b7bec$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eJOHy.useContext)($4c0d0311609b7bec$export$1ca2a26fecb070ae);
};
$4c0d0311609b7bec$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("dgf4X", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $86d0def7b1ad36d9$export$97a37b1befbbf9b1);
$parcel$export(module.exports, "default", () => $86d0def7b1ad36d9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $86d0def7b1ad36d9$var$HeadingLevelContext = /*#__PURE__*/ (0, $eJOHy.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ const $86d0def7b1ad36d9$var$useHeadingLevel = ()=>{
    return (0, $eJOHy.useContext)($86d0def7b1ad36d9$var$HeadingLevelContext);
};
const $86d0def7b1ad36d9$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = $86d0def7b1ad36d9$var$useHeadingLevel();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const $86d0def7b1ad36d9$var$HeadingLevelContextProvider = ({ children: children, value: value })=>{
    const parentHeadingLevel = $86d0def7b1ad36d9$var$useHeadingLevel();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($86d0def7b1ad36d9$var$HeadingLevelContext.Provider, {
        value: value || headingLevel,
        children: children
    });
};
var $86d0def7b1ad36d9$export$2e2bcd8739ae039 = $86d0def7b1ad36d9$var$HeadingLevelContextProvider;

});


parcelRegister("jVDYl", function(module, exports) {
$parcel$export(module.exports, "default", () => $c05c4ff35176a720$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $egx8e = parcelRequire("egx8e");
const $c05c4ff35176a720$var$baseStyles = null;
const $c05c4ff35176a720$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhk1w7a",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $c05c4ff35176a720$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $c05c4ff35176a720$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $c05c4ff35176a720$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $c05c4ff35176a720$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $c05c4ff35176a720$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $c05c4ff35176a720$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ const $c05c4ff35176a720$var$Box = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $hcewu.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $c05c4ff35176a720$var$backgroundColorMap[backgroundColor],
            backgroundColor && $c05c4ff35176a720$var$isSurfaceToken(backgroundColor) && $c05c4ff35176a720$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $c05c4ff35176a720$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $c05c4ff35176a720$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $c05c4ff35176a720$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $c05c4ff35176a720$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $egx8e.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
var $c05c4ff35176a720$export$2e2bcd8739ae039 = $c05c4ff35176a720$var$Box;
function $c05c4ff35176a720$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $c05c4ff35176a720$var$setSurfaceTokenMap;
}

});

parcelRegister("cIjay", function(module, exports) {
$parcel$export(module.exports, "default", () => $12b4d15d05bef668$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ivAPc = parcelRequire("ivAPc");

var $3du7u = parcelRequire("3du7u");
const $12b4d15d05bef668$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $12b4d15d05bef668$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            $12b4d15d05bef668$var$styles.separator
        ]),
        children: children
    });
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $12b4d15d05bef668$var$Inline = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $gt9Am.jsx)($12b4d15d05bef668$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $eJOHy.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3du7u.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $ivAPc.cx)(grow === 'hug' && $12b4d15d05bef668$var$styles.hug, grow === 'fill' && $12b4d15d05bef668$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$12b4d15d05bef668$var$Inline.displayName = 'Inline';
var $12b4d15d05bef668$export$2e2bcd8739ae039 = $12b4d15d05bef668$var$Inline;

});
parcelRegister("ivAPc", function(module, exports) {
$parcel$export(module.exports, "cx", () => $f2a0f3549168b88e$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("eJOHy");

var $3C1kS = parcelRequire("3C1kS");
const $f2a0f3549168b88e$var$strictApi = (0, $3C1kS.createStrictAPI)();
const $f2a0f3549168b88e$export$dbf350e5966cf602 = $f2a0f3549168b88e$var$strictApi.css;
const $f2a0f3549168b88e$export$eb1ecd84a24ee424 = $f2a0f3549168b88e$var$strictApi.cssMap;
$f2a0f3549168b88e$var$strictApi.cssMap;
const $f2a0f3549168b88e$export$a274e22fb40f762e = $f2a0f3549168b88e$var$strictApi.cx;
const $f2a0f3549168b88e$var$XCSSProp = $f2a0f3549168b88e$var$strictApi.XCSSProp;

});

parcelRegister("3du7u", function(module, exports) {
$parcel$export(module.exports, "default", () => $219f2bb8402ee870$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $219f2bb8402ee870$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $219f2bb8402ee870$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $219f2bb8402ee870$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $219f2bb8402ee870$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $219f2bb8402ee870$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $219f2bb8402ee870$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $219f2bb8402ee870$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $219f2bb8402ee870$var$Flex = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $hcewu.default)([
            $219f2bb8402ee870$var$styles.root,
            gap && $219f2bb8402ee870$var$columnGapMap[gap],
            columnGap && $219f2bb8402ee870$var$columnGapMap[columnGap],
            gap && $219f2bb8402ee870$var$rowGapMap[gap],
            rowGap && $219f2bb8402ee870$var$rowGapMap[rowGap],
            alignItems && $219f2bb8402ee870$var$alignItemsMap[alignItems],
            direction && $219f2bb8402ee870$var$flexDirectionMap[direction],
            justifyContent && $219f2bb8402ee870$var$justifyContentMap[justifyContent],
            wrap && $219f2bb8402ee870$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$219f2bb8402ee870$var$Flex.displayName = 'Flex';
var $219f2bb8402ee870$export$2e2bcd8739ae039 = $219f2bb8402ee870$var$Flex;

});


parcelRegister("7SOTF", function(module, exports) {
$parcel$export(module.exports, "default", () => $c174ff4a49b81fba$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ivAPc = parcelRequire("ivAPc");

var $3du7u = parcelRequire("3du7u");
const $c174ff4a49b81fba$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $c174ff4a49b81fba$var$Stack = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3du7u.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $ivAPc.cx)(grow === 'hug' && $c174ff4a49b81fba$var$styles.hug, grow === 'fill' && $c174ff4a49b81fba$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$c174ff4a49b81fba$var$Stack.displayName = 'Stack';
var $c174ff4a49b81fba$export$2e2bcd8739ae039 = $c174ff4a49b81fba$var$Stack;

});

parcelRegister("hk2S7", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cef932bebf8dbdf$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3cef932bebf8dbdf$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $3cef932bebf8dbdf$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
$3cef932bebf8dbdf$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $3cef932bebf8dbdf$export$2e2bcd8739ae039 = $3cef932bebf8dbdf$var$VisuallyHidden;

});

const $3c00358b8d5a4fa2$export$d6830277b06edd6 = 'normal';

parcelRegister("90eEZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4db8bc12d252e181$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $RIJMT = parcelRequire("RIJMT");

var $cIjay = parcelRequire("cIjay");


var $ahonG = parcelRequire("ahonG");
const $4db8bc12d252e181$var$buttonStyles = null;
const $4db8bc12d252e181$var$fontStyles = null;
const $4db8bc12d252e181$var$appearanceNormalButtonStyles = null;
const $4db8bc12d252e181$var$appearanceNormalActionsContainerStyles = null;
const $4db8bc12d252e181$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $3c00358b8d5a4fa2$export$d6830277b06edd6), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $3c00358b8d5a4fa2$export$d6830277b06edd6);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c82smr"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cIjay.default), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $RIJMT.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $ahonG.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $ahonG.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $ahonG.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $ahonG.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $hcewu.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow0718uv _1p6b18uv _8dbm18uv _77mc18uv _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        appearance === (0, $3c00358b8d5a4fa2$export$d6830277b06edd6) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4db8bc12d252e181$export$2e2bcd8739ae039 = $4db8bc12d252e181$var$FlagActions;

});
parcelRegister("RIJMT", function(module, exports) {
$parcel$export(module.exports, "default", () => $14fe9755d5d6a6e2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iIPH8 = parcelRequire("iIPH8");

var $7OArX = parcelRequire("7OArX");

var $gAC1H = parcelRequire("gAC1H");

var $bscf6 = parcelRequire("bscf6");

var $3pDT1 = parcelRequire("3pDT1");
function $14fe9755d5d6a6e2$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $14fe9755d5d6a6e2$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $14fe9755d5d6a6e2$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $3pDT1.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $eJOHy.useState)($14fe9755d5d6a6e2$var$initial);
    const onMouseEnter = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $eJOHy.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pDT1.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iIPH8.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pDT1.default).Consumer, {
                    mode: mode,
                    state: $14fe9755d5d6a6e2$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $gAC1H.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7OArX.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bscf6.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $3pDT1.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$14fe9755d5d6a6e2$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $14fe9755d5d6a6e2$export$2e2bcd8739ae039 = $14fe9755d5d6a6e2$var$CustomThemeButton;

});
parcelRegister("iIPH8", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", () => $84ba06e151c35aaf$export$7692396083754928);
$parcel$export(module.exports, "default", () => $84ba06e151c35aaf$export$2e2bcd8739ae039);

var $58O8Z = parcelRequire("58O8Z");
// Create default global light theme
const { Provider: $84ba06e151c35aaf$var$Provider, Consumer: $84ba06e151c35aaf$var$Consumer, useTheme: $84ba06e151c35aaf$export$7692396083754928 } = (0, $58O8Z.createTheme)(()=>({
        mode: 'light'
    }));
const $84ba06e151c35aaf$var$Theme = {
    Provider: $84ba06e151c35aaf$var$Provider,
    Consumer: $84ba06e151c35aaf$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$84ba06e151c35aaf$export$2e2bcd8739ae039 = $84ba06e151c35aaf$var$Theme;

});
parcelRegister("58O8Z", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $719b10144ce5b9eb$export$25d302a5b900a763);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $719b10144ce5b9eb$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $eJOHy.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: children(tokens)
        });
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, $eJOHy.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $eJOHy.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("7OArX", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ad43f1e08aff96$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                        * @jsxRuntime classic
                                                                        * @jsx jsx
                                                                        */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $99f0y = parcelRequire("99f0y");

var $2w7cu = parcelRequire("2w7cu");

var $jfGrc = parcelRequire("jfGrc");

var $5mvVQ = parcelRequire("5mvVQ");

var $8MFTW = parcelRequire("8MFTW");


var $f3gwZ = parcelRequire("f3gwZ");

var $bm7hu = parcelRequire("bm7hu");

var $3Ut2N = parcelRequire("3Ut2N");
function $72ad43f1e08aff96$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $72ad43f1e08aff96$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $72ad43f1e08aff96$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $72ad43f1e08aff96$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $72ad43f1e08aff96$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $3Ut2N.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $72ad43f1e08aff96$var$getChildren = (children, childrenStyles)=>{
    if ((0, $3Ut2N.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $72ad43f1e08aff96$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $2w7cu.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $2w7cu.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $eJOHy.useRef)();
    const setRef = (0, $eJOHy.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $jfGrc.default)(ourRef, autoFocus);
    const interactionContext = (0, $eJOHy.useContext)((0, $8MFTW.default));
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $99f0y.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $eJOHy.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $1NIU8.css)((0, $bm7hu.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? `var(--ds-icon-subtle, ${0, $5d8ec86348a5c657$export$c39c0fe0f26207ae})` : `var(--ds-icon-warning-inverse, ${0, $5d8ec86348a5c657$export$c39c0fe0f26207ae})`} !important`
        }
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5mvVQ.default), null, /*#__PURE__*/ (0, $1NIU8.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $72ad43f1e08aff96$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $f3gwZ.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bm7hu.getIconStyle)({
                spacing: spacing
            }),
            $72ad43f1e08aff96$var$getSpacingFix(children, $72ad43f1e08aff96$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $72ad43f1e08aff96$var$getChildren(children, [
        fadeStyles,
        (0, $bm7hu.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bm7hu.getIconStyle)({
                spacing: spacing
            }),
            $72ad43f1e08aff96$var$getSpacingFix(children, $72ad43f1e08aff96$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: [
            (0, $bm7hu.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$72ad43f1e08aff96$export$2e2bcd8739ae039 = $72ad43f1e08aff96$var$ButtonBase;

});
parcelRegister("jfGrc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e40b9382a648c8ca$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $e40b9382a648c8ca$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("5mvVQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e631124426245c1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
const $7e631124426245c1$var$BORDER_WIDTH = 2;
const $7e631124426245c1$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #2684FF)"}`,
    outlineOffset: $7e631124426245c1$var$BORDER_WIDTH
});
const $7e631124426245c1$var$baseInsetStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$7e631124426245c1$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $7e631124426245c1$var$focusRingStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $7e631124426245c1$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $7e631124426245c1$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $7e631124426245c1$var$insetFocusRingStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $7e631124426245c1$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $7e631124426245c1$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $7e631124426245c1$var$FocusRing = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $7e631124426245c1$var$baseInsetStyles : $7e631124426245c1$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $7e631124426245c1$var$insetFocusRingStyles : $7e631124426245c1$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1NIU8.ClassNames), null, ({ css: css, cx: cx })=>(0, $eJOHy.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $eJOHy.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$7e631124426245c1$var$FocusRing.displayName = 'FocusRing';
var $7e631124426245c1$export$2e2bcd8739ae039 = $7e631124426245c1$var$FocusRing;

});

var $5d8ec86348a5c657$exports = {};
$parcel$export($5d8ec86348a5c657$exports, "R50", () => $5d8ec86348a5c657$export$4b84fd0e2c617bd);
$parcel$export($5d8ec86348a5c657$exports, "R75", () => $5d8ec86348a5c657$export$b34b069eff244586);
$parcel$export($5d8ec86348a5c657$exports, "R100", () => $5d8ec86348a5c657$export$be802dd0d8b57f35);
$parcel$export($5d8ec86348a5c657$exports, "R200", () => $5d8ec86348a5c657$export$60847d42f9da92a6);
$parcel$export($5d8ec86348a5c657$exports, "R300", () => $5d8ec86348a5c657$export$4a7404f376229999);
$parcel$export($5d8ec86348a5c657$exports, "R400", () => $5d8ec86348a5c657$export$2010d0fb4295b346);
$parcel$export($5d8ec86348a5c657$exports, "R500", () => $5d8ec86348a5c657$export$2837b5a1a71d5c02);
$parcel$export($5d8ec86348a5c657$exports, "Y50", () => $5d8ec86348a5c657$export$8d9596b529bbb9cf);
$parcel$export($5d8ec86348a5c657$exports, "Y75", () => $5d8ec86348a5c657$export$41060a744ab0b7ae);
$parcel$export($5d8ec86348a5c657$exports, "Y100", () => $5d8ec86348a5c657$export$1cc05bbbf340e559);
$parcel$export($5d8ec86348a5c657$exports, "Y200", () => $5d8ec86348a5c657$export$5aae31392d72caaa);
$parcel$export($5d8ec86348a5c657$exports, "Y300", () => $5d8ec86348a5c657$export$c6930421db9fa514);
$parcel$export($5d8ec86348a5c657$exports, "Y400", () => $5d8ec86348a5c657$export$59619663aa6500fb);
$parcel$export($5d8ec86348a5c657$exports, "Y500", () => $5d8ec86348a5c657$export$874739ea9e379ab6);
$parcel$export($5d8ec86348a5c657$exports, "G50", () => $5d8ec86348a5c657$export$8a6341c32b6a3ee6);
$parcel$export($5d8ec86348a5c657$exports, "G75", () => $5d8ec86348a5c657$export$69a3bf21b9686c2b);
$parcel$export($5d8ec86348a5c657$exports, "G100", () => $5d8ec86348a5c657$export$afbce1382ec95f73);
$parcel$export($5d8ec86348a5c657$exports, "G200", () => $5d8ec86348a5c657$export$747d86715d4175de);
$parcel$export($5d8ec86348a5c657$exports, "G300", () => $5d8ec86348a5c657$export$940e1f69e873f202);
$parcel$export($5d8ec86348a5c657$exports, "G400", () => $5d8ec86348a5c657$export$a49394138f7b8e85);
$parcel$export($5d8ec86348a5c657$exports, "G500", () => $5d8ec86348a5c657$export$6fa04827ac68a4fb);
$parcel$export($5d8ec86348a5c657$exports, "B50", () => $5d8ec86348a5c657$export$226de0355ed012f8);
$parcel$export($5d8ec86348a5c657$exports, "B75", () => $5d8ec86348a5c657$export$8c13c2ee36917869);
$parcel$export($5d8ec86348a5c657$exports, "B100", () => $5d8ec86348a5c657$export$ecfc1dff386a3e7a);
$parcel$export($5d8ec86348a5c657$exports, "B200", () => $5d8ec86348a5c657$export$215b7063051591f1);
$parcel$export($5d8ec86348a5c657$exports, "B300", () => $5d8ec86348a5c657$export$e62e8919cca44969);
$parcel$export($5d8ec86348a5c657$exports, "B400", () => $5d8ec86348a5c657$export$b3de0ae08da2ce64);
$parcel$export($5d8ec86348a5c657$exports, "B500", () => $5d8ec86348a5c657$export$a6ee3d71bc067634);
$parcel$export($5d8ec86348a5c657$exports, "B600", () => $5d8ec86348a5c657$export$67f15409e87642a1);
$parcel$export($5d8ec86348a5c657$exports, "B700", () => $5d8ec86348a5c657$export$f0539dbc42dbb067);
$parcel$export($5d8ec86348a5c657$exports, "P50", () => $5d8ec86348a5c657$export$363e4475840015bb);
$parcel$export($5d8ec86348a5c657$exports, "P75", () => $5d8ec86348a5c657$export$4b0a4417ed59760f);
$parcel$export($5d8ec86348a5c657$exports, "P100", () => $5d8ec86348a5c657$export$6011520a64d9a187);
$parcel$export($5d8ec86348a5c657$exports, "P200", () => $5d8ec86348a5c657$export$a7175d4e9206bc80);
$parcel$export($5d8ec86348a5c657$exports, "P300", () => $5d8ec86348a5c657$export$b48405b95304b5a1);
$parcel$export($5d8ec86348a5c657$exports, "P400", () => $5d8ec86348a5c657$export$c71e4279dd54a18d);
$parcel$export($5d8ec86348a5c657$exports, "P500", () => $5d8ec86348a5c657$export$147899de772240ec);
$parcel$export($5d8ec86348a5c657$exports, "T50", () => $5d8ec86348a5c657$export$2cf711fe14c66f06);
$parcel$export($5d8ec86348a5c657$exports, "T75", () => $5d8ec86348a5c657$export$7a8f4d33f6f9772c);
$parcel$export($5d8ec86348a5c657$exports, "T100", () => $5d8ec86348a5c657$export$776c9c497ef08533);
$parcel$export($5d8ec86348a5c657$exports, "T200", () => $5d8ec86348a5c657$export$69cb3ca10c1e330e);
$parcel$export($5d8ec86348a5c657$exports, "T300", () => $5d8ec86348a5c657$export$9dc1ef0f3f48059b);
$parcel$export($5d8ec86348a5c657$exports, "T400", () => $5d8ec86348a5c657$export$7c835c78b6fcdef8);
$parcel$export($5d8ec86348a5c657$exports, "T500", () => $5d8ec86348a5c657$export$6036577f95c3877e);
$parcel$export($5d8ec86348a5c657$exports, "N0", () => $5d8ec86348a5c657$export$29a4f05edc054374);
$parcel$export($5d8ec86348a5c657$exports, "N10", () => $5d8ec86348a5c657$export$e655ef011c4aa1a2);
$parcel$export($5d8ec86348a5c657$exports, "N20", () => $5d8ec86348a5c657$export$9fdfb749e33cdf97);
$parcel$export($5d8ec86348a5c657$exports, "N30", () => $5d8ec86348a5c657$export$3e51e8f1440314ba);
$parcel$export($5d8ec86348a5c657$exports, "N40", () => $5d8ec86348a5c657$export$1ce2d1575d444ceb);
$parcel$export($5d8ec86348a5c657$exports, "N50", () => $5d8ec86348a5c657$export$8754fc7e6d8b3000);
$parcel$export($5d8ec86348a5c657$exports, "N60", () => $5d8ec86348a5c657$export$c2e91cbeada39b8b);
$parcel$export($5d8ec86348a5c657$exports, "N70", () => $5d8ec86348a5c657$export$5f71e19f3a7ad9de);
$parcel$export($5d8ec86348a5c657$exports, "N80", () => $5d8ec86348a5c657$export$eaa8c8a70ac22806);
$parcel$export($5d8ec86348a5c657$exports, "N90", () => $5d8ec86348a5c657$export$7c87d337fb91a97d);
$parcel$export($5d8ec86348a5c657$exports, "N100", () => $5d8ec86348a5c657$export$d6447c357493214f);
$parcel$export($5d8ec86348a5c657$exports, "N200", () => $5d8ec86348a5c657$export$f563ee71e9ee74cd);
$parcel$export($5d8ec86348a5c657$exports, "N300", () => $5d8ec86348a5c657$export$e2ef2124cf4024b1);
$parcel$export($5d8ec86348a5c657$exports, "N400", () => $5d8ec86348a5c657$export$eece5f492e429f08);
$parcel$export($5d8ec86348a5c657$exports, "N500", () => $5d8ec86348a5c657$export$c39c0fe0f26207ae);
$parcel$export($5d8ec86348a5c657$exports, "N600", () => $5d8ec86348a5c657$export$7090862dc3038a9f);
$parcel$export($5d8ec86348a5c657$exports, "N700", () => $5d8ec86348a5c657$export$ad0bacf983b7ddaa);
$parcel$export($5d8ec86348a5c657$exports, "N800", () => $5d8ec86348a5c657$export$7d61b15e0da132af);
$parcel$export($5d8ec86348a5c657$exports, "N900", () => $5d8ec86348a5c657$export$fbda843f0a27fe96);
$parcel$export($5d8ec86348a5c657$exports, "N10A", () => $5d8ec86348a5c657$export$791e57b27ca738ef);
$parcel$export($5d8ec86348a5c657$exports, "N20A", () => $5d8ec86348a5c657$export$8d43898f60b96a82);
$parcel$export($5d8ec86348a5c657$exports, "N30A", () => $5d8ec86348a5c657$export$920c0d5c49070351);
$parcel$export($5d8ec86348a5c657$exports, "N40A", () => $5d8ec86348a5c657$export$46987b49aab6d1a8);
$parcel$export($5d8ec86348a5c657$exports, "N50A", () => $5d8ec86348a5c657$export$7d3359664e8bb0e5);
$parcel$export($5d8ec86348a5c657$exports, "N60A", () => $5d8ec86348a5c657$export$d2d3bedfb276cac0);
$parcel$export($5d8ec86348a5c657$exports, "N70A", () => $5d8ec86348a5c657$export$6e5e7499ff054f6d);
$parcel$export($5d8ec86348a5c657$exports, "N80A", () => $5d8ec86348a5c657$export$59264b346c877fa7);
$parcel$export($5d8ec86348a5c657$exports, "N90A", () => $5d8ec86348a5c657$export$d092757d7c64925c);
$parcel$export($5d8ec86348a5c657$exports, "N100A", () => $5d8ec86348a5c657$export$486ab785e4bac3c6);
$parcel$export($5d8ec86348a5c657$exports, "N200A", () => $5d8ec86348a5c657$export$fba592bbc6419fea);
$parcel$export($5d8ec86348a5c657$exports, "N300A", () => $5d8ec86348a5c657$export$13609db0e6812ab8);
$parcel$export($5d8ec86348a5c657$exports, "N400A", () => $5d8ec86348a5c657$export$fbae4efaa892d883);
$parcel$export($5d8ec86348a5c657$exports, "N500A", () => $5d8ec86348a5c657$export$f13946d26f440ce6);
$parcel$export($5d8ec86348a5c657$exports, "N600A", () => $5d8ec86348a5c657$export$19f58225ac52a306);
$parcel$export($5d8ec86348a5c657$exports, "N700A", () => $5d8ec86348a5c657$export$6384f09da70e7b62);
$parcel$export($5d8ec86348a5c657$exports, "N800A", () => $5d8ec86348a5c657$export$d0dccc730683edc2);
$parcel$export($5d8ec86348a5c657$exports, "DN900", () => $5d8ec86348a5c657$export$2f6319cf7d736c2a);
$parcel$export($5d8ec86348a5c657$exports, "DN800", () => $5d8ec86348a5c657$export$95126bc8884d6634);
$parcel$export($5d8ec86348a5c657$exports, "DN700", () => $5d8ec86348a5c657$export$8338d8c35d44ff1);
$parcel$export($5d8ec86348a5c657$exports, "DN600", () => $5d8ec86348a5c657$export$5368d76ae4fbbda7);
$parcel$export($5d8ec86348a5c657$exports, "DN500", () => $5d8ec86348a5c657$export$9f0a771d16ec8d36);
$parcel$export($5d8ec86348a5c657$exports, "DN400", () => $5d8ec86348a5c657$export$abcf8c38338b4aa5);
$parcel$export($5d8ec86348a5c657$exports, "DN300", () => $5d8ec86348a5c657$export$97e81faa16a182c7);
$parcel$export($5d8ec86348a5c657$exports, "DN200", () => $5d8ec86348a5c657$export$bfe21c59123ecf33);
$parcel$export($5d8ec86348a5c657$exports, "DN100", () => $5d8ec86348a5c657$export$ee82aa2ea6a1558);
$parcel$export($5d8ec86348a5c657$exports, "DN90", () => $5d8ec86348a5c657$export$682927c6ed76be02);
$parcel$export($5d8ec86348a5c657$exports, "DN80", () => $5d8ec86348a5c657$export$91fd9994c5be9757);
$parcel$export($5d8ec86348a5c657$exports, "DN70", () => $5d8ec86348a5c657$export$d281fbfe3cff2df6);
$parcel$export($5d8ec86348a5c657$exports, "DN60", () => $5d8ec86348a5c657$export$3902c91d8b98a753);
$parcel$export($5d8ec86348a5c657$exports, "DN50", () => $5d8ec86348a5c657$export$8e8133c1ba5845b5);
$parcel$export($5d8ec86348a5c657$exports, "DN40", () => $5d8ec86348a5c657$export$33ff357f6620b39);
$parcel$export($5d8ec86348a5c657$exports, "DN30", () => $5d8ec86348a5c657$export$633847cf062b69e0);
$parcel$export($5d8ec86348a5c657$exports, "DN20", () => $5d8ec86348a5c657$export$9776a6e503bdbf76);
$parcel$export($5d8ec86348a5c657$exports, "DN10", () => $5d8ec86348a5c657$export$6c813d5160dff5db);
$parcel$export($5d8ec86348a5c657$exports, "DN0", () => $5d8ec86348a5c657$export$3d4f271a500072a);
$parcel$export($5d8ec86348a5c657$exports, "DN800A", () => $5d8ec86348a5c657$export$fe151285c22759ec);
$parcel$export($5d8ec86348a5c657$exports, "DN700A", () => $5d8ec86348a5c657$export$a101c6190d0da34);
$parcel$export($5d8ec86348a5c657$exports, "DN600A", () => $5d8ec86348a5c657$export$4b16f52932fda51);
$parcel$export($5d8ec86348a5c657$exports, "DN500A", () => $5d8ec86348a5c657$export$a74bcd7b9845b0d8);
$parcel$export($5d8ec86348a5c657$exports, "DN400A", () => $5d8ec86348a5c657$export$9209c179316d1751);
$parcel$export($5d8ec86348a5c657$exports, "DN300A", () => $5d8ec86348a5c657$export$88f55133f636c8dd);
$parcel$export($5d8ec86348a5c657$exports, "DN200A", () => $5d8ec86348a5c657$export$51126f85d1009512);
$parcel$export($5d8ec86348a5c657$exports, "DN100A", () => $5d8ec86348a5c657$export$a069b547bd23af78);
$parcel$export($5d8ec86348a5c657$exports, "DN90A", () => $5d8ec86348a5c657$export$40cce05af3b2600a);
$parcel$export($5d8ec86348a5c657$exports, "DN80A", () => $5d8ec86348a5c657$export$b78942185925a0d);
$parcel$export($5d8ec86348a5c657$exports, "DN70A", () => $5d8ec86348a5c657$export$e058fb44b8eaafca);
$parcel$export($5d8ec86348a5c657$exports, "DN60A", () => $5d8ec86348a5c657$export$92b0b8de26920c18);
$parcel$export($5d8ec86348a5c657$exports, "DN50A", () => $5d8ec86348a5c657$export$67564f7459d3fc9e);
$parcel$export($5d8ec86348a5c657$exports, "DN40A", () => $5d8ec86348a5c657$export$77868e1ca884ffa3);
$parcel$export($5d8ec86348a5c657$exports, "DN30A", () => $5d8ec86348a5c657$export$2afd71d7d3ea2cd5);
$parcel$export($5d8ec86348a5c657$exports, "DN20A", () => $5d8ec86348a5c657$export$f2a0acaab9972c70);
$parcel$export($5d8ec86348a5c657$exports, "DN10A", () => $5d8ec86348a5c657$export$9ab70e67d6475361);
$parcel$export($5d8ec86348a5c657$exports, "T30", () => $5d8ec86348a5c657$export$d2adc5dedf09fced);
$parcel$export($5d8ec86348a5c657$exports, "L50", () => $5d8ec86348a5c657$export$f51762073d2bb381);
$parcel$export($5d8ec86348a5c657$exports, "L75", () => $5d8ec86348a5c657$export$95e26d54def96891);
// Reds
const $5d8ec86348a5c657$export$4b84fd0e2c617bd = '#FFEBE6';
const $5d8ec86348a5c657$export$b34b069eff244586 = '#FFBDAD';
const $5d8ec86348a5c657$export$be802dd0d8b57f35 = '#FF8F73';
const $5d8ec86348a5c657$export$60847d42f9da92a6 = '#FF7452';
const $5d8ec86348a5c657$export$4a7404f376229999 = '#FF5630';
const $5d8ec86348a5c657$export$2010d0fb4295b346 = '#DE350B';
const $5d8ec86348a5c657$export$2837b5a1a71d5c02 = '#BF2600';
const $5d8ec86348a5c657$export$8d9596b529bbb9cf = '#FFFAE6';
const $5d8ec86348a5c657$export$41060a744ab0b7ae = '#FFF0B3';
const $5d8ec86348a5c657$export$1cc05bbbf340e559 = '#FFE380';
const $5d8ec86348a5c657$export$5aae31392d72caaa = '#FFC400';
const $5d8ec86348a5c657$export$c6930421db9fa514 = '#FFAB00';
const $5d8ec86348a5c657$export$59619663aa6500fb = '#FF991F';
const $5d8ec86348a5c657$export$874739ea9e379ab6 = '#FF8B00';
const $5d8ec86348a5c657$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5d8ec86348a5c657$export$69a3bf21b9686c2b = '#ABF5D1';
const $5d8ec86348a5c657$export$afbce1382ec95f73 = '#79F2C0';
const $5d8ec86348a5c657$export$747d86715d4175de = '#57D9A3';
const $5d8ec86348a5c657$export$940e1f69e873f202 = '#36B37E';
const $5d8ec86348a5c657$export$a49394138f7b8e85 = '#00875A';
const $5d8ec86348a5c657$export$6fa04827ac68a4fb = '#006644';
const $5d8ec86348a5c657$export$226de0355ed012f8 = '#DEEBFF';
const $5d8ec86348a5c657$export$8c13c2ee36917869 = '#B3D4FF';
const $5d8ec86348a5c657$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5d8ec86348a5c657$export$215b7063051591f1 = '#2684FF';
const $5d8ec86348a5c657$export$e62e8919cca44969 = '#0065FF';
const $5d8ec86348a5c657$export$b3de0ae08da2ce64 = '#0052CC';
const $5d8ec86348a5c657$export$a6ee3d71bc067634 = '#0747A6';
const $5d8ec86348a5c657$export$67f15409e87642a1 = '#669DF1';
const $5d8ec86348a5c657$export$f0539dbc42dbb067 = '#8FB8F6';
const $5d8ec86348a5c657$export$363e4475840015bb = '#EAE6FF';
const $5d8ec86348a5c657$export$4b0a4417ed59760f = '#C0B6F2';
const $5d8ec86348a5c657$export$6011520a64d9a187 = '#998DD9';
const $5d8ec86348a5c657$export$a7175d4e9206bc80 = '#8777D9';
const $5d8ec86348a5c657$export$b48405b95304b5a1 = '#6554C0';
const $5d8ec86348a5c657$export$c71e4279dd54a18d = '#5243AA';
const $5d8ec86348a5c657$export$147899de772240ec = '#403294';
const $5d8ec86348a5c657$export$2cf711fe14c66f06 = '#E6FCFF';
const $5d8ec86348a5c657$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5d8ec86348a5c657$export$776c9c497ef08533 = '#79E2F2';
const $5d8ec86348a5c657$export$69cb3ca10c1e330e = '#00C7E6';
const $5d8ec86348a5c657$export$9dc1ef0f3f48059b = '#00B8D9';
const $5d8ec86348a5c657$export$7c835c78b6fcdef8 = '#00A3BF';
const $5d8ec86348a5c657$export$6036577f95c3877e = '#008DA6';
const $5d8ec86348a5c657$export$29a4f05edc054374 = '#FFFFFF';
const $5d8ec86348a5c657$export$e655ef011c4aa1a2 = '#FAFBFC';
const $5d8ec86348a5c657$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5d8ec86348a5c657$export$3e51e8f1440314ba = '#EBECF0';
const $5d8ec86348a5c657$export$1ce2d1575d444ceb = '#DFE1E6';
const $5d8ec86348a5c657$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5d8ec86348a5c657$export$c2e91cbeada39b8b = '#B3BAC5';
const $5d8ec86348a5c657$export$5f71e19f3a7ad9de = '#A5ADBA';
const $5d8ec86348a5c657$export$eaa8c8a70ac22806 = '#97A0AF';
const $5d8ec86348a5c657$export$7c87d337fb91a97d = '#8993A4';
const $5d8ec86348a5c657$export$d6447c357493214f = '#7A869A';
const $5d8ec86348a5c657$export$f563ee71e9ee74cd = '#6B778C';
const $5d8ec86348a5c657$export$e2ef2124cf4024b1 = '#5E6C84';
const $5d8ec86348a5c657$export$eece5f492e429f08 = '#505F79';
const $5d8ec86348a5c657$export$c39c0fe0f26207ae = '#42526E';
const $5d8ec86348a5c657$export$7090862dc3038a9f = '#344563';
const $5d8ec86348a5c657$export$ad0bacf983b7ddaa = '#253858';
const $5d8ec86348a5c657$export$7d61b15e0da132af = '#172B4D';
const $5d8ec86348a5c657$export$fbda843f0a27fe96 = '#091E42';
const $5d8ec86348a5c657$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $5d8ec86348a5c657$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $5d8ec86348a5c657$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $5d8ec86348a5c657$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $5d8ec86348a5c657$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $5d8ec86348a5c657$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $5d8ec86348a5c657$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $5d8ec86348a5c657$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $5d8ec86348a5c657$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $5d8ec86348a5c657$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $5d8ec86348a5c657$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $5d8ec86348a5c657$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $5d8ec86348a5c657$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $5d8ec86348a5c657$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $5d8ec86348a5c657$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $5d8ec86348a5c657$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $5d8ec86348a5c657$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $5d8ec86348a5c657$export$2f6319cf7d736c2a = '#E6EDFA';
const $5d8ec86348a5c657$export$95126bc8884d6634 = '#DCE5F5';
const $5d8ec86348a5c657$export$8338d8c35d44ff1 = '#CED9EB';
const $5d8ec86348a5c657$export$5368d76ae4fbbda7 = '#B8C7E0';
const $5d8ec86348a5c657$export$9f0a771d16ec8d36 = '#ABBBD6';
const $5d8ec86348a5c657$export$abcf8c38338b4aa5 = '#9FB0CC';
const $5d8ec86348a5c657$export$97e81faa16a182c7 = '#8C9CB8';
const $5d8ec86348a5c657$export$bfe21c59123ecf33 = '#7988A3';
const $5d8ec86348a5c657$export$ee82aa2ea6a1558 = '#67758F';
const $5d8ec86348a5c657$export$682927c6ed76be02 = '#56637A';
const $5d8ec86348a5c657$export$91fd9994c5be9757 = '#455166';
const $5d8ec86348a5c657$export$d281fbfe3cff2df6 = '#3B475C';
const $5d8ec86348a5c657$export$3902c91d8b98a753 = '#313D52';
const $5d8ec86348a5c657$export$8e8133c1ba5845b5 = '#283447';
const $5d8ec86348a5c657$export$33ff357f6620b39 = '#202B3D';
const $5d8ec86348a5c657$export$633847cf062b69e0 = '#1B2638';
const $5d8ec86348a5c657$export$9776a6e503bdbf76 = '#121A29';
const $5d8ec86348a5c657$export$6c813d5160dff5db = '#0E1624';
const $5d8ec86348a5c657$export$3d4f271a500072a = '#0D1424';
const $5d8ec86348a5c657$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $5d8ec86348a5c657$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $5d8ec86348a5c657$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $5d8ec86348a5c657$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $5d8ec86348a5c657$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $5d8ec86348a5c657$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $5d8ec86348a5c657$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $5d8ec86348a5c657$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $5d8ec86348a5c657$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $5d8ec86348a5c657$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $5d8ec86348a5c657$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $5d8ec86348a5c657$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $5d8ec86348a5c657$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $5d8ec86348a5c657$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $5d8ec86348a5c657$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $5d8ec86348a5c657$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $5d8ec86348a5c657$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $5d8ec86348a5c657$export$d2adc5dedf09fced = '#292A2E';
const $5d8ec86348a5c657$export$f51762073d2bb381 = '#94C748';
const $5d8ec86348a5c657$export$95e26d54def96891 = '#B3DF72';

parcelRegister("f3gwZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $41be5fb2a75c6a98$export$2e2bcd8739ae039);
function $41be5fb2a75c6a98$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $41be5fb2a75c6a98$var$tabKeyCode = 9;
function $41be5fb2a75c6a98$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $41be5fb2a75c6a98$var$tabKeyCode) return;
    $41be5fb2a75c6a98$var$abort(event);
}
const $41be5fb2a75c6a98$var$block = {
    onMouseDownCapture: $41be5fb2a75c6a98$var$abort,
    onMouseUpCapture: $41be5fb2a75c6a98$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $41be5fb2a75c6a98$var$onKey,
    onKeyUpCapture: $41be5fb2a75c6a98$var$onKey,
    onTouchStartCapture: $41be5fb2a75c6a98$var$abort,
    onTouchEndCapture: $41be5fb2a75c6a98$var$abort,
    onPointerDownCapture: $41be5fb2a75c6a98$var$abort,
    onPointerUpCapture: $41be5fb2a75c6a98$var$abort,
    onClickCapture: $41be5fb2a75c6a98$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $41be5fb2a75c6a98$var$abort
};
const $41be5fb2a75c6a98$var$doNotBlock = {};
function $41be5fb2a75c6a98$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $41be5fb2a75c6a98$var$doNotBlock : $41be5fb2a75c6a98$var$block;
}

});

parcelRegister("bm7hu", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $5fec2f058089612d$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $5fec2f058089612d$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $5fec2f058089612d$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $5fec2f058089612d$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $5fec2f058089612d$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $5fec2f058089612d$var$gridSize = 8;
const $5fec2f058089612d$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $5fec2f058089612d$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $5fec2f058089612d$var$lineHeights = {
    default: $5fec2f058089612d$var$heights.default,
    compact: $5fec2f058089612d$var$heights.compact,
    none: 'inherit'
};
const $5fec2f058089612d$var$padding = {
    // 10px gutter
    default: `0 ${$5fec2f058089612d$var$gridSize + $5fec2f058089612d$var$gridSize / 4}px`,
    compact: `0 ${$5fec2f058089612d$var$gridSize + $5fec2f058089612d$var$gridSize / 4}px`,
    none: '0'
};
const $5fec2f058089612d$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$5fec2f058089612d$var$gridSize / 4}px`,
    default: `0 ${$5fec2f058089612d$var$gridSize / 4}px`,
    none: '0'
};
const $5fec2f058089612d$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $5fec2f058089612d$var$innerMargin = {
    content: `0 ${$5fec2f058089612d$var$gridSize / 4}px`,
    icon: `0 ${$5fec2f058089612d$var$gridSize / 4}px`
};
const $5fec2f058089612d$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $5fec2f058089612d$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$5fec2f058089612d$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $5fec2f058089612d$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const $5fec2f058089612d$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const $5fec2f058089612d$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $5fec2f058089612d$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const $5fec2f058089612d$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const $5fec2f058089612d$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $5fec2f058089612d$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$5fec2f058089612d$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $5fec2f058089612d$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $5fec2f058089612d$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $5fec2f058089612d$var$heights[spacing],
        lineHeight: $5fec2f058089612d$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $5fec2f058089612d$var$singleIconPadding[spacing] : $5fec2f058089612d$var$padding[spacing],
        verticalAlign: $5fec2f058089612d$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $5fec2f058089612d$var$selectedStyles : {
            ...appearance === 'default' && $5fec2f058089612d$var$defaultStyles,
            ...appearance === 'primary' && $5fec2f058089612d$var$primaryStyles,
            ...appearance === 'link' && $5fec2f058089612d$var$linkStyles,
            ...appearance === 'subtle' && $5fec2f058089612d$var$subtleStyles,
            ...appearance === 'subtle-link' && $5fec2f058089612d$var$subtleLinkStyles,
            ...appearance === 'warning' && $5fec2f058089612d$var$warningStyles,
            ...appearance === 'danger' && $5fec2f058089612d$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $5fec2f058089612d$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $5fec2f058089612d$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $5fec2f058089612d$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                }
            },
            ...$5fec2f058089612d$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $5fec2f058089612d$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $1NIU8.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $5fec2f058089612d$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $5fec2f058089612d$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $5fec2f058089612d$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $5fec2f058089612d$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $5fec2f058089612d$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});

parcelRegister("3Ut2N", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $c44000c04c6038f0$export$20bbd2efb0d734c4);

var $eJOHy = parcelRequire("eJOHy");

var $hk2S7 = parcelRequire("hk2S7");
const $c44000c04c6038f0$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $eJOHy.isValidElement)(children) && children.type === (0, $hk2S7.default);
};

});


parcelRegister("gAC1H", function(module, exports) {
$parcel$export(module.exports, "default", () => $34c5bc537f914e2b$export$2e2bcd8739ae039);

var $3Ut2N = parcelRequire("3Ut2N");
function $34c5bc537f914e2b$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $3Ut2N.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("bscf6", function(module, exports) {
$parcel$export(module.exports, "default", () => $1269a62bc9b845cd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6AidT = parcelRequire("6AidT");
function $1269a62bc9b845cd$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $1269a62bc9b845cd$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6AidT.default), {
        size: size,
        label: ", Loading",
        appearance: $1269a62bc9b845cd$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("6AidT", function(module, exports) {
$parcel$export(module.exports, "default", () => $df2c1c5a0a9d4ea9$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8MFTW = parcelRequire("8MFTW");


var $2s1i8 = parcelRequire("2s1i8");
/**
 * Returns the appropriate circle stroke color.
 */ function $df2c1c5a0a9d4ea9$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? `var(--ds-icon-subtle, ${0, $5d8ec86348a5c657$export$c39c0fe0f26207ae})` : `var(--ds-icon-inverse, ${0, $5d8ec86348a5c657$export$29a4f05edc054374})`;
}
const $df2c1c5a0a9d4ea9$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $df2c1c5a0a9d4ea9$var$loadIn = null;
const $df2c1c5a0a9d4ea9$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $df2c1c5a0a9d4ea9$var$useLayoutEffect = typeof window === 'undefined' ? (0, $eJOHy.useEffect) : (0, $eJOHy.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $df2c1c5a0a9d4ea9$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $2s1i8.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $df2c1c5a0a9d4ea9$var$getStrokeColor(appearance);
    const context = (0, $eJOHy.useContext)((0, $8MFTW.default));
    $df2c1c5a0a9d4ea9$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $hcewu.default)([
            $df2c1c5a0a9d4ea9$var$styles.wrapperStyles,
            $df2c1c5a0a9d4ea9$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $hcewu.default)([
                $df2c1c5a0a9d4ea9$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $hcewu.default)([
                    $df2c1c5a0a9d4ea9$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $df2c1c5a0a9d4ea9$export$2e2bcd8739ae039 = $df2c1c5a0a9d4ea9$var$Spinner;

});
parcelRegister("2s1i8", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $bb66723345350fbc$export$4e9f1640bbe7a1a8);
const $bb66723345350fbc$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("3pDT1", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $9baad76d94f8c86e$export$643db0b8d8778e);
$parcel$export(module.exports, "defaultThemeFn", () => $9baad76d94f8c86e$export$437a7f77d13d7916);
$parcel$export(module.exports, "default", () => $9baad76d94f8c86e$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $58O8Z = parcelRequire("58O8Z");

var $bm7hu = parcelRequire("bm7hu");
const $9baad76d94f8c86e$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $9baad76d94f8c86e$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', mode: mode = 'light', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $bm7hu.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $9baad76d94f8c86e$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $9baad76d94f8c86e$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $9baad76d94f8c86e$export$437a7f77d13d7916(current, values) {
    return current(values);
}
const $9baad76d94f8c86e$var$Theme = (0, $58O8Z.createTheme)((themeProps)=>({
        buttonStyles: $9baad76d94f8c86e$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9baad76d94f8c86e$export$2e2bcd8739ae039 = $9baad76d94f8c86e$var$Theme;

});


parcelRegister("ahonG", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $2b527e9fc3af3a68$export$59e42969c95d314);
$parcel$export(module.exports, "flagIconColor", () => $2b527e9fc3af3a68$export$7f70afe2167f8235);
$parcel$export(module.exports, "flagIconGlyph", () => $2b527e9fc3af3a68$export$73f08aee70487cd4);
$parcel$export(module.exports, "flagTextColor", () => $2b527e9fc3af3a68$export$f50075b2584087f);
$parcel$export(module.exports, "flagTextColorToken", () => $2b527e9fc3af3a68$export$13b42cd9d596bfe0);
$parcel$export(module.exports, "actionBackgroundColor", () => $2b527e9fc3af3a68$export$81ba6b63eedb299f);
$parcel$export(module.exports, "actionTextColor", () => $2b527e9fc3af3a68$export$7bcfe3cca4dd78b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $akCIa = parcelRequire("akCIa");

var $dZGdK = parcelRequire("dZGdK");

var $eIpuh = parcelRequire("eIpuh");

var $fumm9 = parcelRequire("fumm9");

const $2b527e9fc3af3a68$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
const $2b527e9fc3af3a68$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};
const $2b527e9fc3af3a68$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($akCIa))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZGdK))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #292A2E)"
    }),
    normal: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZGdK))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-subtle, ${(0, $5d8ec86348a5c657$export$c39c0fe0f26207ae)})`,
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eIpuh))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #5B7F24)"
    }),
    warning: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fumm9))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-warning-inverse, ${(0, $5d8ec86348a5c657$export$ad0bacf983b7ddaa)})`,
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #FBC828)"
    })
};
const $2b527e9fc3af3a68$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
const $2b527e9fc3af3a68$export$13b42cd9d596bfe0 = {
    error: `var(--ds-text-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`,
    info: `var(--ds-text-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`,
    normal: `var(--ds-text, ${(0, $5d8ec86348a5c657$export$7d61b15e0da132af)})`,
    success: `var(--ds-text-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $5d8ec86348a5c657$export$ad0bacf983b7ddaa)})`
};
const $2b527e9fc3af3a68$export$81ba6b63eedb299f = {
    success: {
        default: `var(--ds-background-inverse-subtle, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`
    },
    info: {
        default: `var(--ds-background-inverse-subtle, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`
    },
    error: {
        default: `var(--ds-background-inverse-subtle, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`
    },
    warning: {
        default: `var(--ds-background-inverse-subtle, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $5d8ec86348a5c657$export$920c0d5c49070351)})`
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
const $2b527e9fc3af3a68$export$7bcfe3cca4dd78b6 = {
    success: `var(--ds-text-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`,
    info: `var(--ds-text-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`,
    error: `var(--ds-text-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $5d8ec86348a5c657$export$ad0bacf983b7ddaa)})`,
    normal: `var(--ds-link, ${(0, $5d8ec86348a5c657$export$b3de0ae08da2ce64)})`
};

});


parcelRegister("1kIJP", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $55b1d30c87543655$export$e91ea202abb66350);
$parcel$export(module.exports, "default", () => $55b1d30c87543655$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2w7cu = parcelRequire("2w7cu");

var $2JrCM = parcelRequire("2JrCM");
var $bm3QZ = parcelRequire("bm3QZ");

var $kiiKi = parcelRequire("kiiKi");

var $aIHSx = parcelRequire("aIHSx");

var $hk2S7 = parcelRequire("hk2S7");
const $55b1d30c87543655$export$1eee5ddc4f6d41c5 = 400;
const $55b1d30c87543655$var$defaultFlagGroupContext = {
    onDismissed: (0, $2w7cu.default),
    isDismissAllowed: false
};
const $55b1d30c87543655$export$c57ba665aaa722be = /*#__PURE__*/ (0, $eJOHy.createContext)($55b1d30c87543655$var$defaultFlagGroupContext);
function $55b1d30c87543655$export$e91ea202abb66350() {
    return (0, $eJOHy.useContext)($55b1d30c87543655$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $55b1d30c87543655$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $55b1d30c87543655$var$dismissAllowedStyles = null;
const $55b1d30c87543655$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ const $55b1d30c87543655$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $2w7cu.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $eJOHy.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $eJOHy.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bm3QZ.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $hcewu.default)([
                            $55b1d30c87543655$var$groupStyles.root,
                            index === 0 && $55b1d30c87543655$var$groupStyles.first,
                            index === 1 && $55b1d30c87543655$var$groupStyles.second,
                            index >= 1 && $55b1d30c87543655$var$groupStyles.nth,
                            index >= 2 && $55b1d30c87543655$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)($55b1d30c87543655$export$c57ba665aaa722be.Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : $55b1d30c87543655$var$defaultFlagGroupContext,
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const flags = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $hcewu.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hk2S7.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(LabelTag, {
                    children: label
                })
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2JrCM.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kiiKi.default), {
        zIndex: (0, $aIHSx.layers).flag(),
        children: flags
    });
};
var $55b1d30c87543655$export$2e2bcd8739ae039 = $55b1d30c87543655$var$FlagGroup;

});
parcelRegister("2JrCM", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $3507c3e4a3c6ba3c$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $3507c3e4a3c6ba3c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
// We define empty context here so the object doesn't change.
const $3507c3e4a3c6ba3c$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $3507c3e4a3c6ba3c$var$ExitingContext = /*#__PURE__*/ (0, $eJOHy.createContext)($3507c3e4a3c6ba3c$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $3507c3e4a3c6ba3c$var$wrapChildWithContextProvider = (child, value = $3507c3e4a3c6ba3c$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($3507c3e4a3c6ba3c$var$ExitingContext.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $3507c3e4a3c6ba3c$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $eJOHy.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $3507c3e4a3c6ba3c$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $3507c3e4a3c6ba3c$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $3507c3e4a3c6ba3c$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $3507c3e4a3c6ba3c$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $3507c3e4a3c6ba3c$var$ExitingPersistence = /*#__PURE__*/ (0, $eJOHy.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $eJOHy.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $eJOHy.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $eJOHy.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $eJOHy.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
		 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
		 * useState is mocked to return a boolean value.
		 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $3507c3e4a3c6ba3c$var$childrenToArray(previousChildren);
    const current = $3507c3e4a3c6ba3c$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const missingKeys = $3507c3e4a3c6ba3c$var$getMissingKeys(current, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $3507c3e4a3c6ba3c$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $3507c3e4a3c6ba3c$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$3507c3e4a3c6ba3c$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $3507c3e4a3c6ba3c$export$3b6f38abbdcbd000 = ()=>{
    return (0, $eJOHy.useContext)($3507c3e4a3c6ba3c$var$ExitingContext);
};
$3507c3e4a3c6ba3c$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $3507c3e4a3c6ba3c$export$2e2bcd8739ae039 = $3507c3e4a3c6ba3c$var$ExitingPersistence;

});

parcelRegister("bm3QZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc5fc4faf2c98277$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cKE0K = parcelRequire("cKE0K");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ const $dc5fc4faf2c98277$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cKE0K.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $dc5fc4faf2c98277$export$2e2bcd8739ae039 = $dc5fc4faf2c98277$var$SlideIn;

});
parcelRegister("cKE0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $d79468203c2911f6$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1LruV = parcelRequire("1LruV");

var $fokc3 = parcelRequire("fokc3");

var $3iYpY = parcelRequire("3iYpY");

var $2JrCM = parcelRequire("2JrCM");

var $8XJoG = parcelRequire("8XJoG");
const $d79468203c2911f6$var$zoomIn = null;
const $d79468203c2911f6$var$zoomOut = null;
const $d79468203c2911f6$var$fadeIn = null;
const $d79468203c2911f6$var$fadeOut = null;
const $d79468203c2911f6$var$fadeInFromTop = null;
const $d79468203c2911f6$var$fadeOutFromTop = null;
const $d79468203c2911f6$var$fadeInFromLeft = null;
const $d79468203c2911f6$var$fadeOutFromLeft = null;
const $d79468203c2911f6$var$fadeInFromBottom = null;
const $d79468203c2911f6$var$fadeOutFromBottom = null;
const $d79468203c2911f6$var$fadeInFromRight = null;
const $d79468203c2911f6$var$fadeOutFromRight = null;
const $d79468203c2911f6$var$fadeInFromTopConstant = null;
const $d79468203c2911f6$var$fadeOutFromTopConstant = null;
const $d79468203c2911f6$var$fadeInFromLeftConstant = null;
const $d79468203c2911f6$var$fadeOutFromLeftConstant = null;
const $d79468203c2911f6$var$fadeInFromBottomConstant = null;
const $d79468203c2911f6$var$fadeOutFromBottomConstant = null;
const $d79468203c2911f6$var$fadeInFromRightConstant = null;
const $d79468203c2911f6$var$fadeOutFromRightConstant = null;
const $d79468203c2911f6$var$slideInFromTop = null;
const $d79468203c2911f6$var$slideOutFromTop = null;
const $d79468203c2911f6$var$slideInFromRight = null;
const $d79468203c2911f6$var$slideOutFromRight = null;
const $d79468203c2911f6$var$slideInFromBottom = null;
const $d79468203c2911f6$var$slideOutFromBottom = null;
const $d79468203c2911f6$var$slideInFromLeft = null;
const $d79468203c2911f6$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $d79468203c2911f6$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $8XJoG.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $2JrCM.useExitingPersistence)();
    const setTimeout = (0, $3iYpY.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $eJOHy.useState)(appear);
    (0, $eJOHy.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $1LruV.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $fokc3.exitingDurations)[duration] : (0, $fokc3.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $hcewu.default)([
            (0, $hcewu.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $hcewu.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $hcewu.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $hcewu.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $hcewu.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $hcewu.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $hcewu.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $hcewu.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $hcewu.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $hcewu.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $hcewu.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $hcewu.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $hcewu.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $hcewu.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $hcewu.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $hcewu.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $hcewu.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $hcewu.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $hcewu.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $hcewu.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $hcewu.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $hcewu.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $hcewu.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $hcewu.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $hcewu.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $hcewu.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $hcewu.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $hcewu.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $hcewu.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $hcewu.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $hcewu.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $hcewu.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $hcewu.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $hcewu.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $hcewu.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $hcewu.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $hcewu.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $hcewu.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $hcewu.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $hcewu.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $hcewu.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $hcewu.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $hcewu.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $hcewu.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $hcewu.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $hcewu.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $hcewu.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $hcewu.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $hcewu.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $hcewu.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $hcewu.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $d79468203c2911f6$export$2e2bcd8739ae039 = $d79468203c2911f6$var$EnteringMotion;

});
parcelRegister("1LruV", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $dcc8cfdbe553ee88$export$b7baf7667a68d87c);
$parcel$export(module.exports, "useIsReducedMotion", () => $dcc8cfdbe553ee88$export$c537e63161742ce3);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $dcc8cfdbe553ee88$export$f0f789643ba5a83c);
$parcel$export(module.exports, "prefersReducedMotion", () => $dcc8cfdbe553ee88$export$ff7706047246b98b);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");
const $dcc8cfdbe553ee88$var$isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;
const $dcc8cfdbe553ee88$export$b7baf7667a68d87c = ()=>{
    if (!$dcc8cfdbe553ee88$var$isMatchMediaAvailable()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};
const $dcc8cfdbe553ee88$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $eJOHy.useState)($dcc8cfdbe553ee88$export$b7baf7667a68d87c);
    (0, $eJOHy.useEffect)(()=>{
        if (!$dcc8cfdbe553ee88$var$isMatchMediaAvailable()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $4eDgu.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
const $dcc8cfdbe553ee88$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
const $dcc8cfdbe553ee88$export$ff7706047246b98b = ()=>$dcc8cfdbe553ee88$export$f0f789643ba5a83c;

});

parcelRegister("fokc3", function(module, exports) {
$parcel$export(module.exports, "durations", () => $37a8fdfe3acaa8ca$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $37a8fdfe3acaa8ca$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $37a8fdfe3acaa8ca$export$368bacef0dacbe05 = 25;
const $37a8fdfe3acaa8ca$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $37a8fdfe3acaa8ca$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $37a8fdfe3acaa8ca$export$30fa1a2e62ae150c = {
    none: $37a8fdfe3acaa8ca$export$38b928a7167ce124.none,
    small: $37a8fdfe3acaa8ca$export$38b928a7167ce124.small * $37a8fdfe3acaa8ca$var$EXITING_MOTION_MULTIPLIER,
    medium: $37a8fdfe3acaa8ca$export$38b928a7167ce124.medium * $37a8fdfe3acaa8ca$var$EXITING_MOTION_MULTIPLIER,
    large: $37a8fdfe3acaa8ca$export$38b928a7167ce124.large * $37a8fdfe3acaa8ca$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("3iYpY", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $5f6cb718efcb2c50$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $5f6cb718efcb2c50$export$4f34107a2b00f39c);

var $eJOHy = parcelRequire("eJOHy");
const $5f6cb718efcb2c50$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $5f6cb718efcb2c50$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $eJOHy.useRef)([]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $5f6cb718efcb2c50$var$getHookDeps(opts));
    return (0, $eJOHy.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
const $5f6cb718efcb2c50$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $eJOHy.useRef)([]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $5f6cb718efcb2c50$var$getHookDeps(opts));
    return (0, $eJOHy.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("8XJoG", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $d6ad4e1f33ac0222$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $d6ad4e1f33ac0222$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2w7cu = parcelRequire("2w7cu");

var $6s6qN = parcelRequire("6s6qN");

var $WaB64 = parcelRequire("WaB64");
const $d6ad4e1f33ac0222$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $eJOHy.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $2w7cu.default)
    }));
const $d6ad4e1f33ac0222$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $WaB64.useUniqueId)();
    const context = (0, $eJOHy.useContext)($d6ad4e1f33ac0222$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $d6ad4e1f33ac0222$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $eJOHy.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $eJOHy.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $6s6qN.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d6ad4e1f33ac0222$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var $d6ad4e1f33ac0222$export$2e2bcd8739ae039 = $d6ad4e1f33ac0222$var$StaggeredEntrance;

});
parcelRegister("6s6qN", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $34739887dae135c8$export$e5c5a5f917a5871c);

var $eJOHy = parcelRequire("eJOHy");
const $34739887dae135c8$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $eJOHy.useEffect) : (0, $eJOHy.useLayoutEffect);

});

parcelRegister("WaB64", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $a1af8bbaa9dcf713$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $eJOHy = parcelRequire("eJOHy");
function $a1af8bbaa9dcf713$export$c485849f2e393253() {
    const identifier = (0, $eJOHy.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("kiiKi", function(module, exports) {
$parcel$export(module.exports, "default", () => $d28bfdb1d06404b4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $91hOG = parcelRequire("91hOG");

var $gcX7x = parcelRequire("gcX7x");

var $eAviz = parcelRequire("eAviz");

var $g0knw = parcelRequire("g0knw");

var $kBaW3 = parcelRequire("kBaW3");
function $d28bfdb1d06404b4$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $g0knw.default)(mountStrategy);
    (0, $kBaW3.default)(zIndex);
    return !(0, $91hOG.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gcX7x.default), {
        zIndex: zIndex,
        children: children
    }) : null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eAviz.default), {
        zIndex: zIndex,
        children: children
    });
}

});
parcelRegister("gcX7x", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ad176d822bc2d0d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $ffBf3 = parcelRequire("ffBf3");
function $8ad176d822bc2d0d$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $eJOHy.useMemo)(()=>(0, $ffBf3.createContainer)(zIndex), [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $ffBf3.appendPortalContainerIfNotAppended)(container);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            (0, $ffBf3.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aQK2r.createPortal)(children, container);
}

});
parcelRegister("ffBf3", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $68ff3bd40a56ee20$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $68ff3bd40a56ee20$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $68ff3bd40a56ee20$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $68ff3bd40a56ee20$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $68ff3bd40a56ee20$export$95029ca7aca2989e);

const $68ff3bd40a56ee20$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $0139489ca8ea5bd0$export$13f57c02915787b3);
    container.style.zIndex = `${zIndex}`;
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $68ff3bd40a56ee20$var$getBody = ()=>{
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ const $68ff3bd40a56ee20$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $0139489ca8ea5bd0$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $0139489ca8ea5bd0$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $68ff3bd40a56ee20$var$getBody()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $68ff3bd40a56ee20$export$da99f98bf3fe55b3 = (container)=>{
    $68ff3bd40a56ee20$var$getPortalParent().removeChild(container);
};
const $68ff3bd40a56ee20$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $68ff3bd40a56ee20$var$getPortalParent().appendChild(container);
};
const $68ff3bd40a56ee20$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $68ff3bd40a56ee20$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($68ff3bd40a56ee20$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $0139489ca8ea5bd0$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};
const $68ff3bd40a56ee20$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($68ff3bd40a56ee20$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $0139489ca8ea5bd0$export$72f415121273627e));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $0139489ca8ea5bd0$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            $68ff3bd40a56ee20$var$getBody()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});
const $0139489ca8ea5bd0$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $0139489ca8ea5bd0$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $0139489ca8ea5bd0$export$13f57c02915787b3 = 'atlaskit-portal';



parcelRegister("eAviz", function(module, exports) {
$parcel$export(module.exports, "default", () => $cba2e003aaaf0ce4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $9IA0D = parcelRequire("9IA0D");

var $ffBf3 = parcelRequire("ffBf3");
function $cba2e003aaaf0ce4$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $eJOHy.useState)(null);
    (0, $9IA0D.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $ffBf3.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $ffBf3.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $aQK2r.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("9IA0D", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $80193c89aa960ce4$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
const $80193c89aa960ce4$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $eJOHy.useLayoutEffect) : (0, $eJOHy.useEffect);

});


parcelRegister("g0knw", function(module, exports) {
$parcel$export(module.exports, "default", () => $b937423e6dff606d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9IA0D = parcelRequire("9IA0D");
const $b937423e6dff606d$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $eJOHy.useState)(false);
    const [useMountEffect] = (0, $eJOHy.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $9IA0D.useIsomorphicLayoutEffect) : (0, $eJOHy.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $b937423e6dff606d$export$2e2bcd8739ae039 = $b937423e6dff606d$var$useIsSubsequentRender;

});

parcelRegister("kBaW3", function(module, exports) {
$parcel$export(module.exports, "default", () => $61bc4a76d8396b29$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $iasBq = parcelRequire("iasBq");
const $61bc4a76d8396b29$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $eJOHy.useEffect)(()=>{
        (0, $iasBq.default)((0, $90a9eddfce0c3200$export$ed5835cc67e87f72), zIndexNumber);
        return ()=>{
            (0, $iasBq.default)((0, $90a9eddfce0c3200$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $61bc4a76d8396b29$export$2e2bcd8739ae039 = $61bc4a76d8396b29$var$useFirePortalEvent;

});
const $90a9eddfce0c3200$export$ed5835cc67e87f72 = 'akPortalMount';
const $90a9eddfce0c3200$export$80816bd900e5bd00 = 'akPortalUnmount';

parcelRegister("iasBq", function(module, exports) {
$parcel$export(module.exports, "default", () => $df9c35f74c7a8ac3$export$2e2bcd8739ae039);
const $df9c35f74c7a8ac3$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $df9c35f74c7a8ac3$var$getLayerName = (zIndex)=>{
    return $df9c35f74c7a8ac3$var$zIndexToName.hasOwnProperty(zIndex) ? $df9c35f74c7a8ac3$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $df9c35f74c7a8ac3$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $df9c35f74c7a8ac3$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $df9c35f74c7a8ac3$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $df9c35f74c7a8ac3$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("aIHSx", function(module, exports) {
$parcel$export(module.exports, "noFocusRing", () => $98a0405056ab44a6$export$c0dd343266bc3261);
$parcel$export(module.exports, "layers", () => $98a0405056ab44a6$export$7be255094ccdc533);
$parcel$export(module.exports, "skeletonShimmer", () => $98a0405056ab44a6$export$e497e856b4f89fcd);

var $9JWQE = parcelRequire("9JWQE");

const $98a0405056ab44a6$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $98a0405056ab44a6$export$c93026a968943f95 = 'light';
const $98a0405056ab44a6$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $98a0405056ab44a6$export$8e24544ddba725ee = (color = `var(--ds-border-focused, ${0, $5d8ec86348a5c657$export$215b7063051591f1})`, outlineWidth = 2)=>{
    (0, $9JWQE.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $98a0405056ab44a6$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $98a0405056ab44a6$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $98a0405056ab44a6$export$a1b3edb637fb4f35 = ()=>{
    (0, $9JWQE.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $98a0405056ab44a6$export$ba1d834b86d72a09 = $98a0405056ab44a6$export$a1b3edb637fb4f35;
const $98a0405056ab44a6$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: `var(--ds-skeleton, ${0, $5d8ec86348a5c657$export$8d43898f60b96a82})`,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: `var(--ds-skeleton, ${0, $5d8ec86348a5c657$export$8d43898f60b96a82})`
            },
            to: {
                backgroundColor: `var(--ds-skeleton-subtle, ${0, $5d8ec86348a5c657$export$920c0d5c49070351})`
            }
        }
    });

});
parcelRegister("9JWQE", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c2464d45c02a39a$export$2e2bcd8739ae039);

var $fiHgw = parcelRequire("fiHgw");

var $igDjg = parcelRequire("igDjg");
function $9c2464d45c02a39a$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $fiHgw.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}
function $9c2464d45c02a39a$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $igDjg;
}

});
parcelRegister("fiHgw", function(module, exports) {
$parcel$export(module.exports, "default", () => $a651566277eeb70b$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $a651566277eeb70b$var$printed = {};
function $a651566277eeb70b$export$2e2bcd8739ae039(message) {
    if ($a651566277eeb70b$var$printed[message]) return;
    $a651566277eeb70b$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});




parcelRegister("emXjk", function(module, exports) {
$parcel$export(module.exports, "default", () => $6733b4f34632e830$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $c0JOE = parcelRequire("c0JOE");

var $fOPPX = parcelRequire("fOPPX");

var $1rran = parcelRequire("1rran");

var $9lUef = parcelRequire("9lUef");

var $ahonG = parcelRequire("ahonG");
const $6733b4f34632e830$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($9lUef)));
    let buttonLabel = 'Dismiss';
    let size = 'small';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($1rran))) : (0, (/*@__PURE__*/$parcel$interopDefault($fOPPX)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c0JOE.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)(ButtonIcon, {
                ...iconProps,
                LEGACY_size: size,
                size: "small",
                label: "",
                color: (0, $ahonG.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $6733b4f34632e830$var$DismissButton = /*#__PURE__*/ (0, $eJOHy.memo)($6733b4f34632e830$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6733b4f34632e830$export$2e2bcd8739ae039 = $6733b4f34632e830$var$DismissButton;

});
parcelRegister("c0JOE", function(module, exports) {
$parcel$export(module.exports, "default", () => $81586e20e39e32f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7zosp = parcelRequire("7zosp");

var $k0cow = parcelRequire("k0cow");

var $hk2S7 = parcelRequire("hk2S7");

var $bnaqA = parcelRequire("bnaqA");

var $lrFzB = parcelRequire("lrFzB");

var $lbqGH = parcelRequire("lbqGH");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $81586e20e39e32f3$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bnaqA.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lrFzB.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lbqGH.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hk2S7.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k0cow.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bnaqA.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $7zosp.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lrFzB.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lbqGH.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hk2S7.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$81586e20e39e32f3$var$IconButton.displayName = 'IconButton';
var $81586e20e39e32f3$export$2e2bcd8739ae039 = $81586e20e39e32f3$var$IconButton;

});
parcelRegister("7zosp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0b1c78518fd7c22$export$2e2bcd8739ae039);
function $d0b1c78518fd7c22$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("k0cow", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba25d542612bb257$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $b1YLR = parcelRequire("b1YLR");

var $2w7cu = parcelRequire("2w7cu");

var $9PByu = parcelRequire("9PByu");

var $dtOeL = parcelRequire("dtOeL");

var $dAEnZ = parcelRequire("dAEnZ");

var $2JrCM = parcelRequire("2JrCM");
var $eN6pO = parcelRequire("eN6pO");

var $e0ZfU = parcelRequire("e0ZfU");

var $kiiKi = parcelRequire("kiiKi");

var $aIHSx = parcelRequire("aIHSx");

var $3NjXI = parcelRequire("3NjXI");

var $hEp9g = parcelRequire("hEp9g");

var $eKuYD = parcelRequire("eKuYD");

var $JgdAF = parcelRequire("JgdAF");

var $cTxYb = parcelRequire("cTxYb");
const $ba25d542612bb257$var$tooltipZIndex = (0, $aIHSx.layers).tooltip();
const $ba25d542612bb257$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $ba25d542612bb257$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $ba25d542612bb257$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $ba25d542612bb257$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $JgdAF.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $2w7cu.default), onHide: onHide = (0, $2w7cu.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $b1YLR.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$ba25d542612bb257$var$analyticsAttributes
    });
    const onHideHandler = (0, $b1YLR.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$ba25d542612bb257$var$analyticsAttributes
    });
    const apiRef = (0, $eJOHy.useRef)(null);
    const [state, setState] = (0, $eJOHy.useState)('hide');
    const targetRef = (0, $eJOHy.useRef)(null);
    const containerRef = (0, $eJOHy.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $eJOHy.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $dtOeL.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $dtOeL.default)(onShowHandler);
    const onHideHandlerStable = (0, $dtOeL.default)(onHideHandler);
    const delayStable = (0, $dtOeL.default)(delay);
    const canAppearStable = (0, $dtOeL.default)(canAppear);
    const hasCalledShowHandler = (0, $eJOHy.useRef)(false);
    const start = (0, $eJOHy.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $eJOHy.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $eJOHy.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $eJOHy.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        return (0, $3NjXI.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $eJOHy.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $hEp9g.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    const hideTooltipOnEsc = (0, $eJOHy.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $9PByu.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $eJOHy.useEffect)(()=>{
        if (state === 'hide') return 0, $2w7cu.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $4eDgu.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $eJOHy.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $cTxYb.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $eJOHy.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $cTxYb.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $eJOHy.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $eJOHy.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $eJOHy.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $eJOHy.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $eJOHy.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $dAEnZ.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $eKuYD.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $eJOHy.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : // @ts-ignore
            /*#__PURE__*/ (0, $gt9Am.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kiiKi.default), {
                zIndex: $ba25d542612bb257$var$tooltipZIndex,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e0ZfU.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = position === 'mouse' ? undefined : $ba25d542612bb257$var$invertedDirection[$ba25d542612bb257$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2JrCM.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eN6pO.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $ba25d542612bb257$export$2e2bcd8739ae039 = $ba25d542612bb257$var$Tooltip;

});
parcelRegister("b1YLR", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $e6555a90a032aa2a$export$1a04351537078b55);

var $eJOHy = parcelRequire("eJOHy");

var $iFaP4 = parcelRequire("iFaP4");

var $5YL9v = parcelRequire("5YL9v");
function $e6555a90a032aa2a$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $5YL9v.useTrackedRef)(analyticsData);
    const fnRef = (0, $5YL9v.useTrackedRef)(fn);
    const handler = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("9PByu", function(module, exports) {
$parcel$export(module.exports, "default", () => $714369b4f666329d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

function $714369b4f666329d$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eJOHy.useRef)(false);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $331378e6eb9d51ed$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $eJOHy.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $4eDgu.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $331378e6eb9d51ed$export$390330c10ff2b9a1 = 'ArrowUp';
const $331378e6eb9d51ed$export$a80636c6f41931fe = 'ArrowDown';
const $331378e6eb9d51ed$export$4af703091671bc = 'Home';
const $331378e6eb9d51ed$export$e2bc30913faa5db7 = 'End';
const $331378e6eb9d51ed$export$10f6869ed0a7d75b = 'Tab';
const $331378e6eb9d51ed$export$8152f929a25a0ff4 = 'Enter';
const $331378e6eb9d51ed$export$e51a3576c045c8d5 = 'Space';
const $331378e6eb9d51ed$export$2bb790b9008907b4 = 'Escape';


parcelRegister("dtOeL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8f73b98a762f0a2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $e8f73b98a762f0a2$export$2e2bcd8739ae039(value) {
    const ref = (0, $eJOHy.useRef)(value);
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("dAEnZ", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $9f3edcd002a5c368$export$469bb693f11edc7f);

var $eJOHy = parcelRequire("eJOHy");

var $iYR7o = parcelRequire("iYR7o");

var $fLLwJ = parcelRequire("fLLwJ");
function $9f3edcd002a5c368$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose }) {
    const context = (0, $eJOHy.useContext)((0, $iYR7o.OpenLayerObserverContext));
    const namespace = (0, $fLLwJ.useOpenLayerObserverNamespace)();
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("iYR7o", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $aa47921c749e1675$export$5fbf4d7fae6cdc00);

var $eJOHy = parcelRequire("eJOHy");
const $aa47921c749e1675$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});

parcelRegister("fLLwJ", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $4a4d03917eb59983$export$1d57e79091cc3046);

var $eJOHy = parcelRequire("eJOHy");

var $lmQWP = parcelRequire("lmQWP");
function $4a4d03917eb59983$export$1d57e79091cc3046() {
    const namespace = (0, $eJOHy.useContext)((0, $lmQWP.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("lmQWP", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $7eb02b6debb36104$export$644a49f3b8c50fcd);

var $eJOHy = parcelRequire("eJOHy");
const $7eb02b6debb36104$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});



parcelRegister("eN6pO", function(module, exports) {
$parcel$export(module.exports, "default", () => $7af552d80c12e59f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cKE0K = parcelRequire("cKE0K");
const $7af552d80c12e59f$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $7af552d80c12e59f$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $7af552d80c12e59f$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cKE0K.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $7af552d80c12e59f$export$2e2bcd8739ae039 = $7af552d80c12e59f$var$FadeIn;

});

parcelRegister("e0ZfU", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $9fbd7021e24659e4$export$badac9ada3a0bdf9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $h7FjD = parcelRequire("h7FjD");

var $lAyXp = parcelRequire("lAyXp");

var $5AzHI = parcelRequire("5AzHI");
const $9fbd7021e24659e4$var$viewportPadding = 5;
const $9fbd7021e24659e4$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $9fbd7021e24659e4$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $9fbd7021e24659e4$var$defaultChildrenFn() {
    return null;
}
const $9fbd7021e24659e4$var$defaultOffset = [
    0,
    8
];
function $9fbd7021e24659e4$export$badac9ada3a0bdf9({ children: children = $9fbd7021e24659e4$var$defaultChildrenFn, offset: offset = $9fbd7021e24659e4$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $eJOHy.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $9fbd7021e24659e4$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $lAyXp.getMaxSizeModifiers)({
            viewportPadding: $9fbd7021e24659e4$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$9fbd7021e24659e4$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $eJOHy.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h7FjD.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("h7FjD", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $c7732387e3db4027$export$badac9ada3a0bdf9);

var $eJOHy = parcelRequire("eJOHy");

var $bXUqf = parcelRequire("bXUqf");

var $7DgQQ = parcelRequire("7DgQQ");

var $h9DhJ = parcelRequire("h9DhJ");
var $c7732387e3db4027$var$NOOP = function NOOP() {
    return void 0;
};
var $c7732387e3db4027$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $c7732387e3db4027$var$EMPTY_MODIFIERS = [];
function $c7732387e3db4027$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $c7732387e3db4027$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eJOHy.useContext((0, $bXUqf.ManagerReferenceNodeContext));
    var _React$useState = $eJOHy.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eJOHy.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eJOHy.useEffect(function() {
        (0, $7DgQQ.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eJOHy.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $h9DhJ.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eJOHy.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $c7732387e3db4027$var$NOOP,
            update: update || $c7732387e3db4027$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $7DgQQ.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("bXUqf", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $8b60f8b1f09db516$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $8b60f8b1f09db516$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $8b60f8b1f09db516$export$d0d38e7dec7a1a61);

var $eJOHy = parcelRequire("eJOHy");
var $8b60f8b1f09db516$export$3dbd3405086fec7b = $eJOHy.createContext();
var $8b60f8b1f09db516$export$cbabb21c2529b130 = $eJOHy.createContext();
function $8b60f8b1f09db516$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eJOHy.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eJOHy.useRef(false);
    $eJOHy.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eJOHy.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eJOHy.createElement($8b60f8b1f09db516$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eJOHy.createElement($8b60f8b1f09db516$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("7DgQQ", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $58e93f3debf0c495$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $58e93f3debf0c495$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $58e93f3debf0c495$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $58e93f3debf0c495$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $58e93f3debf0c495$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
var $58e93f3debf0c495$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $58e93f3debf0c495$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $58e93f3debf0c495$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $58e93f3debf0c495$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $58e93f3debf0c495$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $58e93f3debf0c495$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;

});

parcelRegister("h9DhJ", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $c7d1c01e1a5e4f78$export$f4d5bf230a36dd6e);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $3y6fZ = parcelRequire("3y6fZ");

var $aVrYR = parcelRequire("aVrYR");

var $7DgQQ = parcelRequire("7DgQQ");
var $c7d1c01e1a5e4f78$var$EMPTY_MODIFIERS = [];
var $c7d1c01e1a5e4f78$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eJOHy.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $c7d1c01e1a5e4f78$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eJOHy.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eJOHy.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aQK2r.flushSync(function() {
                    setState({
                        styles: (0, $7DgQQ.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $7DgQQ.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eJOHy.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aVrYR)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eJOHy.useRef();
    (0, $7DgQQ.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $7DgQQ.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3y6fZ.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("3y6fZ", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $2959668ab75d560c$export$8f7491d57c8f97a9);

var $4drMc = parcelRequire("4drMc");

var $dRZce = parcelRequire("dRZce");

var $HPGsg = parcelRequire("HPGsg");

var $cXFBx = parcelRequire("cXFBx");

var $aCZ4M = parcelRequire("aCZ4M");

var $hSS18 = parcelRequire("hSS18");

var $filWH = parcelRequire("filWH");

var $4pUra = parcelRequire("4pUra");

var $hoIyB = parcelRequire("hoIyB");

var $cUZlK = parcelRequire("cUZlK");


var $2959668ab75d560c$export$d34966752335dd47 = [
    (0, $dRZce.default),
    (0, $HPGsg.default),
    (0, $cXFBx.default),
    (0, $aCZ4M.default),
    (0, $hSS18.default),
    (0, $filWH.default),
    (0, $4pUra.default),
    (0, $hoIyB.default),
    (0, $cUZlK.default)
];
var $2959668ab75d560c$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $4drMc.popperGenerator)({
    defaultModifiers: $2959668ab75d560c$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4drMc", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $311dec28ac591174$export$ed5e13716264f202);

var $iWbjU = parcelRequire("iWbjU");

var $gknHB = parcelRequire("gknHB");

var $hTauD = parcelRequire("hTauD");

var $jIy8Z = parcelRequire("jIy8Z");

var $hW8nJ = parcelRequire("hW8nJ");

var $9Wg0t = parcelRequire("9Wg0t");

var $e7Ukp = parcelRequire("e7Ukp");


var $kQRrr = parcelRequire("kQRrr");
var $311dec28ac591174$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $311dec28ac591174$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $311dec28ac591174$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $311dec28ac591174$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $311dec28ac591174$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $kQRrr.isElement)(reference) ? (0, $hTauD.default)(reference) : reference.contextElement ? (0, $hTauD.default)(reference.contextElement) : [],
                    popper: (0, $hTauD.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $hW8nJ.default)((0, $e7Ukp.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$311dec28ac591174$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $iWbjU.default)(reference, (0, $jIy8Z.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $gknHB.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9Wg0t.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$311dec28ac591174$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $311dec28ac591174$export$8f7491d57c8f97a9 = /*#__PURE__*/ $311dec28ac591174$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("iWbjU", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc966cb06c98b404$export$2e2bcd8739ae039);

var $36jD0 = parcelRequire("36jD0");

var $1NB9x = parcelRequire("1NB9x");

var $9XffG = parcelRequire("9XffG");

var $kQRrr = parcelRequire("kQRrr");

var $9GF4G = parcelRequire("9GF4G");

var $eXzHV = parcelRequire("eXzHV");

var $iiEOo = parcelRequire("iiEOo");

var $baNUm = parcelRequire("baNUm");
function $dc966cb06c98b404$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $baNUm.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $baNUm.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dc966cb06c98b404$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $kQRrr.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $kQRrr.isHTMLElement)(offsetParent) && $dc966cb06c98b404$var$isElementScaled(offsetParent);
    var documentElement = (0, $eXzHV.default)(offsetParent);
    var rect = (0, $36jD0.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9XffG.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $iiEOo.default)(documentElement)) scroll = (0, $1NB9x.default)(offsetParent);
        if ((0, $kQRrr.isHTMLElement)(offsetParent)) {
            offsets = (0, $36jD0.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $9GF4G.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("36jD0", function(module, exports) {
$parcel$export(module.exports, "default", () => $24212859a74f1852$export$2e2bcd8739ae039);

var $kQRrr = parcelRequire("kQRrr");

var $baNUm = parcelRequire("baNUm");

var $dUkib = parcelRequire("dUkib");

var $hXgRQ = parcelRequire("hXgRQ");
function $24212859a74f1852$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $kQRrr.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $baNUm.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $baNUm.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $kQRrr.isElement)(element) ? (0, $dUkib.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $hXgRQ.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("kQRrr", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $f2e21e6330ec746d$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $f2e21e6330ec746d$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $f2e21e6330ec746d$export$af51f0f06c0f328a);

var $dUkib = parcelRequire("dUkib");
function $f2e21e6330ec746d$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $dUkib.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f2e21e6330ec746d$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $dUkib.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f2e21e6330ec746d$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $dUkib.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("dUkib", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2003ef78eee7526$export$2e2bcd8739ae039);
function $a2003ef78eee7526$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("baNUm", function(module, exports) {
$parcel$export(module.exports, "max", () => $82275797e56019e5$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $82275797e56019e5$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $82275797e56019e5$export$2077e0241d6afd3c);
var $82275797e56019e5$export$8960430cfd85939f = Math.max;
var $82275797e56019e5$export$96ec731ed4dcb222 = Math.min;
var $82275797e56019e5$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("hXgRQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d12507e7c9d15a88$export$2e2bcd8739ae039);

var $byO21 = parcelRequire("byO21");
function $d12507e7c9d15a88$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $byO21.default)());
}

});
parcelRegister("byO21", function(module, exports) {
$parcel$export(module.exports, "default", () => $86a9aded965fc05b$export$2e2bcd8739ae039);
function $86a9aded965fc05b$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("1NB9x", function(module, exports) {
$parcel$export(module.exports, "default", () => $14f72fcf0bff2999$export$2e2bcd8739ae039);

var $caopt = parcelRequire("caopt");

var $dUkib = parcelRequire("dUkib");

var $kQRrr = parcelRequire("kQRrr");

var $7nqIP = parcelRequire("7nqIP");
function $14f72fcf0bff2999$export$2e2bcd8739ae039(node) {
    if (node === (0, $dUkib.default)(node) || !(0, $kQRrr.isHTMLElement)(node)) return (0, $caopt.default)(node);
    else return (0, $7nqIP.default)(node);
}

});
parcelRegister("caopt", function(module, exports) {
$parcel$export(module.exports, "default", () => $8db95a7b60b70ae4$export$2e2bcd8739ae039);

var $dUkib = parcelRequire("dUkib");
function $8db95a7b60b70ae4$export$2e2bcd8739ae039(node) {
    var win = (0, $dUkib.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("7nqIP", function(module, exports) {
$parcel$export(module.exports, "default", () => $55ef68d47da22b6e$export$2e2bcd8739ae039);
function $55ef68d47da22b6e$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("9XffG", function(module, exports) {
$parcel$export(module.exports, "default", () => $73f5747cf61e4f06$export$2e2bcd8739ae039);
function $73f5747cf61e4f06$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("9GF4G", function(module, exports) {
$parcel$export(module.exports, "default", () => $70d7e5dcce841316$export$2e2bcd8739ae039);

var $36jD0 = parcelRequire("36jD0");

var $eXzHV = parcelRequire("eXzHV");

var $caopt = parcelRequire("caopt");
function $70d7e5dcce841316$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $36jD0.default)((0, $eXzHV.default)(element)).left + (0, $caopt.default)(element).scrollLeft;
}

});
parcelRegister("eXzHV", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae4246255273b444$export$2e2bcd8739ae039);

var $kQRrr = parcelRequire("kQRrr");
function $ae4246255273b444$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $kQRrr.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("iiEOo", function(module, exports) {
$parcel$export(module.exports, "default", () => $d52990d0edaa0340$export$2e2bcd8739ae039);

var $3RTtM = parcelRequire("3RTtM");
function $d52990d0edaa0340$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3RTtM.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("3RTtM", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d115b5a595f58b4$export$2e2bcd8739ae039);

var $dUkib = parcelRequire("dUkib");
function $2d115b5a595f58b4$export$2e2bcd8739ae039(element) {
    return (0, $dUkib.default)(element).getComputedStyle(element);
}

});



parcelRegister("gknHB", function(module, exports) {
$parcel$export(module.exports, "default", () => $03114e09c3d0f3c5$export$2e2bcd8739ae039);

var $36jD0 = parcelRequire("36jD0");
function $03114e09c3d0f3c5$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $36jD0.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("hTauD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d05fb66e49246d6f$export$2e2bcd8739ae039);

var $6BWEI = parcelRequire("6BWEI");

var $fNWfR = parcelRequire("fNWfR");

var $dUkib = parcelRequire("dUkib");

var $iiEOo = parcelRequire("iiEOo");
function $d05fb66e49246d6f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $6BWEI.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $dUkib.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $iiEOo.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($d05fb66e49246d6f$export$2e2bcd8739ae039((0, $fNWfR.default)(target)));
}

});
parcelRegister("6BWEI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d03b2930709d63c$export$2e2bcd8739ae039);

var $fNWfR = parcelRequire("fNWfR");

var $iiEOo = parcelRequire("iiEOo");

var $9XffG = parcelRequire("9XffG");

var $kQRrr = parcelRequire("kQRrr");
function $4d03b2930709d63c$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $9XffG.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $kQRrr.isHTMLElement)(node) && (0, $iiEOo.default)(node)) return node;
    return $4d03b2930709d63c$export$2e2bcd8739ae039((0, $fNWfR.default)(node));
}

});
parcelRegister("fNWfR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8189ed02dd66c00$export$2e2bcd8739ae039);

var $9XffG = parcelRequire("9XffG");

var $eXzHV = parcelRequire("eXzHV");

var $kQRrr = parcelRequire("kQRrr");
function $b8189ed02dd66c00$export$2e2bcd8739ae039(element) {
    if ((0, $9XffG.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $kQRrr.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eXzHV.default)(element) // fallback
    );
}

});



parcelRegister("jIy8Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5ac9ca8efed2552$export$2e2bcd8739ae039);

var $dUkib = parcelRequire("dUkib");

var $9XffG = parcelRequire("9XffG");

var $3RTtM = parcelRequire("3RTtM");

var $kQRrr = parcelRequire("kQRrr");

var $g8vKs = parcelRequire("g8vKs");

var $fNWfR = parcelRequire("fNWfR");

var $byO21 = parcelRequire("byO21");
function $e5ac9ca8efed2552$var$getTrueOffsetParent(element) {
    if (!(0, $kQRrr.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3RTtM.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $e5ac9ca8efed2552$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $byO21.default)());
    var isIE = /Trident/i.test((0, $byO21.default)());
    if (isIE && (0, $kQRrr.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3RTtM.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $fNWfR.default)(element);
    if ((0, $kQRrr.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $kQRrr.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $9XffG.default)(currentNode)) < 0){
        var css = (0, $3RTtM.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $e5ac9ca8efed2552$export$2e2bcd8739ae039(element) {
    var window = (0, $dUkib.default)(element);
    var offsetParent = $e5ac9ca8efed2552$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $g8vKs.default)(offsetParent) && (0, $3RTtM.default)(offsetParent).position === 'static')offsetParent = $e5ac9ca8efed2552$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $9XffG.default)(offsetParent) === 'html' || (0, $9XffG.default)(offsetParent) === 'body' && (0, $3RTtM.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $e5ac9ca8efed2552$var$getContainingBlock(element) || window;
}

});
parcelRegister("g8vKs", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbf605401dac32f7$export$2e2bcd8739ae039);

var $9XffG = parcelRequire("9XffG");
function $bbf605401dac32f7$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $9XffG.default)(element)) >= 0;
}

});


parcelRegister("hW8nJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0ee5adff4b99cf6$export$2e2bcd8739ae039);

var $5AzHI = parcelRequire("5AzHI");
function $d0ee5adff4b99cf6$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $d0ee5adff4b99cf6$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $d0ee5adff4b99cf6$var$order(modifiers); // order based on phase
    return (0, $5AzHI.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("5AzHI", function(module, exports) {
$parcel$export(module.exports, "top", () => $411c02a3d39734c0$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $411c02a3d39734c0$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $411c02a3d39734c0$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $411c02a3d39734c0$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $411c02a3d39734c0$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $411c02a3d39734c0$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $411c02a3d39734c0$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $411c02a3d39734c0$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $411c02a3d39734c0$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $411c02a3d39734c0$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $411c02a3d39734c0$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $411c02a3d39734c0$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $411c02a3d39734c0$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $411c02a3d39734c0$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $411c02a3d39734c0$export$d087d3878fdf71d5);
var $411c02a3d39734c0$export$1e95b668f3b82d = 'top';
var $411c02a3d39734c0$export$40e543e69a8b3fbb = 'bottom';
var $411c02a3d39734c0$export$79ffe56a765070d2 = 'right';
var $411c02a3d39734c0$export$eabcd2c8791e7bf4 = 'left';
var $411c02a3d39734c0$export$dfb5619354ba860 = 'auto';
var $411c02a3d39734c0$export$aec2ce47c367b8c3 = [
    $411c02a3d39734c0$export$1e95b668f3b82d,
    $411c02a3d39734c0$export$40e543e69a8b3fbb,
    $411c02a3d39734c0$export$79ffe56a765070d2,
    $411c02a3d39734c0$export$eabcd2c8791e7bf4
];
var $411c02a3d39734c0$export$b3571188c770cc5a = 'start';
var $411c02a3d39734c0$export$bd5df0f255a350f8 = 'end';
var $411c02a3d39734c0$export$390fd549c5303b4d = 'clippingParents';
var $411c02a3d39734c0$export$d7b7311ec04a3e8f = 'viewport';
var $411c02a3d39734c0$export$ae5ab1c730825774 = 'popper';
var $411c02a3d39734c0$export$ca50aac9f3ba507f = 'reference';
var $411c02a3d39734c0$export$368f9a87e87fa4e1 = /*#__PURE__*/ $411c02a3d39734c0$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $411c02a3d39734c0$export$b3571188c770cc5a,
        placement + "-" + $411c02a3d39734c0$export$bd5df0f255a350f8
    ]);
}, []);
var $411c02a3d39734c0$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($411c02a3d39734c0$export$aec2ce47c367b8c3, [
    $411c02a3d39734c0$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $411c02a3d39734c0$export$b3571188c770cc5a,
        placement + "-" + $411c02a3d39734c0$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $411c02a3d39734c0$export$421679a7c3d56e = 'beforeRead';
var $411c02a3d39734c0$export$aafa59e2e03f2942 = 'read';
var $411c02a3d39734c0$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $411c02a3d39734c0$export$c65e99957a05207c = 'beforeMain';
var $411c02a3d39734c0$export$f22da7240b7add18 = 'main';
var $411c02a3d39734c0$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $411c02a3d39734c0$export$8d4d2d70e7d46032 = 'beforeWrite';
var $411c02a3d39734c0$export$68d8715fc104d294 = 'write';
var $411c02a3d39734c0$export$70a6e5159acce2e6 = 'afterWrite';
var $411c02a3d39734c0$export$d087d3878fdf71d5 = [
    $411c02a3d39734c0$export$421679a7c3d56e,
    $411c02a3d39734c0$export$aafa59e2e03f2942,
    $411c02a3d39734c0$export$6964f6c886723980,
    $411c02a3d39734c0$export$c65e99957a05207c,
    $411c02a3d39734c0$export$f22da7240b7add18,
    $411c02a3d39734c0$export$bab79516f2d662fe,
    $411c02a3d39734c0$export$8d4d2d70e7d46032,
    $411c02a3d39734c0$export$68d8715fc104d294,
    $411c02a3d39734c0$export$70a6e5159acce2e6
];

});


parcelRegister("9Wg0t", function(module, exports) {
$parcel$export(module.exports, "default", () => $73c5f26d4fa4f217$export$2e2bcd8739ae039);
function $73c5f26d4fa4f217$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("e7Ukp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a48d69bc312f6600$export$2e2bcd8739ae039);
function $a48d69bc312f6600$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("dRZce", function(module, exports) {
$parcel$export(module.exports, "default", () => $a18fb1e99e747911$export$2e2bcd8739ae039);

var $dUkib = parcelRequire("dUkib");
var $a18fb1e99e747911$var$passive = {
    passive: true
};
function $a18fb1e99e747911$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $dUkib.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $a18fb1e99e747911$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $a18fb1e99e747911$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $a18fb1e99e747911$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $a18fb1e99e747911$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $a18fb1e99e747911$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $a18fb1e99e747911$var$effect,
    data: {}
};

});

parcelRegister("HPGsg", function(module, exports) {
$parcel$export(module.exports, "default", () => $083c1b95a0149c16$export$2e2bcd8739ae039);

var $9SSSn = parcelRequire("9SSSn");
function $083c1b95a0149c16$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9SSSn.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $083c1b95a0149c16$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $083c1b95a0149c16$var$popperOffsets,
    data: {}
};

});
parcelRegister("9SSSn", function(module, exports) {
$parcel$export(module.exports, "default", () => $7323b974c38c9abd$export$2e2bcd8739ae039);

var $anFzz = parcelRequire("anFzz");

var $ldlws = parcelRequire("ldlws");

var $fsw2T = parcelRequire("fsw2T");

var $5AzHI = parcelRequire("5AzHI");
function $7323b974c38c9abd$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $anFzz.default)(placement) : null;
    var variation = placement ? (0, $ldlws.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $5AzHI.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $5AzHI.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $5AzHI.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $5AzHI.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $fsw2T.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $5AzHI.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $5AzHI.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("anFzz", function(module, exports) {
$parcel$export(module.exports, "default", () => $78ec4cd4191a5eed$export$2e2bcd8739ae039);

function $78ec4cd4191a5eed$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("ldlws", function(module, exports) {
$parcel$export(module.exports, "default", () => $f71b81c60cc9063b$export$2e2bcd8739ae039);
function $f71b81c60cc9063b$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("fsw2T", function(module, exports) {
$parcel$export(module.exports, "default", () => $b412542147e87880$export$2e2bcd8739ae039);
function $b412542147e87880$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("cXFBx", function(module, exports) {
$parcel$export(module.exports, "default", () => $96fb447cafbbe8e4$export$2e2bcd8739ae039);

var $5AzHI = parcelRequire("5AzHI");

var $jIy8Z = parcelRequire("jIy8Z");

var $dUkib = parcelRequire("dUkib");

var $eXzHV = parcelRequire("eXzHV");

var $3RTtM = parcelRequire("3RTtM");

var $anFzz = parcelRequire("anFzz");

var $ldlws = parcelRequire("ldlws");

var $baNUm = parcelRequire("baNUm");
var $96fb447cafbbe8e4$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $96fb447cafbbe8e4$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $baNUm.round)(x * dpr) / dpr || 0,
        y: (0, $baNUm.round)(y * dpr) / dpr || 0
    };
}
function $96fb447cafbbe8e4$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $5AzHI.left);
    var sideY = (0, $5AzHI.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $jIy8Z.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $dUkib.default)(popper)) {
            offsetParent = (0, $eXzHV.default)(popper);
            if ((0, $3RTtM.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $5AzHI.top) || (placement === (0, $5AzHI.left) || placement === (0, $5AzHI.right)) && variation === (0, $5AzHI.end)) {
            sideY = (0, $5AzHI.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $5AzHI.left) || (placement === (0, $5AzHI.top) || placement === (0, $5AzHI.bottom)) && variation === (0, $5AzHI.end)) {
            sideX = (0, $5AzHI.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $96fb447cafbbe8e4$var$unsetSides);
    var _ref4 = roundOffsets === true ? $96fb447cafbbe8e4$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $dUkib.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $96fb447cafbbe8e4$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $anFzz.default)(state.placement),
        variation: (0, $ldlws.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $96fb447cafbbe8e4$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $96fb447cafbbe8e4$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $96fb447cafbbe8e4$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $96fb447cafbbe8e4$var$computeStyles,
    data: {}
};

});

parcelRegister("aCZ4M", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bccd46d04bc4cfc$export$2e2bcd8739ae039);

var $9XffG = parcelRequire("9XffG");

var $kQRrr = parcelRequire("kQRrr");
// and applies them to the HTMLElements such as popper and arrow
function $7bccd46d04bc4cfc$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $kQRrr.isHTMLElement)(element) || !(0, $9XffG.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7bccd46d04bc4cfc$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $kQRrr.isHTMLElement)(element) || !(0, $9XffG.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7bccd46d04bc4cfc$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7bccd46d04bc4cfc$var$applyStyles,
    effect: $7bccd46d04bc4cfc$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("hSS18", function(module, exports) {
$parcel$export(module.exports, "default", () => $d051618cd8b40bb2$export$2e2bcd8739ae039);

var $anFzz = parcelRequire("anFzz");

var $5AzHI = parcelRequire("5AzHI");
function $d051618cd8b40bb2$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $anFzz.default)(placement);
    var invertDistance = [
        (0, $5AzHI.left),
        (0, $5AzHI.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $5AzHI.left),
        (0, $5AzHI.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $d051618cd8b40bb2$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $5AzHI.placements).reduce(function(acc, placement) {
        acc[placement] = $d051618cd8b40bb2$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d051618cd8b40bb2$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $d051618cd8b40bb2$var$offset
};

});

parcelRegister("filWH", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2298f6c1aed65a7$export$2e2bcd8739ae039);

var $1akFy = parcelRequire("1akFy");

var $anFzz = parcelRequire("anFzz");

var $iQhT7 = parcelRequire("iQhT7");

var $gZzDx = parcelRequire("gZzDx");

var $eIIJq = parcelRequire("eIIJq");

var $5AzHI = parcelRequire("5AzHI");

var $ldlws = parcelRequire("ldlws");
function $b2298f6c1aed65a7$var$getExpandedFallbackPlacements(placement) {
    if ((0, $anFzz.default)(placement) === (0, $5AzHI.auto)) return [];
    var oppositePlacement = (0, $1akFy.default)(placement);
    return [
        (0, $iQhT7.default)(placement),
        oppositePlacement,
        (0, $iQhT7.default)(oppositePlacement)
    ];
}
function $b2298f6c1aed65a7$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $anFzz.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1akFy.default)(preferredPlacement)
    ] : $b2298f6c1aed65a7$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $anFzz.default)(placement) === (0, $5AzHI.auto) ? (0, $eIIJq.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $anFzz.default)(placement);
        var isStartVariation = (0, $ldlws.default)(placement) === (0, $5AzHI.start);
        var isVertical = [
            (0, $5AzHI.top),
            (0, $5AzHI.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gZzDx.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $5AzHI.right) : (0, $5AzHI.left) : isStartVariation ? (0, $5AzHI.bottom) : (0, $5AzHI.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1akFy.default)(mainVariationSide);
        var altVariationSide = (0, $1akFy.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b2298f6c1aed65a7$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b2298f6c1aed65a7$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("1akFy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d96c219052f8587$export$2e2bcd8739ae039);
var $0d96c219052f8587$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $0d96c219052f8587$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $0d96c219052f8587$var$hash[matched];
    });
}

});

parcelRegister("iQhT7", function(module, exports) {
$parcel$export(module.exports, "default", () => $db7af5892406d244$export$2e2bcd8739ae039);
var $db7af5892406d244$var$hash = {
    start: 'end',
    end: 'start'
};
function $db7af5892406d244$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $db7af5892406d244$var$hash[matched];
    });
}

});

parcelRegister("gZzDx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5edfc94ce32c276$export$2e2bcd8739ae039);

var $lQNbn = parcelRequire("lQNbn");

var $eXzHV = parcelRequire("eXzHV");

var $36jD0 = parcelRequire("36jD0");

var $9SSSn = parcelRequire("9SSSn");

var $8u6wS = parcelRequire("8u6wS");

var $5AzHI = parcelRequire("5AzHI");

var $kQRrr = parcelRequire("kQRrr");

var $yjJVG = parcelRequire("yjJVG");

var $6WTSa = parcelRequire("6WTSa");
function $c5edfc94ce32c276$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $5AzHI.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $5AzHI.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $5AzHI.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $yjJVG.default)(typeof padding !== 'number' ? padding : (0, $6WTSa.default)(padding, (0, $5AzHI.basePlacements)));
    var altContext = elementContext === (0, $5AzHI.popper) ? (0, $5AzHI.reference) : (0, $5AzHI.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $lQNbn.default)((0, $kQRrr.isElement)(element) ? element : element.contextElement || (0, $eXzHV.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $36jD0.default)(state.elements.reference);
    var popperOffsets = (0, $9SSSn.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $8u6wS.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $5AzHI.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $5AzHI.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $5AzHI.right),
                (0, $5AzHI.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $5AzHI.top),
                (0, $5AzHI.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("lQNbn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe849aeec17c3d78$export$2e2bcd8739ae039);

var $5AzHI = parcelRequire("5AzHI");

var $13ygq = parcelRequire("13ygq");

var $hQgn3 = parcelRequire("hQgn3");

var $hTauD = parcelRequire("hTauD");

var $jIy8Z = parcelRequire("jIy8Z");

var $eXzHV = parcelRequire("eXzHV");

var $3RTtM = parcelRequire("3RTtM");

var $kQRrr = parcelRequire("kQRrr");

var $36jD0 = parcelRequire("36jD0");

var $fNWfR = parcelRequire("fNWfR");

var $6AZFv = parcelRequire("6AZFv");

var $9XffG = parcelRequire("9XffG");

var $8u6wS = parcelRequire("8u6wS");

var $baNUm = parcelRequire("baNUm");
function $fe849aeec17c3d78$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $36jD0.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $fe849aeec17c3d78$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $5AzHI.viewport) ? (0, $8u6wS.default)((0, $13ygq.default)(element, strategy)) : (0, $kQRrr.isElement)(clippingParent) ? $fe849aeec17c3d78$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $8u6wS.default)((0, $hQgn3.default)((0, $eXzHV.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $fe849aeec17c3d78$var$getClippingParents(element) {
    var clippingParents = (0, $hTauD.default)((0, $fNWfR.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3RTtM.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $kQRrr.isHTMLElement)(element) ? (0, $jIy8Z.default)(element) : element;
    if (!(0, $kQRrr.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $kQRrr.isElement)(clippingParent) && (0, $6AZFv.default)(clippingParent, clipperElement) && (0, $9XffG.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $fe849aeec17c3d78$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $fe849aeec17c3d78$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $fe849aeec17c3d78$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $baNUm.max)(rect.top, accRect.top);
        accRect.right = (0, $baNUm.min)(rect.right, accRect.right);
        accRect.bottom = (0, $baNUm.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $baNUm.max)(rect.left, accRect.left);
        return accRect;
    }, $fe849aeec17c3d78$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("13ygq", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c50a6602245868d$export$2e2bcd8739ae039);

var $dUkib = parcelRequire("dUkib");

var $eXzHV = parcelRequire("eXzHV");

var $9GF4G = parcelRequire("9GF4G");

var $hXgRQ = parcelRequire("hXgRQ");
function $0c50a6602245868d$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $dUkib.default)(element);
    var html = (0, $eXzHV.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $hXgRQ.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $9GF4G.default)(element),
        y: y
    };
}

});

parcelRegister("hQgn3", function(module, exports) {
$parcel$export(module.exports, "default", () => $035a20ffb64cb76f$export$2e2bcd8739ae039);

var $eXzHV = parcelRequire("eXzHV");

var $3RTtM = parcelRequire("3RTtM");

var $9GF4G = parcelRequire("9GF4G");

var $caopt = parcelRequire("caopt");

var $baNUm = parcelRequire("baNUm");
function $035a20ffb64cb76f$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eXzHV.default)(element);
    var winScroll = (0, $caopt.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $baNUm.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $baNUm.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $9GF4G.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3RTtM.default)(body || html).direction === 'rtl') x += (0, $baNUm.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("6AZFv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cd5f0edd3fac807$export$2e2bcd8739ae039);

var $kQRrr = parcelRequire("kQRrr");
function $4cd5f0edd3fac807$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $kQRrr.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("8u6wS", function(module, exports) {
$parcel$export(module.exports, "default", () => $62d630a9317fe304$export$2e2bcd8739ae039);
function $62d630a9317fe304$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("yjJVG", function(module, exports) {
$parcel$export(module.exports, "default", () => $06727d00b4525720$export$2e2bcd8739ae039);

var $f1p04 = parcelRequire("f1p04");
function $06727d00b4525720$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f1p04.default)(), paddingObject);
}

});
parcelRegister("f1p04", function(module, exports) {
$parcel$export(module.exports, "default", () => $aefa578a9d6cc200$export$2e2bcd8739ae039);
function $aefa578a9d6cc200$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("6WTSa", function(module, exports) {
$parcel$export(module.exports, "default", () => $50f380071de1cf81$export$2e2bcd8739ae039);
function $50f380071de1cf81$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("eIIJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab77df8689b6cba2$export$2e2bcd8739ae039);

var $ldlws = parcelRequire("ldlws");

var $5AzHI = parcelRequire("5AzHI");

var $gZzDx = parcelRequire("gZzDx");

var $anFzz = parcelRequire("anFzz");
function $ab77df8689b6cba2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $5AzHI.placements) : _options$allowedAutoP;
    var variation = (0, $ldlws.default)(placement);
    var placements = variation ? flipVariations ? (0, $5AzHI.variationPlacements) : (0, $5AzHI.variationPlacements).filter(function(placement) {
        return (0, $ldlws.default)(placement) === variation;
    }) : (0, $5AzHI.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gZzDx.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $anFzz.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("4pUra", function(module, exports) {
$parcel$export(module.exports, "default", () => $3375467cd527c073$export$2e2bcd8739ae039);

var $5AzHI = parcelRequire("5AzHI");

var $anFzz = parcelRequire("anFzz");

var $fsw2T = parcelRequire("fsw2T");

var $kEhTe = parcelRequire("kEhTe");

var $kmdYq = parcelRequire("kmdYq");

var $gknHB = parcelRequire("gknHB");

var $jIy8Z = parcelRequire("jIy8Z");

var $gZzDx = parcelRequire("gZzDx");

var $ldlws = parcelRequire("ldlws");

var $f1p04 = parcelRequire("f1p04");

var $baNUm = parcelRequire("baNUm");
function $3375467cd527c073$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gZzDx.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $anFzz.default)(state.placement);
    var variation = (0, $ldlws.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $fsw2T.default)(basePlacement);
    var altAxis = (0, $kEhTe.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $5AzHI.top) : (0, $5AzHI.left);
        var altSide = mainAxis === 'y' ? (0, $5AzHI.bottom) : (0, $5AzHI.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $5AzHI.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $5AzHI.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $gknHB.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $f1p04.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $kmdYq.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $jIy8Z.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $kmdYq.within)(tether ? (0, $baNUm.min)(min, tetherMin) : min, offset, tether ? (0, $baNUm.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $5AzHI.top) : (0, $5AzHI.left);
        var _altSide = mainAxis === 'x' ? (0, $5AzHI.bottom) : (0, $5AzHI.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $5AzHI.top),
            (0, $5AzHI.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $kmdYq.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $kmdYq.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3375467cd527c073$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3375467cd527c073$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("kEhTe", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0856b9b3f51dedd$export$2e2bcd8739ae039);
function $f0856b9b3f51dedd$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("kmdYq", function(module, exports) {
$parcel$export(module.exports, "within", () => $ed20b39381e635a8$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $ed20b39381e635a8$export$86c8af6d3ef0b4a);

var $baNUm = parcelRequire("baNUm");
function $ed20b39381e635a8$export$f28d906d67a997f3(min, value, max) {
    return (0, $baNUm.max)(min, (0, $baNUm.min)(value, max));
}
function $ed20b39381e635a8$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $ed20b39381e635a8$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("hoIyB", function(module, exports) {
$parcel$export(module.exports, "default", () => $caa73da94f0d9c36$export$2e2bcd8739ae039);

var $anFzz = parcelRequire("anFzz");

var $gknHB = parcelRequire("gknHB");

var $6AZFv = parcelRequire("6AZFv");

var $jIy8Z = parcelRequire("jIy8Z");

var $fsw2T = parcelRequire("fsw2T");

var $kmdYq = parcelRequire("kmdYq");

var $yjJVG = parcelRequire("yjJVG");

var $6WTSa = parcelRequire("6WTSa");

var $5AzHI = parcelRequire("5AzHI");
var $caa73da94f0d9c36$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $yjJVG.default)(typeof padding !== 'number' ? padding : (0, $6WTSa.default)(padding, (0, $5AzHI.basePlacements)));
};
function $caa73da94f0d9c36$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $anFzz.default)(state.placement);
    var axis = (0, $fsw2T.default)(basePlacement);
    var isVertical = [
        (0, $5AzHI.left),
        (0, $5AzHI.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $caa73da94f0d9c36$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $gknHB.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $5AzHI.top) : (0, $5AzHI.left);
    var maxProp = axis === 'y' ? (0, $5AzHI.bottom) : (0, $5AzHI.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $jIy8Z.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $kmdYq.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $caa73da94f0d9c36$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $6AZFv.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $caa73da94f0d9c36$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $caa73da94f0d9c36$var$arrow,
    effect: $caa73da94f0d9c36$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("cUZlK", function(module, exports) {
$parcel$export(module.exports, "default", () => $967a4dc2ae7e2aca$export$2e2bcd8739ae039);

var $5AzHI = parcelRequire("5AzHI");

var $gZzDx = parcelRequire("gZzDx");
function $967a4dc2ae7e2aca$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $967a4dc2ae7e2aca$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $5AzHI.top),
        (0, $5AzHI.right),
        (0, $5AzHI.bottom),
        (0, $5AzHI.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $967a4dc2ae7e2aca$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gZzDx.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gZzDx.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $967a4dc2ae7e2aca$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $967a4dc2ae7e2aca$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $967a4dc2ae7e2aca$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $967a4dc2ae7e2aca$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $967a4dc2ae7e2aca$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $967a4dc2ae7e2aca$var$hide
};

});




parcelRegister("lAyXp", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $0181a3b01e2f0f07$export$6d8c2b45c99d6e3f);
function $0181a3b01e2f0f07$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});


parcelRegister("3NjXI", function(module, exports) {
$parcel$export(module.exports, "register", () => $d31cb3bd12f63840$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $4eDgu = parcelRequire("4eDgu");
const $d31cb3bd12f63840$var$registrations = new Set();
let $d31cb3bd12f63840$var$cleanupEndEventListeners = null;
function $d31cb3bd12f63840$var$onDragStart() {
    if ($d31cb3bd12f63840$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $d31cb3bd12f63840$var$cleanupEndEventListeners = (0, $4eDgu.bindAll)(window, [
        {
            type: 'dragend',
            listener: $d31cb3bd12f63840$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $d31cb3bd12f63840$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $d31cb3bd12f63840$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($d31cb3bd12f63840$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $d31cb3bd12f63840$var$onDragEnd() {
    $d31cb3bd12f63840$var$cleanupEndEventListeners?.();
    $d31cb3bd12f63840$var$cleanupEndEventListeners = null;
    const clone = Array.from($d31cb3bd12f63840$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $d31cb3bd12f63840$var$bindStartEvents() {
    return (0, $4eDgu.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $d31cb3bd12f63840$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $d31cb3bd12f63840$var$onDragStart
        }
    ]);
}
let $d31cb3bd12f63840$var$cleanupStartEventListeners = null;
function $d31cb3bd12f63840$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$d31cb3bd12f63840$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $d31cb3bd12f63840$var$cleanupStartEventListeners = $d31cb3bd12f63840$var$bindStartEvents();
    $d31cb3bd12f63840$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $d31cb3bd12f63840$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $d31cb3bd12f63840$var$registrations.delete(registration);
        if ($d31cb3bd12f63840$var$registrations.size === 0) {
            $d31cb3bd12f63840$var$cleanupStartEventListeners?.();
            $d31cb3bd12f63840$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("hEp9g", function(module, exports) {
$parcel$export(module.exports, "show", () => $91f02f35537269dd$export$57bf213be019eeb0);

var $4rHKw = parcelRequire("4rHKw");
let $91f02f35537269dd$var$active = null;
function $91f02f35537269dd$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($91f02f35537269dd$var$active && $91f02f35537269dd$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $4rHKw.clearScheduled)();
            $91f02f35537269dd$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $4rHKw.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $4rHKw.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $4rHKw.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($91f02f35537269dd$var$active && $91f02f35537269dd$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($91f02f35537269dd$var$active) {
            (0, $4rHKw.clearScheduled)();
            $91f02f35537269dd$var$active.entry.hide({
                isImmediate: true
            });
            $91f02f35537269dd$var$active.entry.done();
            $91f02f35537269dd$var$active = null;
        }
        // this tooltip is now the active tooltip
        $91f02f35537269dd$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $4rHKw.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("4rHKw", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $3a7f543fd4f646d7$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $3a7f543fd4f646d7$export$5f4d6617421d489b);
let $3a7f543fd4f646d7$var$delayId = null;
function $3a7f543fd4f646d7$export$eaf678f6f93f5250() {
    if ($3a7f543fd4f646d7$var$delayId != null) {
        window.clearTimeout($3a7f543fd4f646d7$var$delayId);
        $3a7f543fd4f646d7$var$delayId = null;
    }
}
function $3a7f543fd4f646d7$export$5f4d6617421d489b(fn, delay) {
    $3a7f543fd4f646d7$export$eaf678f6f93f5250();
    $3a7f543fd4f646d7$var$delayId = window.setTimeout(()=>{
        $3a7f543fd4f646d7$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("eKuYD", function(module, exports) {
$parcel$export(module.exports, "default", () => $3edd2135bed11c21$export$2e2bcd8739ae039);

var $duGTW = parcelRequire("duGTW");
function $3edd2135bed11c21$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $duGTW.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("duGTW", function(module, exports) {
$parcel$export(module.exports, "useId", () => $33030e46cdcf6535$export$f680877a34711e37);
$parcel$export(module.exports, "IdProvider", () => $33030e46cdcf6535$export$6be90bcb437e928f);
$parcel$export(module.exports, "useIdSeed", () => $33030e46cdcf6535$export$6ee17796e3d70de2);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $o0Fzr = parcelRequire("o0Fzr");

var $91hOG = parcelRequire("91hOG");
// @ts-ignore - useId is not accessible in React 16
const $33030e46cdcf6535$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useId ?? undefined;
function $33030e46cdcf6535$export$f680877a34711e37() {
    if ($33030e46cdcf6535$var$react18UseId && (0, $91hOG.fg)('platform-dst-react-18-use-id')) {
        if ((0, $91hOG.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $33030e46cdcf6535$var$react18UseId().replace(/[:«»]/g, '_');
        return $33030e46cdcf6535$var$react18UseId();
    }
    return `uid${(0, $o0Fzr.useUID)()}`;
}
const $33030e46cdcf6535$export$6be90bcb437e928f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${$33030e46cdcf6535$export$f680877a34711e37()}${postfix}`;
    (0, $eJOHy.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
function $33030e46cdcf6535$export$6ee17796e3d70de2() {
    if ($33030e46cdcf6535$var$react18UseId && (0, $91hOG.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        const uid = $33030e46cdcf6535$export$f680877a34711e37();
        return (id)=>`${uid}-${id.toString()}`;
    }
    return (0, $o0Fzr.useUIDSeed)();
}

});


parcelRegister("JgdAF", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f2b3d153c2520ec$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kQNZc = parcelRequire("kQNZc");
const $5f2b3d153c2520ec$var$styles = {
    base: "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $5f2b3d153c2520ec$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kQNZc.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $5f2b3d153c2520ec$var$styles.base,
            truncate && $5f2b3d153c2520ec$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        children: children
    });
});
$5f2b3d153c2520ec$var$TooltipContainer.displayName = 'TooltipContainer';
var $5f2b3d153c2520ec$export$2e2bcd8739ae039 = $5f2b3d153c2520ec$var$TooltipContainer;

});
parcelRegister("kQNZc", function(module, exports) {
$parcel$export(module.exports, "default", () => $73e9f428e84e89eb$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $by8QK = parcelRequire("by8QK");
const $73e9f428e84e89eb$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $73e9f428e84e89eb$var$TooltipPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            role: "tooltip",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $hcewu.default)([
                "_80om73ad",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                children,
                shortcut && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $by8QK.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$73e9f428e84e89eb$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $73e9f428e84e89eb$export$2e2bcd8739ae039 = $73e9f428e84e89eb$var$TooltipPrimitive;

});
parcelRegister("by8QK", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $45392d5c176742cf$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $91hOG = parcelRequire("91hOG");
const $45392d5c176742cf$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c81u0j _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p",
    regularFont: "_11c81o8v"
};
const $45392d5c176742cf$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $45392d5c176742cf$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)("kbd", {
                className: (0, $hcewu.default)([
                    $45392d5c176742cf$var$styles.shortcutSegment,
                    (0, $91hOG.fg)('platform-tooltip-shortcuts-regular-font') && $45392d5c176742cf$var$styles.regularFont
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};

});



parcelRegister("cTxYb", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $83d8c1f6537d3565$export$642213d516a9b928);
function $83d8c1f6537d3565$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("bnaqA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e080240808bf60a$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $ivAPc = parcelRequire("ivAPc");

var $7zosp = parcelRequire("7zosp");

var $jfGrc = parcelRequire("jfGrc");

var $duGTW = parcelRequire("duGTW");

var $bf6e0 = parcelRequire("bf6e0");

var $hk2S7 = parcelRequire("hk2S7");

var $7gdFM = parcelRequire("7gdFM");

var $iwNPb = parcelRequire("iwNPb");

var $fJyKB = parcelRequire("fJyKB");
const $3e080240808bf60a$var$LOADING_LABEL = ', Loading';
const $3e080240808bf60a$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1caa _irr31caa _1di61caa",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhk1w7a _y4ti12x7 _bozg12x7"
};
const $3e080240808bf60a$var$defaultStyles = {
    root: "_bfhk1w7a _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk18uv _8l3mbk0g _irr318uv _1di618uv"
};
const $3e080240808bf60a$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $3e080240808bf60a$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
const $3e080240808bf60a$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
const $3e080240808bf60a$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $3e080240808bf60a$var$subtleStyles = {
    root: "_bfhk1w7a _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk18uv _8l3mbk0g _irr318uv _1di618uv"
};
const $3e080240808bf60a$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $3e080240808bf60a$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    const localRef = (0, $eJOHy.useRef)(null);
    const splitButtonContext = (0, $7gdFM.useSplitButtonContext)();
    const loadingLabelId = (0, $duGTW.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $jfGrc.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bf6e0.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $7zosp.default)([
            localRef,
            ref
        ]),
        xcss: (0, $ivAPc.cx)($3e080240808bf60a$var$styles.base, appearance === 'default' && $3e080240808bf60a$var$defaultStyles.root, appearance === 'default' && isInteractive && $3e080240808bf60a$var$defaultStyles.interactive, appearance === 'primary' && $3e080240808bf60a$var$primaryStyles.root, appearance === 'primary' && isInteractive && $3e080240808bf60a$var$primaryStyles.interactive, appearance === 'warning' && $3e080240808bf60a$var$warningStyles.root, appearance === 'warning' && isInteractive && $3e080240808bf60a$var$warningStyles.interactive, appearance === 'danger' && $3e080240808bf60a$var$dangerStyles.root, appearance === 'danger' && isInteractive && $3e080240808bf60a$var$dangerStyles.interactive, appearance === 'discovery' && $3e080240808bf60a$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $3e080240808bf60a$var$discoveryStyles.interactive, appearance === 'subtle' && $3e080240808bf60a$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $3e080240808bf60a$var$subtleStyles.interactive, $3e080240808bf60a$var$styles.linkDecorationUnset, isSelected && $3e080240808bf60a$var$selectedStyles.root, isSelected && isSplitButton && $3e080240808bf60a$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $3e080240808bf60a$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $3e080240808bf60a$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $3e080240808bf60a$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $3e080240808bf60a$var$selectedStyles.discovery, isDisabled && $3e080240808bf60a$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $3e080240808bf60a$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $3e080240808bf60a$var$defaultStyles.disabled, isCircle && !isSplitButton && $3e080240808bf60a$var$styles.circle, spacing === 'compact' && $3e080240808bf60a$var$styles.spacingCompact, hasIconBefore && $3e080240808bf60a$var$styles.buttonIconBefore, shouldFitContainer && $3e080240808bf60a$var$styles.fullWidth, hasIconAfter && $3e080240808bf60a$var$styles.buttonIconAfter, isIconButton && $3e080240808bf60a$var$styles.iconButton, isIconButton && spacing === 'compact' && $3e080240808bf60a$var$styles.iconButtonCompact, isLoading && $3e080240808bf60a$var$styles.loading, isSplitButton && $3e080240808bf60a$var$styles.splitButton, isNavigationSplitButton && $3e080240808bf60a$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$3e080240808bf60a$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $iwNPb.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7gdFM.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        $3e080240808bf60a$var$styles.loadingOverlay
                    ]),
                    children: (0, $fJyKB.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hk2S7.default), {
                    id: loadingLabelId,
                    children: $3e080240808bf60a$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $3e080240808bf60a$export$2e2bcd8739ae039 = $3e080240808bf60a$var$ButtonBase;

});
parcelRegister("bf6e0", function(module, exports) {
$parcel$export(module.exports, "default", () => $994053d7d78c08a9$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $99f0y = parcelRequire("99f0y");

var $9Zgt8 = parcelRequire("9Zgt8");

var $2w7cu = parcelRequire("2w7cu");

var $8MFTW = parcelRequire("8MFTW");

var $9Qs1b = parcelRequire("9Qs1b");
const $994053d7d78c08a9$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $994053d7d78c08a9$var$Pressable = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $2w7cu.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $eJOHy.useContext)((0, $8MFTW.default));
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $99f0y.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9Qs1b.default // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        ,
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $9Zgt8.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $k0ahr.cx)($994053d7d78c08a9$var$styles.root, isDisabled && $994053d7d78c08a9$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});
var $994053d7d78c08a9$export$2e2bcd8739ae039 = $994053d7d78c08a9$var$Pressable;

});
parcelRegister("9Zgt8", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $1434e0ada0646a0e$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $1434e0ada0646a0e$export$e1865c3bedcd822b);
function $1434e0ada0646a0e$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $1434e0ada0646a0e$var$isIPhone() {
    return $1434e0ada0646a0e$var$testPlatform(/^iPhone/i);
}
function $1434e0ada0646a0e$var$isMac() {
    return $1434e0ada0646a0e$var$testPlatform(/^Mac/i);
}
function $1434e0ada0646a0e$var$isIPad() {
    return $1434e0ada0646a0e$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $1434e0ada0646a0e$var$isMac() && navigator.maxTouchPoints > 1;
}
function $1434e0ada0646a0e$var$isIOS() {
    return $1434e0ada0646a0e$var$isIPhone() || $1434e0ada0646a0e$var$isIPad();
}
function $1434e0ada0646a0e$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $1434e0ada0646a0e$export$e1865c3bedcd822b() {
    return $1434e0ada0646a0e$var$isMac() || $1434e0ada0646a0e$var$isIOS();
}

});

parcelRegister("9Qs1b", function(module, exports) {
$parcel$export(module.exports, "default", () => $e625de26891161ac$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $e625de26891161ac$var$focusRingStyles = null;
const $e625de26891161ac$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ const $e625de26891161ac$var$Focusable = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $hcewu.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $e625de26891161ac$export$2e2bcd8739ae039 = $e625de26891161ac$var$Focusable;

});


parcelRegister("7gdFM", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $b408546307185eec$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $b408546307185eec$export$47e2c6fdb142d947);

var $eJOHy = parcelRequire("eJOHy");
const $b408546307185eec$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $b408546307185eec$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $eJOHy.useContext)($b408546307185eec$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("iwNPb", function(module, exports) {
$parcel$export(module.exports, "default", () => $482f8c9f1d4eb5d4$export$2e2bcd8739ae039);
function $482f8c9f1d4eb5d4$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $482f8c9f1d4eb5d4$var$tabKeyCode = 9;
function $482f8c9f1d4eb5d4$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $482f8c9f1d4eb5d4$var$tabKeyCode) return;
    $482f8c9f1d4eb5d4$var$abort(event);
}
function $482f8c9f1d4eb5d4$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $482f8c9f1d4eb5d4$var$abort,
        onMouseUpCapture: $482f8c9f1d4eb5d4$var$abort,
        onKeyDownCapture: $482f8c9f1d4eb5d4$var$onKey,
        onKeyUpCapture: $482f8c9f1d4eb5d4$var$onKey,
        onTouchStartCapture: $482f8c9f1d4eb5d4$var$abort,
        onTouchEndCapture: $482f8c9f1d4eb5d4$var$abort,
        onPointerDownCapture: $482f8c9f1d4eb5d4$var$abort,
        onPointerUpCapture: $482f8c9f1d4eb5d4$var$abort,
        onClickCapture: $482f8c9f1d4eb5d4$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $482f8c9f1d4eb5d4$var$abort
    } : events;
}

});

parcelRegister("fJyKB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c75baed067caf13a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6AidT = parcelRequire("6AidT");
function $c75baed067caf13a$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $c75baed067caf13a$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $c75baed067caf13a$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6AidT.default), {
        size: $c75baed067caf13a$var$getIconSpacing(spacing),
        appearance: $c75baed067caf13a$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("lrFzB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7000d3fee9bddad4$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $7000d3fee9bddad4$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $7000d3fee9bddad4$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            $7000d3fee9bddad4$var$styles.common,
            type === 'text' && $7000d3fee9bddad4$var$styles.text,
            type === 'icon' && $7000d3fee9bddad4$var$styles.icon,
            isLoading && $7000d3fee9bddad4$var$styles.fade,
            position === 'before' && $7000d3fee9bddad4$var$styles.beforeIcon,
            position === 'after' && $7000d3fee9bddad4$var$styles.afterIcon
        ]),
        children: children
    });
};
var $7000d3fee9bddad4$export$2e2bcd8739ae039 = $7000d3fee9bddad4$var$Content;

});

parcelRegister("lbqGH", function(module, exports) {
$parcel$export(module.exports, "default", () => $71faca1639cfdafa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $91hOG = parcelRequire("91hOG");
function $71faca1639cfdafa$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $71faca1639cfdafa$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $71faca1639cfdafa$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $91hOG.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $71faca1639cfdafa$export$2e2bcd8739ae039 = $71faca1639cfdafa$var$IconRenderer;

});



parcelRegister("a2bs3", function(module, exports) {
$parcel$export(module.exports, "default", () => $57eb4b12d54e660c$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2JrCM = parcelRequire("2JrCM");
var $eN6pO = parcelRequire("eN6pO");

var $jVDYl = parcelRequire("jVDYl");
var $7SOTF = parcelRequire("7SOTF");
const $57eb4b12d54e660c$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $57eb4b12d54e660c$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jVDYl.default), {
        xcss: $57eb4b12d54e660c$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2JrCM.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eN6pO.default), {
                children: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jVDYl.default), {
                        xcss: $57eb4b12d54e660c$var$styles.container,
                        ...props,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7SOTF.default), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$57eb4b12d54e660c$export$2e2bcd8739ae039 = $57eb4b12d54e660c$var$Expander;

});


parcelRegister("huCkT", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fa7ffca66fa480d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $99f0y = parcelRequire("99f0y");

var $2w7cu = parcelRequire("2w7cu");

var $beH2Y = parcelRequire("beH2Y");

var $1kIJP = parcelRequire("1kIJP");
const $1fa7ffca66fa480d$var$packageName = "platform-pkg";
const $1fa7ffca66fa480d$var$packageVersion = "0.0.0-use.local";
const $1fa7ffca66fa480d$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $1fa7ffca66fa480d$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $2w7cu.default) } = props;
    const autoDismissTimer = (0, $eJOHy.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $1kIJP.useFlagGroup)();
    const onDismissed = (0, $eJOHy.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $99f0y.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $1fa7ffca66fa480d$var$packageName,
        packageVersion: $1fa7ffca66fa480d$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $eJOHy.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $eJOHy.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $eJOHy.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $1fa7ffca66fa480d$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $eJOHy.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $beH2Y.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $1fa7ffca66fa480d$export$2e2bcd8739ae039 = $1fa7ffca66fa480d$var$AutoDismissFlag;

});

parcelRegister("aHcvI", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $7bf9aaf1ed1a1815$export$2879604e6aec4ab);
$parcel$export(module.exports, "FlagsProvider", () => $7bf9aaf1ed1a1815$export$a4270ab432ac8a58);
$parcel$export(module.exports, "withFlagsProvider", () => $7bf9aaf1ed1a1815$export$7b676815c264eaf3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $huCkT = parcelRequire("huCkT");

var $beH2Y = parcelRequire("beH2Y");

var $1kIJP = parcelRequire("1kIJP");
const $7bf9aaf1ed1a1815$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
function $7bf9aaf1ed1a1815$export$2879604e6aec4ab() {
    const api = (0, $eJOHy.useContext)($7bf9aaf1ed1a1815$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $7bf9aaf1ed1a1815$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $7bf9aaf1ed1a1815$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $eJOHy.useState)([]);
    const removeFlag = (0, $eJOHy.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $eJOHy.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $7bf9aaf1ed1a1815$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($7bf9aaf1ed1a1815$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1kIJP.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $huCkT.default) : (0, $beH2Y.default);
                    return /*#__PURE__*/ (0, $eJOHy.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $7bf9aaf1ed1a1815$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $gt9Am.jsx)($7bf9aaf1ed1a1815$export$a4270ab432ac8a58, {
        children: fn()
    });

});


parcelRegister("j903d", function(module, exports) {
$parcel$export(module.exports, "Popper", () => (parcelRequire("e0ZfU")).Popper);
$parcel$export(module.exports, "placements", () => (parcelRequire("5AzHI")).placements);
$parcel$export(module.exports, "Manager", () => (parcelRequire("bXUqf")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("clgoR")).Reference);

var $5AzHI = parcelRequire("5AzHI");
var $e0ZfU = parcelRequire("e0ZfU");

var $bXUqf = parcelRequire("bXUqf");
var $clgoR = parcelRequire("clgoR");

});
parcelRegister("clgoR", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $8fc42ae074f0a21b$export$e0be378c32fb70a7);

var $eJOHy = parcelRequire("eJOHy");

var $9Hk5t = parcelRequire("9Hk5t");

var $bXUqf = parcelRequire("bXUqf");

var $7DgQQ = parcelRequire("7DgQQ");
function $8fc42ae074f0a21b$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eJOHy.useContext((0, $bXUqf.ManagerReferenceNodeSetterContext));
    var refHandler = $eJOHy.useCallback(function(node) {
        (0, $7DgQQ.setRef)(innerRef, node);
        (0, $7DgQQ.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eJOHy.useEffect(function() {
        return function() {
            return (0, $7DgQQ.setRef)(innerRef, null);
        };
    }, []);
    $eJOHy.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9Hk5t)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $7DgQQ.unwrapArray)(children)({
        ref: refHandler
    });
}

});


parcelRegister("6NtES", function(module, exports) {
$parcel$export(module.exports, "default", () => $19c32c67909ed5bf$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iFaP4 = parcelRequire("iFaP4");

var $ibpQM = parcelRequire("ibpQM");
const $19c32c67909ed5bf$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps: patchedEventProps } = (0, $ibpQM.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $19c32c67909ed5bf$export$2e2bcd8739ae039 = $19c32c67909ed5bf$var$withAnalyticsEvents;

});
parcelRegister("ibpQM", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $3cac629085af7152$export$9ebb5a84d17e5d18);

var $eJOHy = parcelRequire("eJOHy");

var $iFaP4 = parcelRequire("iFaP4");
function $3cac629085af7152$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const handlerCache = (0, $eJOHy.useRef)({});
    const patchedProps = (0, $eJOHy.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("eG73a", function(module, exports) {
$parcel$export(module.exports, "default", () => $5aa180a3daaf8a3f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2w7cu = parcelRequire("2w7cu");

var $iIPH8 = parcelRequire("iIPH8");

var $7OArX = parcelRequire("7OArX");

var $bm7hu = parcelRequire("bm7hu");

var $gAC1H = parcelRequire("gAC1H");
const $5aa180a3daaf8a3f$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $5aa180a3daaf8a3f$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $2w7cu.default), onMouseUp: providedOnMouseUp = (0, $2w7cu.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $iIPH8.useGlobalTheme)();
    const isOnlySingleIcon = (0, $gAC1H.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $eJOHy.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($5aa180a3daaf8a3f$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $eJOHy.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($5aa180a3daaf8a3f$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $eJOHy.useMemo)(()=>(0, $bm7hu.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7OArX.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        //  manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$5aa180a3daaf8a3f$var$Button.displayName = 'Button';
var $5aa180a3daaf8a3f$export$2e2bcd8739ae039 = $5aa180a3daaf8a3f$var$Button;

});

parcelRegister("lOfHp", function(module, exports) {
$parcel$export(module.exports, "default", () => $c397b62fb6eeff1b$export$2e2bcd8739ae039);
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GOss = parcelRequire("8GOss");

var $frkRf = parcelRequire("frkRf");

var $egx8e = parcelRequire("egx8e");
const $c397b62fb6eeff1b$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $c397b62fb6eeff1b$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $egx8e.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($c397b62fb6eeff1b$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $c397b62fb6eeff1b$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
const $c397b62fb6eeff1b$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $c397b62fb6eeff1b$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
const $c397b62fb6eeff1b$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $c397b62fb6eeff1b$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $c397b62fb6eeff1b$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $c397b62fb6eeff1b$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $8GOss.default)($c397b62fb6eeff1b$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $frkRf.useHasTextAncestor)();
    const color = $c397b62fb6eeff1b$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        className: (0, $hcewu.default)([
            $c397b62fb6eeff1b$var$styles.root,
            size && $c397b62fb6eeff1b$var$fontSizeMap[size],
            color && $c397b62fb6eeff1b$var$textColorMap[color],
            maxLines && $c397b62fb6eeff1b$var$styles.truncation,
            maxLines === 1 && $c397b62fb6eeff1b$var$styles.breakAll,
            align && $c397b62fb6eeff1b$var$styles[`textAlign.${align}`],
            weight && $c397b62fb6eeff1b$var$fontWeightMap[weight],
            Component === 'em' && $c397b62fb6eeff1b$var$styles['as.em'],
            Component === 'strong' && $c397b62fb6eeff1b$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $frkRf.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
var $c397b62fb6eeff1b$export$2e2bcd8739ae039 = $c397b62fb6eeff1b$var$Text;

});
parcelRegister("frkRf", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $4236cbd9d7bf6142$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $4236cbd9d7bf6142$export$ae933c6cbe5643ad);

var $eJOHy = parcelRequire("eJOHy");
const $4236cbd9d7bf6142$var$HasTextAncestorContext = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $4236cbd9d7bf6142$export$9322276ec105d055 = ()=>(0, $eJOHy.useContext)($4236cbd9d7bf6142$var$HasTextAncestorContext);
const $4236cbd9d7bf6142$export$ae933c6cbe5643ad = $4236cbd9d7bf6142$var$HasTextAncestorContext.Provider;

});


parcelRegister("dSGsi", function(module, exports) {
$parcel$export(module.exports, "default", () => $209a1c45e0a90b25$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
function $209a1c45e0a90b25$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $209a1c45e0a90b25$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $209a1c45e0a90b25$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $209a1c45e0a90b25$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("2z6Ra", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b25b3f8b40eee51$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3eWHA = parcelRequire("3eWHA");
const $2b25b3f8b40eee51$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $eJOHy.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3eWHA.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                    ...rest,
                    ref: ref
                })
            });
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $2b25b3f8b40eee51$export$2e2bcd8739ae039 = $2b25b3f8b40eee51$var$withAnalyticsContext;

});

parcelRegister("7T3Ui", function(module, exports) {
$parcel$export(module.exports, "default", () => $01d1e61b39d9c2f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dSGsi = parcelRequire("dSGsi");

var $9ioug = parcelRequire("9ioug");

var $jVDYl = parcelRequire("jVDYl");
var $lOfHp = parcelRequire("lOfHp");

var $6AidT = parcelRequire("6AidT");

var $12zkI = parcelRequire("12zkI");
var $aSiJ7 = parcelRequire("aSiJ7");
var $dU4XD = parcelRequire("dU4XD");
var $kWxvf = parcelRequire("kWxvf");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $01d1e61b39d9c2f3$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $12zkI.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dSGsi.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kWxvf.default), {
                children: isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6AidT.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aSiJ7.default), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dU4XD.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jVDYl.default), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ioug.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jVDYl.default), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lOfHp.default), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $01d1e61b39d9c2f3$export$2e2bcd8739ae039 = $01d1e61b39d9c2f3$var$EmptyState;

});
parcelRegister("12zkI", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea31084fe7ef7f1d$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ea31084fe7ef7f1d$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $ea31084fe7ef7f1d$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
var $ea31084fe7ef7f1d$export$2e2bcd8739ae039 = $ea31084fe7ef7f1d$var$ActionsContainer;

});

parcelRegister("aSiJ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $eac80a48d3610881$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $eac80a48d3610881$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $eac80a48d3610881$var$wideContainerStyles = null;
const $eac80a48d3610881$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $eac80a48d3610881$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
var $eac80a48d3610881$export$2e2bcd8739ae039 = $eac80a48d3610881$var$Container;

});

parcelRegister("dU4XD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed02457ab406a476$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ed02457ab406a476$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $ed02457ab406a476$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $ed02457ab406a476$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $ed02457ab406a476$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        style: {
            [$ed02457ab406a476$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$ed02457ab406a476$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $hcewu.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $ed02457ab406a476$export$2e2bcd8739ae039 = $ed02457ab406a476$var$Image;

});

parcelRegister("kWxvf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2edf7c9880f317cb$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $2edf7c9880f317cb$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $2edf7c9880f317cb$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
var $2edf7c9880f317cb$export$2e2bcd8739ae039 = $2edf7c9880f317cb$var$SpinnerContainer;

});


parcelRegister("6PqvT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4aa7a40228af0d5$export$2e2bcd8739ae039);
var $c4aa7a40228af0d5$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("4Ag5N", function(module, exports) {
$parcel$export(module.exports, "default", () => $52e1c60cf08d3ec5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eG73a = parcelRequire("eG73a");

var $bscf6 = parcelRequire("bscf6");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $52e1c60cf08d3ec5$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eG73a.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bscf6.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$52e1c60cf08d3ec5$var$LoadingButton.displayName = 'LoadingButton';
var $52e1c60cf08d3ec5$export$2e2bcd8739ae039 = $52e1c60cf08d3ec5$var$LoadingButton;

});

parcelRegister("1eghp", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $c83d694fa48af792$export$53c2b9c37c40e0d8);

var $eJOHy = parcelRequire("eJOHy");

var $iFaP4 = parcelRequire("iFaP4");

var $5YL9v = parcelRequire("5YL9v");
const $c83d694fa48af792$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const methodRef = (0, $5YL9v.useTrackedRef)(method);
    const payloadRef = (0, $5YL9v.useTrackedRef)(payload);
    return (0, $eJOHy.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("lxf4O", function(module, exports) {
$parcel$export(module.exports, "default", () => $be82fba950c4f9b7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $VunYa = parcelRequire("VunYa");
class $be82fba950c4f9b7$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data: data, children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError) {
            if (ErrorComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $VunYa.default), {
                data: data,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorComponent, {})
            });
            return null;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $VunYa.default), {
            data: data,
            children: children
        });
    }
}

});

parcelRegister("jwVfo", function(module, exports) {
$parcel$export(module.exports, "fontFallback", () => $0c76c9f7c6e446b2$export$2a99220fb32ec798);
/**
 * Font token fallbacks are verbose.
 * This object exists purely to make using fallbacks less cumbersome while we still need to use them.
 * Will be removed once fallbacks are no longer needed.
 *
 * This is referenced by the use-tokens-typography ESLint rule.
 */ const $0c76c9f7c6e446b2$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    }
};

});

const $758f26253b3d4f8b$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $758f26253b3d4f8b$export$f005e2e9f707cb5f = 'commercial';
const $758f26253b3d4f8b$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $758f26253b3d4f8b$export$a739cd5aac835909 = 'stg';
const $758f26253b3d4f8b$export$42dd0cdd351a4a9 = 'prod';
const $758f26253b3d4f8b$export$404582bc18fe4d9e = 'dev';

const $84d12136aa8dcfaf$export$42f4885608027d0c = 'non_boolean';

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$b2c0462ff17aa26e = 'BUSINESS_BOARD';
const $652f5f63189f3e2a$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

const $2105caca302b8178$export$f636b5b56f1d624a = 'Screen';
const $2105caca302b8178$export$9d2de6eebf7462b5 = 'Drawer';
const $2105caca302b8178$export$1171103ea9083ffa = 'Modal';
const $2105caca302b8178$export$cae2783c9279926 = 'InlineDialog';
const $2105caca302b8178$export$d1123261ca8831d2 = 'Dropdown';
const $2105caca302b8178$export$a1562d08625f5d7e = 'UI';
const $2105caca302b8178$export$947dac6c72b26f81 = 'TRACK';
const $2105caca302b8178$export$f1d537d508d2945a = 'SCREEN';
const $2105caca302b8178$export$12346a674644c156 = 'OPERATIONAL';
const $2105caca302b8178$export$2ceccf177fae277c = 'analyticsBridge';

const $3a6f6559ec260003$export$881d135f98d8d7d0 = 100;
const $3a6f6559ec260003$export$9ab5bdcb8a1d6c34 = false;
const $3a6f6559ec260003$export$f267d0e9ab3eb265 = false;
const $3a6f6559ec260003$export$12c1dc38ea1692da = 0;
const $3a6f6559ec260003$export$c6d9b82b8528dcc3 = false;

const $07c351e56f78ee75$export$cf090d5281b5ae06 = 10000;
const $07c351e56f78ee75$export$8575e30be0feb909 = 30000;

const $576a115f874e345f$export$3288b14b6745c572 = 204;
const $576a115f874e345f$export$c09e7ea0fc79f34f = 409;
const $576a115f874e345f$export$974c37534b0191b1 = 503;


$parcel$global.rlb("9zLwF")
//# sourceMappingURL=shared~vendor~atlaskit~ar.4c0b12a5.js.map
